import React, { Component, Fragment } from "react"
import leftArrowImage from "../../assets/images/left-arrow.png"
import "./css.css"
import {
  CustomerServices,
  DevelopmentServices,
  SampleServices,
  CostingServices,
  StyleServices,
  SystemServices
  // UtilityService
} from "../../services"
import Async from "react-select"
import Modal from "react-responsive-modal"
import externalLink from "../../assets/images/external-link.png"
import selectLink from "../../assets/images/select.png"
import { confirmAlert } from "react-confirm-alert"

//components
import PrintCosting from "./printCosting.js"
import Field from "../../components/Common/Field/Field"
import Audit from "../../components/Common/audit"
import Button from "../../components/Buttons/Button"
import FloatMenuList from "../../components/Costing/FloatMenuList"
import ButtonIcon from "../../components/Costing/Button/ButtonIcon"
import NumberField from "../../components/Costing/NumberField"
import ModuleHeader from "../../components/Costing/ModuleHeader"
import TotalCostRow from "../../components/Costing/TotalCostRow"
import Totalheader from "../../components/Costing/TotalHeader"
import Loading from "../../components/Common/Loading"
import moment from "moment"
import { connect } from 'react-redux';

const fabricTemplate = {
  fabricNumber: null,
  countAndConstruction: "",
  qualityClassification: "",
  supplierName: "",
  supplierSectionId: "",
  fabricPosition: null,
  size: "",
  width: "",
  consumption: "0.00",
  price: "0.00",
  totalCost: "0.00",
  fabricList: [],
  greige:"",
  valueLoss:null,
  EmbValueLoss:null,
  dyingPrint:null,
  gst:null,
  embCost:"",
  yardDyedCost:"",
  marker: null,
  printDirection: null
}

const trimTemplate = {
  trimCategory: null,
  trimRefNumber: null,
  description: "",
  quality: "",
  supplierName: "",
  size: "",
  sizeNumber: "",
  consumption: "0.00",
  price: "0.00",
  totalCost: "0.00",
  unit: "",
  trimList: []
}

let tempTrimPack, girlsTable

const smockingSheeringTemplate = {
  trimCategory: null,
  trimNumber: null,
  placement: null,
  number: null,
  type: null,
  noOfRow: null,
  length: null,
  totalReq: null,
  price: "0.00",
  totalCost: "0.00"
}

const embroideryTemplate = {
  embPlacement: null,
  embForm: null,
  noOfCols: null,
  frames: null,
  stitchesMtr: null,
  consumption: null,
  stitchCount: null,
  priceForStitches: "0.00",
  totalCost: "0.00"
}

const backingTemplate = {
  backingType: null,
  width: null,
  placement: null,
  consumption: null,
  price: "0.00",
  totalCost: "0.00"
}

const embellishmentTemplate = {
  embType: null,
  hoursMinutes: null,
  pricePerHalfHour: "0.00",
  totalCost: "0.00"
}

const washTemplate = {
  washType: null,
  washFrom: null,
  weight: null,
  laundryUnit: null,
  price: "0.00",
  totalCost: "0.00"
}

class Costing extends Component {
  state = {
    action: "",
    _id: "",
    disabled: false,
    isLoading: false,
    costing: {
      costingNumber: "",
      landedPrice: '0.00',
      agreedPrice: '0.00',
      agreedCurrency: null,
      currencyConversion:{
        eur:"",
        gbp:"",
        usd:""
      },
      orderDate: new Date(),
      styleReferenceId: null,
      customer: null,
      customerDepartmentId: null,
      magnumStyleId: null,
      magnumStyleName: "",
      customerRefNumber: "",
      sampleRequestId: null,
      costingType: null,
      shipmentTerm: null,
      shipMode: "",
      comments: null,
      fabric: [],
      trimPack: {
        trimPackNo: "",
        typeOfGmt: "",
        packagingMethod: "",
        packingType: "",
        subType: "",
        consumption: "",
        price: ""
      },
      trim: [],
      smockingSheering: [],
      embroidery: [],
      embroideryBacking: false,
      bitAttaching: false,
      tacking: false,
      backing: [],
      embellishment: [],
      wash: [],
      otherCostDetails: [],
      manufacturingAndPieceCostDetails: {
        orderQty: null,
        smv: null,
        revTailer: null,
        revMachine: null,
        sample: null,
        pattern: null,
        noOftailors: null,
        costPertailor: null,
        perMachine: null,
        minutesperDay: 480,
        setOffMinutes: 960,
        targetPcsAt: null,
        avgOutputNeeded: null,
        daysFortailorLine: null,
        idleDays: null,
        totalDays: null,
        smv80: null,
        smv100: null,
        sam: null,
        totalSmv: null
      },
      manufacturingAndPieceCost: {
        fixedCharge: '0.00',
        CMT: 0,
        valueLoss: 0, //percentage
        overHeads: 0, //percentage
        valueLossCost: 0,
        overHeadsCost: 0,
        totalCost: 0
      },

      //all modules total
      fabricTotalCost: 0,
      trimTotalCost: 0,
      trimPackTotalCost: 0,
      embroideryTotalCost: 0,
      backingTotalCost: 0,
      smockingSheeringTotalCost: 0,
      embelishmentTotalCost: 0,
      washTotalCost: 0,
      otherTotalCost: 0,
      manufacturingTotalCost: 0,

      costingTotal: 0,

      sampleType: "",
      toggle: {
        fabric: true,
        trim: true,
        embellishment: false, //false
        embroidery: false, //false
        smockingSheering: false, //false
        wash: true,
        girlsWearing: false //false
      },

      landedData: {
        toValue: null,
        rateValue: 0,
        freightChargesTotal: 0,
        dutyValue: 0,
        processValue: 0,
        totalLandedValue: 0
      },
      fromCurrencyConvertion: "usd",
      toCurrencyConversion: "usd",
      selectedConversion: "usd",
      selectedMenu: {
        name: null,
        value: null,
        date: null
      },
      girlsWearing: {
        grouping: []
      },
      usdTotal: 0,
      gbpTotal: 0,
      euroTotal: 0
    },
    usdTotal: 0,
    gbpTotal: 0,
    euroTotal: 0,
    girlswearData: [],
    fabricIndex: null,
    trimIndex: null,
    printLoading: false,
    minPerDay: 480,
    ratio: false,
    // createdOn: new Date(),
    netSale: false,
    smvDisplay: false,
    smv80: null,
    smv100: null,
    girlswear: false,
    showLandedCalc: false,
    selected: "usd",
    fabricSupplier: {
      _id: "",
      supplierName: ""
    },
    targetPiece80: 80,
    ratioCosting: [
      {
        sizes: 0,
        quantity: 0,
        unitPrice: 0,
        amt: 0
      }
    ],
    idleDays: 2,
    embelishment: false,
    tacking: false,
    styleInfo: [],
    modalToggle: false,
    costingId: "",
    customerList: [],
    moduleList: [
      "fabric",
      "trim",
      "smockingshirring",
      "embroidery",
      "embelishment",
      "wash",
      "manufacturing"
    ],
    //list populate
    sampleRequestNumbersList: [],
    costingTypeList: [],
    shipModeList: [],
    shipmentTermList: [],
    positionList: [],
    laundryUnitList: [],
    priceperkgList: [],
    washTypeList: [],
    placementList: [],
    embTypeList: [],
    backingTypeList: [],
    embPlacementList: [],
    noOfColorList: [],
    framesList: [],
    embFormList: [],
    trimCategoryList: [],
    trimPlacementList: [],
    units: "",
    supplierSectionList: [],
    selectSmv: [],
    smvList: [],
    patternList: [],
    sampleList: [],
    currencies: {},
    dyingPrint:{},
    valueLoss:{},
    //valueLossSearch:{},
    upCharge:{},
    gst:"",
    // others: {},
    trimPackList: [],
    fabricSizeList: [],
    goBack: -1,
    styleNoInfo: []
  }

  componentWillUnmount() {
    if (this.state.action === "add") {
      window.removeEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }
  }

  async componentWillMount() {
    let { action, _id, sampleRequestId, goBack } = this.props.location.state
    if (action === "edit" && goBack) {
      this.setState({
        action: action,
        _id: _id,
        goBack: this.state.goBack - 1
      })
    }
    if (sampleRequestId !== "") {
      let costing = { ...this.state.costing }
      costing.sampleRequestId = this.props.location.state.sampleRequestId
      this.setState({
        costing
      })
    }
    this.setState({
      action,
      _id
    })

    if (action === "add" && sampleRequestId) {
      this.changeSampleNo(sampleRequestId)
    }

    if (action == "view") {
      this.setState({
        disabled: true
      })
    }
    if (action == "edit" || action == "view") {
      this.setState({ isLoading: true })
      if (_id) {
        CostingServices.getCostingInfo(_id).then(response => {
          if (response.status === 200) {
            let costing = this.state.costing
            costing = response.text.data
            let sampleRequestNumbersList = costing.sampleRequestId && [{
              label: costing.sampleRequestId.requestNumber,
              value: costing.sampleRequestId._id
            }] || []
            costing.sampleRequestId = costing.sampleRequestId && costing.sampleRequestId._id || null
            if (!sampleRequestNumbersList.length) {
              this.getSampleRqNo('')
            }
            if (!costing.girlsWearing) {
              costing.girlsWearing = { grouping: [] }
            }
            setTimeout(() => {
              this.setState(
                {
                  sampleRequestNumbersList,
                  costing
                },
                () => {
                  this.getTrimPack(costing.customer, costing.customerDepartmentId)
                  this.getSMVList(costing.styleReferenceId.value)
                  if (costing.customer && costing.customer._id) {
                    this._handleCustDeptChange(
                      null,
                      costing.customer._id,
                      costing.customerDepartmentId
                    )
                  }
                  //this.currencyConversion();
                  // this.calConsumPrice()
                  this.setState({ isLoading: false })
                }
              )
            }, 1000)
            this.convertoFixed2(costing)
          }
        }).catch(error => this.props.getalertMessage("error", error.toString()))
      } else if (sampleRequestId) {
        this.changeSampleNo(sampleRequestId)
      }
    }

    SampleServices.prefillSRDetails()
      .then(response => {
        if (response.message === "Operation Successful") {
          this.setState({
            positionList: response.data.SAMPLEREQUEST.POSITION,
            laundryUnitList: response.data.WASH.LAUNDRYUNIT,
            priceperkgList: response.data.WASH.PRICEPERKG.map(x => ({
              label: x.label,
              value: x.label
            })),
            patternList: response.data.SAMPLEREQUEST.SAMPLETYPE,
            sampleList: response.data.SAMPLEREQUEST.SAMPLETYPE,
            washTypeList: response.data.WASH.WASHTYPE,
            embTypeList: response.data.SAMPLEREQUEST.TYPE,
            backingTypeList: response.data.SYSTEMSAMPLEREQUEST.BACKINGTYPE,
            placementList: response.data.SAMPLEREQUEST.PLACEMENT,
            embPlacementList: response.data.SAMPLEREQUEST.PLACEMENT_EMB,
            noOfColorList: response.data.SAMPLEREQUEST.NOOFCOLORS,
            framesList: response.data.SAMPLEREQUEST.FRAMES,
            trimCategoryList: response.data.TRIM.TRIMCATEGORY,
            trimPlacementList: response.data.TRIMPLACEMENT,
            embFormList: response.data.SAMPLEREQUEST.EMBFORM,
            SHIRRINGORSMOCKING: response.data.SAMPLEREQUEST.SHIRRINGORSMOCKING
          })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
    this.getCustomerList()

    this.getCostingSystem()
    this.getSampleRqNo("")
    this.getMagnumStyleNo("")
  }

  convertoFixed2 = (costing) => {
    let inputs = ['consumption', 'price', 'pricePerHalfHour', 'weight']
    let arr = Object.keys(costing)
    arr.forEach((key) => {
      if (typeof costing[key] === 'object' && Array.isArray(costing[key])) {
        costing[key].map((x) => {
          Object.keys(x).forEach((k) => {
            if (inputs.includes(k)) {
              x[k] = Number(x[k]).toFixed(2)
            }
          })
        })
      }
    })
    if (costing.manufacturingAndPieceCost && costing.manufacturingAndPieceCost.fixedCharge)
      costing.manufacturingAndPieceCost.fixedCharge = Number(costing.manufacturingAndPieceCost.fixedCharge).toFixed(2)

    this.setState({ costing })
  }

  getCostingNumber = () => {
    CostingServices.costingNumber()
      .then(response => {
        if (response.status == 200) {
          let costing = this.state.costing
          costing.costingNumber = response.text.data.costingNumber
          this.setState({
            costing
          })
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  componentDidMount() {
    let { action } = this.props.location.state
    if (action === "add") {
      this.getCostingNumber()
      //console.log(this.state.action,"add")
       // Initialize the fabric array with default gst values
      //  this.setState(prevState => ({
      //   gst: prevState.gst || "", // Ensure global GST is set
      //   costing: {
      //     ...prevState.costing,
      //     fabric: (prevState.costing.fabric || []).map(item => ({
      //       ...item,
      //       gst: item.gst !== null ? item.gst : prevState.gst || "" // Use item.gst if not null, else fallback to global gst
      //     }))
      //   }
      // }));
    }

    if (this.state.action == "add") {
      window.addEventListener("beforeunload", function (event) {
        event.returnValue = "Hellooww"
      })
    }

    if (this.props.history.location.state) {
      if (this.props.history.location.state.costingpage) {
        this.setState({
          ...this.props.history.location.state.costingpage
        })
      }
    }

  }

  getCostingSystem = () => {
    CostingServices.getCostingSystem()
      .then(async response => {
        if (response.status == 200) {
          let costing = this.state.costing
          let showLandedCalc = false
          if (!costing.manufacturingAndPieceCostDetails.perMachine || costing.manufacturingAndPieceCostDetails.perMachine === "")
            costing.manufacturingAndPieceCostDetails.perMachine =
              response.text.data.OTHERS.perMachine
          if (!costing.manufacturingAndPieceCostDetails.costPertailor || costing.manufacturingAndPieceCostDetails.costPertailor === "")
            costing.manufacturingAndPieceCostDetails.costPertailor =
              response.text.data.OTHERS.costPertailor
          if (!costing.manufacturingAndPieceCostDetails.noOftailors || costing.manufacturingAndPieceCostDetails.noOftailors === "")
            costing.manufacturingAndPieceCostDetails.noOftailors =
              response.text.data.OTHERS.noOftailors
          if (!costing.manufacturingAndPieceCostDetails.orderQty || costing.manufacturingAndPieceCostDetails.orderQty === "")
            costing.manufacturingAndPieceCostDetails.orderQty =
              response.text.data.OTHERS.orderQty
          if (!costing.manufacturingAndPieceCost.valueLoss || costing.manufacturingAndPieceCost.valueLoss === "")
            costing.manufacturingAndPieceCost.valueLoss =
              response.text.data.OTHERS.valueLoss
          if (!costing.manufacturingAndPieceCost.overHeads || costing.manufacturingAndPieceCost.overHeads === "")
            costing.manufacturingAndPieceCost.overHeads =
              response.text.data.OTHERS.overHeads
          if (!costing.manufacturingAndPieceCostDetails.idleDays || costing.manufacturingAndPieceCostDetails.idleDays === "")
            costing.manufacturingAndPieceCostDetails.idleDays =
              response.text.data.OTHERS.idleDays

          // ------*****************----------------------
          if (!costing.landedData.conversionRate || costing.landedData.conversionRate === "")
            costing.landedData.conversionRate = response.text.data.OTHERS.conversionRate
          // costing.landedData.conversionRate =
          //   response.text.data.OTHERS.conversionRate
          if (!costing.landedData.freightCharges || costing.landedData.freightCharges === "")
            costing.landedData.freightCharges = response.text.data.OTHERS.freightCharges
          // costing.landedData.freightCharges =
          //   response.text.data.OTHERS.freightCharges
          if (!costing.landedData.duty || costing.landedData.duty === "")
            costing.landedData.duty = response.text.data.OTHERS.duty
          // costing.landedData.duty = response.text.data.OTHERS.duty
          // costing.landedData.processingCost =
          //   response.text.data.OTHERS.processingCost
          if (!costing.landedData.processingCost || costing.landedData.processingCost === "")
            costing.landedData.processingCost = response.text.data.OTHERS.processingCost
          if (costing.landedData.totalLandedValue) {
            showLandedCalc = true
          }
          this.setState({
            // showLandedCalc,
            costing,
            costingTypeList: response.text.data.COSTINGTYPE,
            shipModeList: response.text.data.SHIPMENTMODE,
            shipmentTermList: response.text.data.SHIPMENTTERM,
            units: response.text.data.UNITS,
            // selectSmv: response.text.data.SELECTSMV,
            smvList: response.text.data.SMV,
            // patternList: response.text.data.PATTERN,
            // sampleList: response.text.data.SAMPLE,
            currencies: response.text.data.CURRENCY_CONVERSION,
            costing: {
              ...this.state.costing,
              currencyConversion: {
                usd: response.text.data.CURRENCY_CONVERSION.usd || '',
                gbp: response.text.data.CURRENCY_CONVERSION.gbp || '',
                eur: response.text.data.CURRENCY_CONVERSION.eur || ''
              },
            },
            dyingPrint:response.text.data['DYING/PRINT'],
            valueLoss:response.text.data.VALUELOSS,
            upCharge:response.text.data.UPCHARGE,
            gst:response.text.data.GST.gst,
            markerList: response.text.data.MARKER,
            printDirectionList: response.text.data.PRINTDIRECTION
          }, () => {
            if (this.state.action === "edit") {
              setTimeout(() => {
                this.convertOthers()
              }, 500)
            }

          })
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getSampleReqNoListById = _id => {
    SampleServices.getSampleRequestListById(_id)
      .then(response => {
        if (response.status == 200) {
          this.setState({
            sampleRequestNumbersList: response.text.data
          })
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  getCustomerList = () => {
    CustomerServices.customerInfo()
      .then(response => {
        if (response.status === 200) {
          this.setState({
            customerList: response.text.data
          })
        }
      })
      .catch(error => { })
  }

  getMagnumStyleNo = value => {
    DevelopmentServices.getMagnumStyleNoWithReference(value)
      .then(response => {
        if (response.status === 200) {
          let jsonData = []
          response.text.data.map((info, index) => {
            let objData = {}
            objData.label = info.referenceCode
            objData.value = info.referenceId
            jsonData.push(objData)
          })
          this.setState({ styleNoInfo: jsonData })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  changeStyleNo = styleInfo => {
    let costing = this.state.costing
    costing.styleReferenceId = null
    if (styleInfo && styleInfo.value) {
      costing.styleReferenceId = styleInfo.value
    }

    this.setState({ styleInfo })
    if (styleInfo !== null) {
      this.setState({ isLoading: true })
      StyleServices.getStyleInfoByReference(styleInfo.value)
        .then(response => {
          this.setState({
            samAsync: !this.state.samAsync
          })
          if (response.text.message === "Sample Request Data") {
            if (response.text.data.sampleRequest.length == 0) {
              this.props.getalertMessage(
                "info",
                "This style ref no does'nt have Requests"
              )
            }
            costing.customerName = `${response.text.data.customerName}-${response.text.data.departmentName}`
            costing.customer = response.text.data.customer
            costing.customerDepartmentId =
              response.text.data.customerDepartmentId
            costing.magnumStyleId = response.text.data.magnumStyleId
            costing.magnumStyleName = response.text.data.magnumStyleName
            costing.customerRefNumber = response.text.data.customerRefNumber
            costing.manufacturingAndPieceCost.fixedCharge = response.text.data.fixedCharge
            this.setState({
              sampleRequestNumbersList: response.text.data.sampleRequest,
              costing
            }, () => {
              this._handleCustDeptChange(
                null,
                costing.customer,
                costing.customerDepartmentId
              )
              setTimeout(() => {
                this.calConsumPrice()
                this.updateCostTotal()
                this.landedCalc("shipmentTerm", costing.landedData.toValue)
                this.setState({ isLoading: false })
              }, 500)
            })
          }
        })
        .catch(error => {
          alert("Something Went Wrong...Try Again Later")
        })
    }
  }

  getSampleRqNo = value => {
    SampleServices.getSampleReqNo(value)
      .then(response => {
        if (response.status === 200) {
          this.setState({ sampleRequestNumbersList: response.text.data })
        }
        response.status == 401 && this.props.unauthorisedFunc()
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  changeSampleNo = sampleNo => {
    if (sampleNo !== null) {
      sampleNo = typeof sampleNo == "object" ? sampleNo.value : sampleNo
      this.setState({ isLoading: true })
      CostingServices.getSampleRequestInfo(sampleNo)
        .then(async response => {
          if (response.status === 200) {
            let costing = { ...this.state.costing }
            costing.sampleRequestId = sampleNo
            costing.customerName = response.text.data.customerName
            costing.customer = response.text.data.customer
            costing.customerDepartmentId =
              response.text.data.customerDepartmentId
            costing.magnumStyleId = response.text.data.magnumStyleId
            costing.styleReferenceId = response.text.data.styleReferenceId
            costing.magnumStyleName = response.text.data.magnumStyleName
            costing.customerRefNumber = response.text.data.customerRefNumber
            costing.fabric = response.text.data.fabric
            costing.trim = response.text.data.trim
            costing.smockingSheering = response.text.data.smockingSheering
            costing.embroidery = response.text.data.embroidery
            costing.backing = response.text.data.backing
            costing.bitAttaching = response.text.data.bitAttaching
            costing.embellishment = response.text.data.embellishment
            costing.wash = response.text.data.wash
            costing.tacking = response.text.data.tacking
            costing.embroideryBacking = response.text.data.embroideryBacking
            costing.sampleType = response.text.data.sampleType
            costing.manufacturingAndPieceCost.fixedCharge = response.text.data.fixedCharge
            costing.toggle = {
              ...costing.toggle,
              fabric: response.text.data.fabric.length && true || false,
              trim: response.text.data.trim.length && true || false,
              embellishment: response.text.data.embellishment.length && true || false,
              embroidery: response.text.data.embroidery.length && true || false,
              smockingSheering: response.text.data.smockingSheering.length && true || false,
              wash: response.text.data.wash.length && true || false,
            }
            // costing.fabric = [1]
            this.setState(
              {
                costing
              },
              () => {
                // this.getTrimPack(costing.customer, costing.customerDepartmentId)
                this.getSampleReqNoListById(costing.sampleRequestId)
                this.getSMVList(costing.styleReferenceId)
                this._handleCustDeptChange(
                  null,
                  costing.customer,
                  costing.customerDepartmentId
                )
                this.calConsumPrice()
                setTimeout(() => {
                  this.updateCostTotal()
                  this.setState({ isLoading: false })
                  if (costing.smockingSheering && costing.smockingSheering.length) {
                    costing.smockingSheering.forEach((x, index) => {
                      this.updateSmockingSheering(null, null, index)
                    })
                  }
                }, 4000)
              }
            )
          } else {
            this.setState({ isLoading: false })
            this.props.getalertMessage("error", response.text.message, 9000)
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      let costing = { ...this.state.costing }
      costing.sampleRequestId = null
      costing.styleReferenceId = null
      costing.customer = null
      costing.customerDepartmentId = null
      costing.magnumStyleId = null
      this.setState({
        costing
      })
    }
  }

  costingPrintData = (data, type) => {
    const Toggles = { ...this.state.costing.toggle }
    const showLandedCalc = this.state.showLandedCalc
    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        key: this.state.costing.costingNumber,
        // costingType : this.state.costing.costingType,
        costingType: document.getElementsByName('costingType')[0].selectedOptions[0].innerHTML,
        Toggles,
        showLandedCalc
      }
    })
    let costingPrint = { ...this.state.costingPrint }
    const { name, value, listToMap } = data
    switch (type) {
      case "single":
        costingPrint[name] = value
        this.setState({
          costingPrint
        })
        break
      case "list":
        if (listToMap === "costingTypeList") {
          const costingType =
            this.state.costingTypeList.length > 0 &&
            this.state.costingTypeList
              .map(data => {
                if (data.value === value) {
                  return data.label
                }
              })
              .filter(Boolean)[0]

          this.setState({
            costingPrint: {
              ...this.state.costingPrint,
              costingType
            }
          })
        } else if (listToMap === "customerList") {
          let customerName
          let departmentName
          if (name === "customerName") {
            customerName =
              this.state.customerList.length > 0 &&
              this.state.customerList
                .map(data => {
                  if (data._id === value) {
                    return data.customerName
                  }
                })
                .filter(Boolean)[0]

            this.setState({
              costingPrint: {
                ...this.state.costingPrint,
                customerName
              }
            })
          } else if (name === "departmentName") {
            departmentName =
              this.state.customerList.length > 0 &&
              this.state.customerList
                .map(data => {
                  if (data.departmentId === value) {
                    return data.departmentName
                  }
                })
                .filter(Boolean)[0]

            this.setState({
              costingPrint: {
                ...this.state.costingPrint,
                departmentName
              }
            })
          }
        } else if (listToMap === "sampleRequestNumbersList") {
          let sampleRequestId = value && this.state.sampleRequestNumbersList.length > 0 &&
            this.state.sampleRequestNumbersList.find(data => data.value === value).label || ""

          this.setState({
            costingPrint: {
              ...this.state.costingPrint,
              sampleRequestId
            }
          })
        } else if (listToMap === "styleNoInfo") {
          let styNo = value && this.state.styleNoInfo.find(data => data.value === value) || null
          let styleReferenceId =
            this.state.styleNoInfo.length > 0 && styNo
            && styNo.label || (this.state.costing.styleReferenceId && this.state.costing.styleReferenceId.label) || ""

          this.setState({
            costingPrint: {
              ...this.state.costingPrint,
              styleReferenceId
            }
          })
        }
    }
  }

 costingPrintFabricData = () => {
  const Fabric = {
    FabricArrayData: [],
    totalCost: 0
  }

  this.state.costing.fabric &&
    this.state.costing.fabric.length > 0 &&
    this.state.costing.fabric.forEach((fabric, index) => {
      let fabricArray = {}

      if (fabric.fabricNumber && fabric.fabricList && fabric.fabricList.length)
        fabricArray.fabricNumber = fabric.fabricList.find(data => data.value === fabric.fabricNumber).label
      if (fabric.fabricPosition && this.state.positionList && this.state.positionList.length)
        fabricArray.fabricPosition = this.state.positionList.find(data => data.value === fabric.fabricPosition).label
      if (fabric.size)
        fabricArray.fabricSize = fabric.size
      if (fabric.printDirection && this.state.printDirectionList && this.state.printDirectionList.length)
        fabricArray.printDirection = this.state.printDirectionList.find(data => data.value === fabric.printDirection).label
      if (fabric.marker && this.state.markerList && this.state.markerList.length)
        fabricArray.marker = this.state.markerList.find(data => data.value === fabric.marker).label
      if(fabric.valueLoss && this.state.valueLoss && this.state.valueLoss.length){
        fabricArray.valueLoss = this.state.valueLoss.find(data => data.value === fabric.valueLoss).label
      }
      if(fabric.EmbValueLoss && this.state.valueLoss && this.state.valueLoss.length){
        fabricArray.EmbValueLoss = this.state.valueLoss.find(data => data.value === fabric.EmbValueLoss).label
      }
      if(fabric.dyingPrint && this.state.dyingPrint && this.state.dyingPrint.length){
        fabricArray.dyingPrint = this.state.dyingPrint.find(data => data.value === fabric.dyingPrint).label
      }
      if(fabric.yardDyedCost && this.state.yardDyedCost && this.state.yardDyedCost.length){
        fabricArray.yardDyedCost = this.state.yardDyedCost.find(data => data.value === fabric.yardDyedCost).label
      }
      if(fabric.upcharge && this.state.upCharge && this.state.upCharge.length){
        fabricArray.upCharge = this.state.upCharge.find(data => data.value === fabric.upcharge).label
      }
      
      fabricArray.countAndConstruction = fabric.countAndConstruction
      fabricArray.qualityClassification = fabric.qualityClassification
      fabricArray.supplierName = fabric.supplierName
      fabricArray.width = fabric.width
      fabricArray.consumption = fabric.consumption
      fabricArray.price = fabric.price
      fabricArray.emb = fabric.emb
      fabricArray.greigeset = fabric.greigeset
      fabricArray.yarn = fabric.yarn
      fabricArray.embCost = fabric.embCost
      fabricArray.greige = fabric.greige
      fabricArray.gst = fabric.gst
      fabricArray.defaultGst = this.state.gst
      fabricArray.yardDyedCost = fabric.yardDyedCost  // Add this line to capture the yardDyedCost value
      fabricArray.totalCost = fabric.totalCost
        ? Number(fabric.totalCost).toFixed(2)
        : 0.0

      Fabric.FabricArrayData.push(fabricArray)
    })

  Fabric.totalCost = Number(this.state.costing.fabricTotalCost).toFixed(2)
    
  this.setState({
    costingPrint: {
      ...this.state.costingPrint,
      Fabric
    }
  })
}
  costingPrintTrimData = () => {
    let TrimObject = {
      trimPack: {},
      trimArrayData: [],
      totalCost: 0
    }
    let costing = { ...this.state.costing }
    // Trim Pack
    TrimObject.trimPack.trimPackNo = costing.trimPack
      ? costing.trimPack.trimPackNo
      : null
    TrimObject.trimPack.typeOfGmt = costing.trimPack
      ? costing.trimPack.typeOfGmt
      : null
    TrimObject.trimPack.packagingMethod = costing.trimPack
      ? costing.trimPack.packagingMethod
      : null
    TrimObject.trimPack.packingType = costing.trimPack
      ? costing.trimPack.packingType
      : null
    TrimObject.trimPack.subType = costing.trimPack
      ? costing.trimPack.subType
      : null
    TrimObject.trimPack.consumption = costing.trimPack
      ? costing.trimPack.consumption
      : null
    TrimObject.trimPack.price = costing.trimPack ? costing.trimPack.price : null
    TrimObject.trimPack.trimPackTotalCost = costing.trimPackTotalCost
      ? costing.trimPackTotalCost
      : null

    // trim Array
    this.state.costing.trim &&
      this.state.costing.trim.length > 0 &&
      this.state.costing.trim.forEach((trim, index) => {
        let trimArray = {}
        if (trim.trimCategory && this.state.trimCategoryList && this.state.trimCategoryList)
          trimArray.trimCategory = this.state.trimCategoryList.find(data => data.value === trim.trimCategory).label
        if (trim.trimNumber && this.state.costing.trim[index].trimList && this.state.costing.trim[index].trimList.length)
          trimArray.trimNumber = this.state.costing.trim[index].trimList.find(data => data.value === trim.trimNumber).label

        trimArray.description = trim.description
        trimArray.quality = trim.quality
        trimArray.supplierName = trim.supplierName
        trimArray.size = trim.size
        trimArray.consumption = trim.consumption
        trimArray.price = trim.price
        trimArray.totalCost = trim.totalCost
          ? Number(trim.totalCost).toFixed(2)
          : 0.0
        TrimObject.trimArrayData.push(trimArray)
      })

    TrimObject.totalCost = this.state.costing.trimTotalCost

    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        TrimObject
      }
    })
  }

  costingPrintSmockingData = () => {
    let SmockingShirring = {
      smockingShirringArray: []
    }

    this.state.costing.smockingSheering &&
      this.state.costing.smockingSheering.length > 0 &&
      this.state.costing.smockingSheering.forEach((smock, index) => {
        let smocking = {}

        smocking.trimCategory =
          this.state.trimCategoryList &&
          this.state.trimCategoryList.length > 0 &&
          this.state.trimCategoryList
            .map(data => {
              if (data.value === smock.trimCategory) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        smocking.trimNumber =
          this.state.costing.smockingSheering[index].trimList &&
          this.state.costing.smockingSheering[index].trimList.length > 0 &&
          this.state.costing.smockingSheering[index].trimList
            .map(data => {
              if (data.value === smock.trimNumber) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        smocking.placement =
          this.state.trimPlacementList &&
          this.state.trimPlacementList.length > 0 &&
          this.state.trimPlacementList
            .map(data => {
              if (data.value === smock.placement) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        smocking.type = smock.type
        smocking.noOfRow = smock.noOfRow
        smocking.length = smock.length
        smocking.totalReq = smock.totalReq
        smocking.price = smock.price
        smocking.totalCost = smock.totalCost

        SmockingShirring.smockingShirringArray.push(smocking)
      })

    SmockingShirring.totalCost = this.state.costing.smockingSheeringTotalCost
    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        SmockingShirring
      }
    })
  }
  costingPrintEmbroideryData = () => {
    let Embroidery = {
      EmbroideryArray: [],
      embroideryBacking: this.state.costing.embroideryBacking,
      bitAttaching: this.state.costing.bitAttaching,
      embroideryTotalCost: this.state.costing.embroideryTotalCost,
      BackingArray: []
    }

    this.state.costing.embroidery &&
      this.state.costing.embroidery.length > 0 &&
      this.state.costing.embroidery.forEach((embroideryData, index) => {
        let embroidery = {}
        if (embroideryData.embPlacement && this.state.embPlacementList && this.state.embPlacementList.length)
          embroidery.embPlacement = this.state.embPlacementList.find(data => data.value === embroideryData.embPlacement).label
        if (embroideryData.embForm && this.state.embFormList && this.state.embFormList.length)
          embroidery.embForm = this.state.embFormList.find(data => data.value === embroideryData.embForm).label
        if (embroideryData.noOfCols && this.state.noOfColorList && this.state.noOfColorList.length)
          embroidery.noOfCols = this.state.noOfColorList.find(data => data.value === embroideryData.noOfCols).label
        if (embroideryData.frames && this.state.framesList && this.state.framesList.length)
          embroidery.frames = this.state.framesList.find(data => data.value === embroideryData.frames).label

        embroidery.stitchesMtr = embroideryData.stitchesMtr
        embroidery.consumption = embroideryData.consumption
        embroidery.stitchCount = embroideryData.stitchCount
        embroidery.priceForStitches = embroideryData.priceForStitches
        embroidery.totalCost = embroideryData.totalCost

        Embroidery.EmbroideryArray.push(embroidery)
      })
    if (this.state.costing.embroideryBacking)
      this.state.costing.backing &&
        this.state.costing.backing.length > 0 &&
        this.state.costing.backing.forEach((back, Index) => {
          let backingData = {}
          if (back.backingType)
            backingData.backingType =
              this.state.backingTypeList &&
              this.state.backingTypeList.length > 0 &&
              this.state.backingTypeList
                .find((data, index) => data.value === back.backingType).label
          if (back.placement)
            backingData.placement =
              this.state.embPlacementList &&
              this.state.embPlacementList.length &&
              this.state.embPlacementList.find((data, index) => data.value === back.placement).label

          backingData.width = back.width
          backingData.consumption = back.consumption
          backingData.price = back.price
          backingData.totalCost = back.totalCost

          Embroidery.BackingArray.push(backingData)
        })

    Embroidery.backingTotalCost = this.state.costing.backingTotalCost

    Embroidery.totalCost = this.state.costing.embroideryTotalCost

    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        Embroidery
      }
    })
  }

  costingPrintEmbellishmentData = () => {
    const Embellishment = {
      totalCost: this.state.costing.embelishmentTotalCost,
      embellishmentArray: []
    }

    if (!!this.state.costing.embellishment) {
      this.state.costing.embellishment.forEach((emb, index) => {
        const embellishment = {}

        embellishment.embType =
          this.state.embTypeList &&
          this.state.embTypeList.length > 0 &&
          this.state.embTypeList
            .map(data => {
              if (data.value === emb.embType) {
                return data.label
              }
            })
            .filter(Boolean)[0]
        embellishment.hoursMinutes = emb.hoursMinutes
        embellishment.pricePerHalfHour = emb.pricePerHalfHour
        embellishment.totalCost = emb.totalCost

        Embellishment.embellishmentArray.push(embellishment)
      })
    }

    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        Embellishment
      }
    })
  }

  costingPrintWashData = () => {
    const Wash = {
      washCost: this.state.costing.washTotalCost,
      washArray: [],
      washTacking: this.state.costing.tacking
    }

    if (!!this.state.costing.wash) {
      this.state.costing.wash.forEach((washData, index) => {
        const wash = {}

        wash.washType =
          this.state.washTypeList &&
          this.state.washTypeList.length > 0 &&
          this.state.washTypeList
            .map(data => {
              if (data.value === washData.washType) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        wash.laundryUnit =
          this.state.laundryUnitList &&
          this.state.laundryUnitList.length > 0 &&
          this.state.laundryUnitList
            .map(data => {
              if (data.value === washData.laundryUnit) {
                return data.label
              }
            })
            .filter(Boolean)[0]

        wash.weight = washData.weight
        wash.price = washData.price
        wash.totalCost = washData.totalCost
        Wash.washArray.push(wash)
      })
    }

    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        Wash
      }
    })
  }

  costingPrintOtherChargesData = () => {
    const OtherCharges = {
      otherTotalCost: this.state.costing.otherTotalCost,
      otherChargesArray: []
    }

    this.state.costing.otherCostDetails.map((otherChargeData, index) => {
      const otherCharge = {}

      otherCharge.label = otherChargeData.label
      otherCharge.value = otherChargeData.value

      OtherCharges.otherChargesArray.push(otherCharge)
    })

    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        OtherCharges
      }
    })
  }

  // currencyConversion = () => {
  //   let { usd, gbp, eur } = this.state.currencies; // Extract updated currency values from state
  //   // Convert values to numbers
  // usd = Number(usd);
  // gbp = Number(gbp);
  // eur = Number(eur);
  //   console.log(usd, gbp, eur);
  //   console.log(this.state._id,"idd")
  
  //   SystemServices.currencyConversion(
  //     "COSTING",
  //     "CURRENCY_CONVERSION",
  //     usd, // Use updated USD
  //     gbp, // Use updated GBP
  //     eur, // Use updated EUR
      
  //   )
  //     .then(response => {
  //       if (response.status === 200) {
  //         this.props.getalertMessage("success", response.text.message);
  //       }
  //     })
  //     .catch(error => this.props.getalertMessage(error.toString()));
  // };
  

  costingPrintManufacturingData = () => {
    const Manufacturing = {
      ManufacturingArray: [],
      fixedCharge: this.state.costing.manufacturingAndPieceCost.fixedCharge
    }
    const manufacturingAndPieceCostDetails = {
      ...this.state.costing.manufacturingAndPieceCostDetails
    }
    const manufacturingAndPieceCost = {
      ...this.state.costing.manufacturingAndPieceCost
    }

    Manufacturing.smv =
      this.state.selectSmv &&
      this.state.selectSmv.length > 0 &&
      this.state.selectSmv
        .map(data => {
          if (data.value === manufacturingAndPieceCostDetails.smv) {
            return data.label
          }
        })
        .filter(Boolean)[0]

    Manufacturing.orderQty = manufacturingAndPieceCostDetails.orderQty
    Manufacturing.smv80 = manufacturingAndPieceCostDetails.smv80
    Manufacturing.perMachine = manufacturingAndPieceCostDetails.perMachine
    Manufacturing.smv100 = manufacturingAndPieceCostDetails.smv100
    Manufacturing.revTailer = manufacturingAndPieceCostDetails.revTailer
    Manufacturing.revMachine = manufacturingAndPieceCostDetails.revMachine
    Manufacturing.CMT = manufacturingAndPieceCost.CMT
    Manufacturing.CMTSelected = manufacturingAndPieceCost.CMT === Manufacturing.revTailer ? 2800 : manufacturingAndPieceCost.CMT === Manufacturing.revMachine ? 1750 : ""
    Manufacturing.totalCost = manufacturingAndPieceCost.totalCost
    Manufacturing.selectedMenu = {
      name: this.state.costing.selectedMenu.name,
      value: this.state.costing.selectedMenu.value && this.state.sampleList.find(x => x.value === this.state.costing.selectedMenu.value).label || null,
      data: this.state.costing.selectedMenu.date
    }
    Manufacturing.others = {
      valueLoss: {
        value: this.state.costing.manufacturingAndPieceCost.valueLoss,
        total: this.state.costing.manufacturingAndPieceCost.valueLossCost
      },
      overHeads: {
        value: this.state.costing.manufacturingAndPieceCost.overHeads,
        total: this.state.costing.manufacturingAndPieceCost.overHeadsCost
      }
    }
    Manufacturing.costingTotal = this.state.costing.costingTotal
    Manufacturing.currencies = {
      usd: {
        value: this.state.currencies.usd,
        total: this.state.costing.usdTotal
      },
      gbp: {
        value: this.state.currencies.gbp,
        total: this.state.costing.gbpTotal
      },
      eur: {
        value: this.state.currencies.eur,
        total: this.state.costing.euroTotal
      }
    }

    Manufacturing.shipment = {
      shipmentTerm: this.state.costing.shipmentTerm,
      shipmentMode: null
    }

    Manufacturing.shipment.shipmentMode =
      this.state.shipModeList &&
      this.state.shipModeList.length > 0 &&
      this.state.shipModeList
        .map((data, index) => {
          if (data.value === this.state.costing.shipMode) {
            return data.label
          }
        })
        .filter(Boolean)[0]

    Manufacturing.landedPrice = this.state.costing.landedData.totalLandedValue && Number(this.state.costing.landedData.totalLandedValue).toFixed(2)
    Manufacturing.agreedPrice = this.state.costing.agreedPrice && Number(this.state.costing.agreedPrice).toFixed(2)
    Manufacturing.agreedCurrency = this.state.costing.agreedCurrency
    Manufacturing.fromCurrencyConvertion =
      this.state.costing.fromCurrencyConvertion || "USD"
    Manufacturing.toCurrencyConvertion = this.state.costing.toCurrencyConversion.toUpperCase()
    Manufacturing.conversionTotal = this.state.costing.landedPrice

    Manufacturing.coversionRate = Number(
      this.state.costing.landedData.conversionRate
    )
    Manufacturing.rateValue = this.state.costing.landedData.rateValue
    Manufacturing.freightCharges = this.state.costing.landedData.freightCharges
    Manufacturing.freightTotal = this.state.costing.landedData.freightChargesTotal
    Manufacturing.dutyValue = Number(this.state.costing.landedData.duty)
    Manufacturing.dutyTotal = this.state.costing.landedData.dutyValue
    Manufacturing.totalLanding = this.state.costing.landedData.totalLandedValue

    Manufacturing.processingCost = Number(
      this.state.costing.landedData.processingCost
    )
    Manufacturing.processValue = this.state.costing.landedData.processValue
    Manufacturing.comments = this.state.costing.comments

    // Manufacturing.totalLandingCost = this.state.usdTotal
    let customerName = document.getElementsByName('customerName')[0].value
    this.setState({
      costingPrint: {
        ...this.state.costingPrint,
        selectedConversion: this.state.costing.selectedConversion,
        Manufacturing,
        customerName: customerName
      }
    })
  }

  updateCostingPrintValues = () => {
    let newUserCosting = `${this.props.userDetails.firstName} ${this.props.userDetails.lastName}`
    setTimeout(() => {
      const costingData = { ...this.state.costing }
      this.costingPrintData(
        {
          name: "createdBy",
          value: costingData.createdBy
            ? `${costingData.createdBy.firstName} ${costingData.createdBy.lastName}`
            : newUserCosting,
          listtoMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name: "modifiedBy",
          value: costingData.modifiedBy
            ? `${costingData.modifiedBy.firstName} ${costingData.modifiedBy.lastName}`
            : newUserCosting,
          listtoMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name: "costingCreatedTime",
          value: moment(costingData.costingCreatedTime).format("HH:mm DD MMM YYYY"),
          listtoMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name: "updatedAt",
          value: moment(costingData.updatedAt).format("HH:mm DD MMM YYYY"),
          listtoMap: ""
        },
        "single"
      )
      //
      this.costingPrintData(
        {
          name: "magnumStyleId",
          value: costingData.magnumStyleId,
          listToMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name:"currencyUpdate",
          value: costingData.currencyConversion,
          listToMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name: "magnumStyleName",
          value: costingData.magnumStyleName,
          listToMap: ""
        },
        "single"
      )
      this.costingPrintData(
        {
          name: "customerRefNumber",
          value: costingData.customerRefNumber,
          listToMap: ""
        },
        "single"
      )

      this.costingPrintData(
        {
          name: "styleReferenceId",
          value: costingData.styleReferenceId,
          listToMap: "styleNoInfo"
        },
        "list"
      )

      // this.costingPrintData(
      //   {
      //     name: "customerName",
      //     value: costingData.customer,
      //     listToMap: "customerList"
      //   },
      //   "list"
      // )
      this.costingPrintData(
        {
          name: "departmentName",
          value: costingData.customerDepartmentId,
          listToMap: "customerList"
        },
        "list"
      )

      this.costingPrintData(
        {
          name: "costingType",
          value: costingData.costingTypeList,
          listToMap: "costingTypeList"
        },
        "list"
      )

      this.costingPrintData(
        {
          name: "sampleRequestId",
          value: costingData.sampleRequestId,
          listToMap: "sampleRequestNumbersList"
        },
        "list"
      )

      this.costingPrintFabricData()
      this.costingPrintTrimData()
      this.costingPrintEmbroideryData()
      this.costingPrintEmbellishmentData()
      this.costingPrintWashData()
      this.costingPrintSmockingData()
      this.costingPrintOtherChargesData()
      this.costingPrintManufacturingData()
    }, 1000)
  }

  // handleCurrencyChange = (name, value) => {
  //   // Update state with the new currency value
  //   this.setState(
  //     prevState => ({
  //       currencies: {
  //         ...prevState.currencies,
  //         [name]: value
  //       }
  //     }),
  //     // After state update, trigger the currency conversion
  //     () => {
  //       // Recalculate the totals after updating the currency value
  //       this.currencyConversion();
  //       this.convertOthers();
  //     }

      
  //   );
  // };
  
  

  getSMVList(referenceId) {
    StyleServices.getSMVByRefId(referenceId)
      .then(response => {
        this.setState({
          selectSmv: response.text.data.smvList.map(x => ({
            label: x.smvNumber,
            value: x.smvId
          }))
        })
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  // getOneSmv = (name, value) => {
  //   let costing = this.state.costing
  //   StyleServices.getSMV(value)
  //     .then(async response => {
  //       let orderQty = Number(costing.manufacturingAndPieceCostDetails.orderQty)
  //       let sam = response.text.data.totalSam
  //       console.log(sam/.8, "samCalculation");

  //       let minutesperDay = Number(response.text.data.minutesPerDay)
  //       let smv80 = Number(response.text.data["80Target"])
  //       let smv100 = Number(response.text.data["100Target"])
  //       let tailers = costing.manufacturingAndPieceCostDetails.noOftailors
  //       let costPerTailer = 1750
  //       let perMachine = 2800
  //       let targetPcsAt = minutesperDay / smv80
  //       let avgOutputNeeded = orderQty / targetPcsAt
  //       let daysFortailorLine = avgOutputNeeded / tailers
  //       let totalDays = daysFortailorLine + 2 //idle days

  //       let totalCost1750 = totalDays * tailers * costPerTailer
  //       let revTailer = totalCost1750 / orderQty

  //       let totalCost2800 = totalDays * tailers * perMachine
  //       let revMachine = totalCost2800 / orderQty

  //       costing.manufacturingAndPieceCostDetails.smv = value
  //       costing.manufacturingAndPieceCostDetails.minutesperDay = minutesperDay
  //       costing.manufacturingAndPieceCostDetails.targetPcsAt = targetPcsAt
  //       costing.manufacturingAndPieceCostDetails.avgOutputNeeded = avgOutputNeeded
  //       costing.manufacturingAndPieceCostDetails.daysFortailorLine = daysFortailorLine
  //       costing.manufacturingAndPieceCostDetails.totalDays = totalDays
  //       costing.manufacturingAndPieceCostDetails.revMachine = revMachine.toFixed(
  //         2
  //       )
  //       costing.manufacturingAndPieceCostDetails.revTailer = revTailer.toFixed(
  //         2
  //       )
  //       costing.manufacturingAndPieceCostDetails.smv80 = smv80
  //       costing.manufacturingAndPieceCostDetails.smv100 = smv100

  //       costing.manufacturingAndPieceCost.CMT = revTailer.toFixed(2)

  //       this.setState(
  //         {
  //           costing
  //         },
  //         () => this.updateCostTotal()
  //       )
  //     })
  //     .catch(error => this.props.getalertMessage("error", error.toString()))
  // }
  getOneSmv = (name, value) => {
    let costing = this.state.costing
    if (name === "smv100" || name === "minutesperDay") {
      let orderQty = Number(costing.manufacturingAndPieceCostDetails.orderQty)
      let sam = (name === "smv100" && Number(value)) || 0
      let totalSmv = (sam / 0.8).toFixed(2)
      let minutesperDay = (name === "minutesperDay" && Number(value)) || Number(costing.manufacturingAndPieceCostDetails.minutesperDay)

      let smv80 = Number(totalSmv)
      let smv100 = (name === "smv100" && Number(value)) || 0
      let tailers = Number(costing.manufacturingAndPieceCostDetails.noOftailors)
      let costPerTailer = Number(costing.manufacturingAndPieceCostDetails.costPertailor)
      let perMachine = Number(costing.manufacturingAndPieceCostDetails.perMachine)
      let targetPcsAt = minutesperDay / totalSmv
      let avgOutputNeeded = orderQty / targetPcsAt
      let daysFortailorLine = Number(avgOutputNeeded) / tailers
      let totalDays = Number(daysFortailorLine) + 2 //idle days

      let totalCost1750 = totalDays * tailers * costPerTailer
      let revTailer = Number(totalCost1750) / Number(orderQty)

      let totalCost2800 = totalDays * tailers * perMachine
      let revMachine = Number(totalCost2800) / Number(orderQty)

      costing.manufacturingAndPieceCostDetails.smv = null
      costing.manufacturingAndPieceCostDetails.minutesperDay = minutesperDay
      costing.manufacturingAndPieceCostDetails.targetPcsAt = targetPcsAt
      costing.manufacturingAndPieceCostDetails.avgOutputNeeded = avgOutputNeeded
      costing.manufacturingAndPieceCostDetails.daysFortailorLine = daysFortailorLine
      costing.manufacturingAndPieceCostDetails.totalDays = totalDays
      costing.manufacturingAndPieceCostDetails.revMachine = Number(revTailer).toFixed(2)
      costing.manufacturingAndPieceCostDetails.revTailer = Number(revMachine).toFixed(2)
      costing.manufacturingAndPieceCostDetails.smv80 = smv80
      costing.manufacturingAndPieceCostDetails.smv100 = smv100
      costing.manufacturingAndPieceCostDetails.sam = sam
      costing.manufacturingAndPieceCostDetails.totalSmv = totalSmv

      costing.manufacturingAndPieceCost.CMT = revMachine.toFixed(2)
      costing.manufacturingAndPieceCost.CMTSelected =
        costing.manufacturingAndPieceCost.CMT ===
          costing.manufacturingAndPieceCostDetails.revTailer
          ? "2800"
          : costing.manufacturingAndPieceCost.CMT ===
            costing.manufacturingAndPieceCostDetails.revMachine
            ? "1750"
            : ""

      this.setState(
        {
          costing
        },
        () => this.updateCostTotal()
      )
    } else {
      if (!value) {
        this.props.getalertMessage("info", "invalid smv request", 5000)
      } else {
        StyleServices.getSMV(value)
          .then(async response => {
            let orderQty = Number(
              costing.manufacturingAndPieceCostDetails.orderQty
            )
            let sam = Number(response.text.data.totalSam)
            let totalSmv = (sam / 0.8).toFixed(2)
            let minutesperDay = Number(response.text.data.minutesPerDay)

            let smv80 = Number(totalSmv)
            let smv100 = Number(response.text.data.totalSam)
            let tailers = Number(
              costing.manufacturingAndPieceCostDetails.noOftailors
            )
            let costPerTailer = Number(
              costing.manufacturingAndPieceCostDetails.costPertailor
            )
            let perMachine = Number(
              costing.manufacturingAndPieceCostDetails.perMachine
            )
            let targetPcsAt = minutesperDay / totalSmv
            let avgOutputNeeded = orderQty / targetPcsAt
            let daysFortailorLine = Number(avgOutputNeeded) / tailers
            let totalDays = Number(daysFortailorLine) + 2 //idle days

            // console.log(totalSmv, "SMVVV", minutesperDay, targetPcsAt, avgOutputNeeded, daysFortailorLine, totalDays)

            let totalCost1750 = totalDays * tailers * costPerTailer
            let revTailer = Number(totalCost1750) / Number(orderQty)

            let totalCost2800 = totalDays * tailers * perMachine
            let revMachine = Number(totalCost2800) / Number(orderQty)

            costing.manufacturingAndPieceCostDetails.smv = value
            costing.manufacturingAndPieceCostDetails.minutesperDay = minutesperDay
            costing.manufacturingAndPieceCostDetails.targetPcsAt = targetPcsAt
            costing.manufacturingAndPieceCostDetails.avgOutputNeeded = avgOutputNeeded
            costing.manufacturingAndPieceCostDetails.daysFortailorLine = daysFortailorLine
            costing.manufacturingAndPieceCostDetails.totalDays = totalDays
            costing.manufacturingAndPieceCostDetails.revMachine = Number(
              revTailer
            ).toFixed(2)
            costing.manufacturingAndPieceCostDetails.revTailer = Number(
              revMachine
            ).toFixed(2)
            costing.manufacturingAndPieceCostDetails.smv80 = smv80
            costing.manufacturingAndPieceCostDetails.smv100 = smv100
            costing.manufacturingAndPieceCostDetails.sam = sam
            costing.manufacturingAndPieceCostDetails.totalSmv = totalSmv

            costing.manufacturingAndPieceCost.CMT = revMachine.toFixed(2)
            costing.manufacturingAndPieceCost.CMTSelected =
              costing.manufacturingAndPieceCost.CMT ===
                costing.manufacturingAndPieceCostDetails.revTailer
                ? "2800"
                : costing.manufacturingAndPieceCost.CMT ===
                  costing.manufacturingAndPieceCostDetails.revMachine
                  ? "1750"
                  : ""

            this.setState(
              {
                costing
              },
              () => this.updateCostTotal()
            )
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
      }
    }
  }

  getFabricNo(value) {
    if (this.state.sampleNo !== undefined) {
      SampleServices.getFabricNo(value, this.state.sampleNo.value)
        .then(response => {
          if (response.message === "Sample Request fabric Data") {
            let jsonData = []
            response.data.fabric.map((info, index) => {
              let objData = {}
              objData.label = info.fabricNumber
              objData.value = info.fabricId

              jsonData.push(objData)
            })
            this.setState({ fabricNumbers: jsonData })
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    } else {
      SampleServices.getAllFabrics(value)
        .then(response => {
          if (response.message === "List Displayed") {
            let jsonData = []
            response.data.map((info, index) => {
              let objData = {}
              objData.label = info.fabricNumber
              objData.value = info._id

              jsonData.push(objData)
            })
            this.setState({ fabricNumbers: jsonData })
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    }
  }
  changeFabricNo = (fabricNo, indexVal) => {
    this.setState({ [`fabricNo${indexVal}`]: fabricNo })
    if (
      fabricNo !== null &&
      fabricNo.value !== undefined &&
      fabricNo.value !== "" &&
      this.state.sampleNo !== undefined
    ) {
      SampleServices.getFabricName(this.state.sampleNo, fabricNo)
        .then(response => {
          //

          if (response.message === "Fabric details from sample request") {
            SampleServices.getSupplierInfo(fabricNo)
              .then(response => {
                if (response.message === "Fabric Supplier") {
                  //
                  let jsonData = []
                  let { fabricCountArray } = this.state
                  response.data.supplier.map((info, index) => {
                    let objData = {}
                    objData.label = info.supplierName
                    objData.value = info._id

                    jsonData.push(objData)
                  })
                  fabricCountArray[indexVal].supplier = jsonData
                  this.setState(
                    { fabricSupplier: jsonData, fabricCountArray },
                    function () {
                      //
                    }
                  )
                }
              })
              .catch(error =>
                this.props.getalertMessage("error", error.toString())
              )
            this.setState({
              [`selectedFabricInfo${indexVal}`]: response.data.fabric
            })
          }
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      SampleServices.getSupplierInfo(fabricNo)
        .then(response => {
          if (response.message === "Fabric Supplier") {
            //
            let jsonData = []
            let { fabricCountArray } = this.state
            response.data.supplier.map((info, index) => {
              let objData = {}
              objData.label = info.supplierName
              objData.value = info._id

              jsonData.push(objData)
            })
            fabricCountArray[indexVal].supplier = jsonData
            this.setState(
              { fabricSupplier: jsonData, fabricCountArray },
              function () { }
            )
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    }
  }

  changeSupplierInfoForFabric = (supplierNo, indexVal) => {
    //
    this.setState({ [`selectedSupplierInfo${indexVal}`]: supplierNo })
  }
  changeSupplierNoForTrim = (supplierNo, indexVal) => {
    this.setState({ [`trimSupplierNo${indexVal}`]: supplierNo })
  }
  getTrimNo(value) {
    if (this.state.sampleNo !== undefined) {
      SampleServices.getTrimNo(value, this.state.sampleNo.value)
        .then(response => {
          if (response.message === "Sample Request trim Data") {
            let jsonData = []
            response.data.trim.map((info, index) => {
              let objData = {}
              objData.label = info.trimNumber
              objData.value = info.trimId

              jsonData.push(objData)
            })
            this.setState({ trimNumbers: jsonData }, function () { })
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    } else {
      SampleServices.getAllTrims(value)
        .then(response => {
          if (response.message === "List Displayed") {
            let jsonData = []
            response.data.map((info, index) => {
              let objData = {}
              objData.label = info.trimNumber
              objData.value = info._id

              jsonData.push(objData)
            })
            this.setState({ trimNumbers: jsonData }, function () { })
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    }
  }
  changeTrimNo = (trimNo, indexVal) => {
    this.setState({ [`trimNo${indexVal}`]: trimNo })

    if (trimNo !== null && trimNo.value !== undefined && trimNo.value !== "") {
      SampleServices.getTrimName(this.state.sampleNo, trimNo)
        .then(response => {
          if (response.message === "Trim details from sample request") {
            SampleServices.getSupplierInfoForTrim(trimNo)
              .then(response => {
                if (response.message === "Trim Supplier") {
                  let jsonData = []
                  response.data.supplier.map((info, index) => {
                    let objData = {}
                    objData.label = info.supplierName
                    objData.value = info._id

                    jsonData.push(objData)
                  })
                  let { trimCountArray } = this.state
                  trimCountArray[indexVal].supplier = jsonData
                  this.setState({ trimSupplier: jsonData, trimCountArray })
                }
              })
              .catch(error => {
                // alert("Something Went wrong...Try Again Later")
              })
            this.setState({
              [`selectedTrimInfo${indexVal}`]: response.data.trim
            })
            // this.setState({ customerInfo: response.data.customer, departmentInfo: response.data.department, styleInfo: response.data.magnumStyle })
          }
        })
        .catch(error => {
          // alert("Something Went wrong...Try Again Later")
        })
    }
  }

  createCosting(e) {
    let costing = { ...this.state.costing }
    if (typeof costing.styleReferenceId === "object") {
      costing.styleReferenceId = costing.styleReferenceId.value
    }
    CostingServices.addCosting(costing)
      .then(response => {
        if (response.status === 200) {
          // this.setState({
          //   costing: response.text.data
          // })
          this.props.getalertMessage("success", response.text.message)
          if (this.state.action === "add") {
            this.setState({
              action: "edit",
              _id: response.text.data._id,
              costing: { ...this.state.costing, _id: response.text.data._id }
            })
            this.props.location.state = {
              _id: response.text.data._id,
              action: "edit",
              // costing: { ...this.state.costing, _id: response.text.data._id }
            }
            // this.props.history.push("/CostingPage", {
            //   action: "edit",
            //   _id: response.text.data._id
            // })
            // this.setState({
            //   goBack: this.state.goBack - 1
            // })
            // this.updateCostingPrintValues()
          }
          // this.props.history.goBack()
        }
      })
      .catch(error => {
        this.props.getalertMessage("error", error)
      })
  }

  countPrice(e) {
    this.setState({
      fabricCost:
        document.getElementsByName("consumption")[0].valueAsNumber *
        document.getElementsByName("price")[0].valueAsNumber,
      totalFabricCost:
        document.getElementsByName("consumption")[0].valueAsNumber *
        document.getElementsByName("price")[0].valueAsNumber
    })
  }

  // Fabric module start

  addFabric = () => {
    let costing = { ...this.state.costing }
    costing.fabric.push({ ...fabricTemplate })
    let index = costing.fabric.length
    this.setState({ costing })
    this.getFabricNumber("", index - 1)
  }

  removeFabric = index => {
    let costing = { ...this.state.costing }
    // costing.fabric[index].totalCost = 0
    // console.log(costing.fabric[index].totalCost, "costing.fabric[index].totalCost")
    // costing.fabricTotalCost = Number(costing.fabric.reduce((arr, cur) => arr + (cur.totalCost || 0), 0)).toFixed(2);
    // console.log(costing.fabricTotalCost, "costing.fabricTotalCost")
    // costing.fabric = costing.fabric.filter((data, i) => i !== index)
    // Remove the selected fabric entry
    costing.fabric = costing.fabric.filter((data, i) => i !== index);

    // Calculate fabricTotalCost, ensuring each fabric entry's totalCost defaults to 0 if undefined or NaN
    costing.fabricTotalCost = Number(
        costing.fabric.reduce((arr, cur) => arr + (Number(cur.totalCost) || 0), 0)
    ).toFixed(2);
    this.setState({
      costing
    },
      () => this.updateCostTotal())
  }

  getFabricInfo = (fabric, index) => {
    let costing = { ...this.state.costing }
    if (fabric != null) {
      SampleServices.getFabricInfo(fabric.value)
        .then(async response => {
          if (response.status == 200) {
            console.log(response.text.data,'121')
            costing.fabric[index].qualityClassification =
              (response.text.data.quality !== null
                ? response.text.data.quality.name
                : "") +
              " / " +
              (response.text.data.classificationOfFabric !== null
                ? response.text.data.classificationOfFabric.name
                : "")
            costing.fabric[
              index
            ].countAndConstruction = `${response.text.data.count.warp}*${response.text.data.count.weft}/${response.text.data.construction.warp}*${response.text.data.construction.weft}`
            costing.fabric[index].fabricNumber = fabric.value
            costing.fabric[index].printDirection = response.text.data.printDirection
            costing.fabric[index].price = response.text.data.price
            costing.fabric[index].supplierName = response.text.data.supplierName
            costing.fabric[index].width = response.text.data.width
            costing.fabric[index].valueLoss = response.text.data.valueLoss
            costing.fabric[index].EmbValueLoss = response.text.data.EmbValueLoss
            costing.fabric[index].greige = response.text.data.greige
            costing.fabric[index].dyingPrint = response.text.data.dyingPrint
            costing.fabric[index].upCharge = response.text.data.upcharge
            costing.fabric[index].gst = response.text.data.gst
            costing.fabric[index].embCost = response.text.data.embCost
            costing.fabric[index].yardDyedCost = response.text.data.yardDyedCost
            console.log(costing.fabric[index],'121')
            this.setState({ costing }, () => {
              costing.fabric.forEach((x, i) => {
                this.calcTotalCost(null, null, i, "fabric")
              })
            })
          }
          response.status == 404 &&
            this.props.getalertMessage("error", response.text.message)
          response.status == 401 && this.props.unauthorisedFunc()
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      costing.fabric[index].fabricNumber = null
    }
    this.setState({
      costing
    })
  }

  getSupplierSectionList = (_id, name) => {
    switch (name) {
      case "fabric":
        CostingServices.getSupplierSectionFabric(_id)
          .then(async response => {
            if (response.status == 200) {
              this.setState(
                {
                  supplierSectionList: response.text.data.supplier
                },
                () =>
                  this.setState({
                    supplier: name,
                    modalToggle: true
                  })
              )
            } else if (response.status == 401) {
              this.props.unauthorisedFunc()
            } else {
              this.props.getalertMessage("error", response.text.message)
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
        break
      case "trim":
        CostingServices.getSupplierSectionTrim(_id)
          .then(async response => {
            if (response.status == 200) {
              this.setState(
                {
                  supplierSectionList: response.text.data.supplier
                },
                () =>
                  this.setState({
                    supplier: name,
                    modalToggle: true
                  })
              )
            } else if (response.status == 401) {
              this.props.unauthorisedFunc()
            } else {
              this.props.getalertMessage("error", response.text.message)
            }
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))
        break
    }
  }

  selectSupplierSec = index => {
    let costing = { ...this.state.costing }
    let supplier = this.state.supplier
    costing[supplier][
      this.state[`${supplier}Index`]
    ].supplierName = this.state.supplierSectionList[index].supplier
    costing[supplier][
      this.state[`${supplier}Index`]
    ].price = this.state.supplierSectionList[index].totalCost
    // suppliers[
    //   this.state[`${supplier}Index`]
    // ].totalCost = (suppliers[this.state[`${supplier}Index`]].price * suppliers[this.state[`${supplier}Index`]].consumption).toFixed(2)

    if (supplier === "trim") {
      // costing.trim[this.state.trimIndex][name] = value
      const consumption = costing.trim[this.state.trimIndex].consumption || 0
      const price = costing.trim[this.state.trimIndex].price || 0
      costing.trim[this.state.trimIndex].totalCost = consumption * price
      costing.trimTotalCost = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing.trim.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
    }

    this.setState({
      costing,
      modalToggle: false
    }, () => {
      if (supplier === 'fabric') {
        this.calcTotalCost(
          null,
          null,
          this.state[`${supplier}Index`],
          "fabric"
        )
      }
    }, () => {
      this.updateCostTotal()
    })
    // costing.fabric[
    //   this.state.fabricIndex
    // ].supplierName = this.state.supplierSectionList[index].supplier
    // costing.fabric[
    //   this.state.fabricIndex
    // ].price = this.state.supplierSectionList[index].totalCost
    // this.setState({
    //   costing,
    //   modalToggle: false
    // })
  }

  //fabric module end

  //trim module start
  addTrim = () => {
    let costing = { ...this.state.costing }
    costing.trim.push({ ...trimTemplate })
    this.setState({
      costing
    })
  }

  // removeTrim = index => {
  //   let costing = { ...this.state.costing }
  //   costing.trim[index].totalCost = 0
  //   costing.trimTotalCost = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing.trim.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
  //   costing.trim = costing.trim.filter((data, i) => i !== index)
  //   this.setState(
  //     {
  //       costing
  //     }, () => this.updateCostTotal()
  //   )
  // }

  removeTrim = index => {
    let costing = { ...this.state.costing };

    // Set the totalCost of the selected trim to 0 (if valid index)
    if (costing.trim && costing.trim[index]) {
        costing.trim[index].totalCost = 0;
    }

    // Safeguard the trimPackTotalCost
    const trimPackTotalCost = Number(costing.trimPackTotalCost) || 0;

    // Safeguard reduce to avoid NaN
    const trimTotalCost = Array.isArray(costing.trim)
        ? costing.trim.reduce((arr, cur) => arr + (cur.totalCost ? Number(cur.totalCost) : 0), 0)
        : 0;

    // Update trimTotalCost
    costing.trimTotalCost = Number(trimPackTotalCost + trimTotalCost).toFixed(2);

    // Filter out the trim at the given index
    costing.trim = costing.trim ? costing.trim.filter((_, i) => i !== index) : [];

    // Update state and recalculate total cost
    this.setState(
        { costing },
        () => this.updateCostTotal()
    );
};


  updateTrim = (name, value, index) => {
    let costing = { ...this.state.costing }
    costing.trim[index][name] = value
    if (name == "trimCategory") {
      SampleServices.getTrimNumber(value, "")
        .then(async response => {
          if (response.status == 200)
            costing.trim[index].trimList = response.text.data
          this.setState({
            costing
          })
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    }
  }

  updateSmockingSheering = (name, value, index) => {
    let costing = { ...this.state.costing }
    if (value !== null) {
      costing.smockingSheering[index][name] = value
    }
    let { smockingorElastic, toptthElastic } = this.state.SHIRRINGORSMOCKING
    if (!smockingorElastic || !toptthElastic) {
      this.props.getalertMessage(
        "info",
        "Create System master(SHIRRINGORSMOCKING)"
      )
    }

    if (name == "trimCategory") {
      SampleServices.getTrimNumber(value, "")
        .then(async response => {
          if (response.status == 200)
            costing.smockingSheering[index].trimList = response.text.data
          this.setState({ costing })
        })
        .catch(error => this.props.getalertMessage("error", error.toString()))
    } else {
      let rows = costing.smockingSheering[index].noOfRow
        ? costing.smockingSheering[index].noOfRow
        : 0
      let length = costing.smockingSheering[index].length
        ? costing.smockingSheering[index].length
        : 0
      let type = costing.smockingSheering[index].type
        ? costing.smockingSheering[index].type
        : ""
      let totalReq = 0
      let price = 0

      if (type === "Both Elastic") {
        //No of Rows *Length * 7 +10% (wastage)
        let mult = Number(smockingorElastic.multiple)
        let wast = Number(smockingorElastic.wastage)
        totalReq = (
          rows * length * mult +
          (rows * length * mult) / wast
        ).toFixed(2)
        price = costing.smockingSheering[index].price
          ? costing.smockingSheering[index].price
          : null
        costing.smockingSheering[index].totalReq = totalReq
        costing.smockingSheering[index].price = price
        costing.smockingSheering[index].totalCost = totalReq * price
      } else if (type === "Top TTH / Bottom Elastic") {
        let mult = toptthElastic.multiple
        let wast = toptthElastic.wastage
        // No of Rows *Length * 4 +10% (wastage)
        totalReq = (
          rows * length * mult +
          (rows * length * mult) / wast
        ).toFixed(2)
        price = costing.smockingSheering[index].price
          ? costing.smockingSheering[index].price
          : ""
        costing.smockingSheering[index].totalReq = totalReq ? totalReq : null
        costing.smockingSheering[index].price = price ? price : null
        costing.smockingSheering[index].totalCost = (totalReq * price).toFixed(
          2
        )
      }
      costing.smockingSheeringTotalCost = costing.smockingSheering
        .reduce(
          (arr, cur) => (cur.totalCost ? arr + Number(cur.totalCost) : arr + 0),
          0
        )
        .toFixed(2)
      this.setState(
        {
          costing
        },
        () => this.updateCostTotal()
      )
    }
  }

  updateEmbellishment = (name, value, index) => {
    let costing = { ...this.state.costing }
    if (value) {
      costing.embellishment[index][name] = value || ""
    } else {
      costing.embellishment[index][name] = ""
    }
    // console.log(Math.round(moment.duration(moment(costing.embellishment[index].hoursMinutes).format('HH:mm'), 'minutes').asMinutes() / 30));
    let hoursMinutes = costing.embellishment[index].hoursMinutes
      ? Math.round(
        moment
          .duration(moment(costing.embellishment[index].hoursMinutes).format("HH:mm"), "minutes")
          .asMinutes() / 1
      )
      : ""
    let pricePerHalfHour = costing.embellishment[index].pricePerHalfHour
      ? costing.embellishment[index].pricePerHalfHour
      : ""
    let pricePerMinute = pricePerHalfHour && (pricePerHalfHour * 2) / 60 || ""
    costing.embellishment[index].totalCost = Number(
      hoursMinutes * pricePerMinute
    ).toFixed(2)
    let embelishmentTotalCost = costing.embellishment.reduce(
      (arr, cur) =>
        cur.totalCost ? Number(arr) + Number(cur.totalCost) : arr + 0,
      0
    )

    costing.embelishmentTotalCost = Number(embelishmentTotalCost).toFixed(2)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  manufactureUpdate = (name, value) => {
    let costing = { ...this.state.costing }

    if (name === "fixedCharge") {
      costing.manufacturingAndPieceCost[name] = value
      let cmt = costing.manufacturingAndPieceCost.CMT
      costing.manufacturingAndPieceCost.totalCost =
        value + ((cmt && Number(cmt)) || 0)
    } else if (name === "sampleDate" || name === "patternDate") {
      costing.selectedMenu.date = value
    } else if (name === "orderQty") {
      costing.manufacturingAndPieceCostDetails.orderQty = value
      if (costing.manufacturingAndPieceCostDetails.smv) {
        this.getOneSmv(null, costing.manufacturingAndPieceCostDetails.smv)
      } else {
        this.getOneSmv('smv100', (costing.manufacturingAndPieceCostDetails.smv100 || 0))
      }
    } else if (name === "CMT") {
      costing.manufacturingAndPieceCost[name] = value
    } else {
      costing.manufacturingAndPieceCostDetails[name] = value
      if (name === "revTailer") {
        costing.manufacturingAndPieceCost.CMT = Number(value).toFixed(2)
      }
    }
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  updateManufacturingProcess = () => {
    let costing = { ...this.state.costing }

    // Variables
    let minutesperDay = costing.manufacturingAndPieceCostDetails.minutesperDay
    let smv80 = costing.manufacturingAndPieceCostDetails.smv80
    let orderQty = costing.manufacturingAndPieceCostDetails.orderQty
    let tailers = costing.manufacturingAndPieceCostDetails.noOftailors
    let costPerTailer = costing.manufacturingAndPieceCostDetails.costPertailor
    let perMachine = costing.manufacturingAndPieceCostDetails.perMachine

    // Calculations
    let targetPcsAt = minutesperDay / smv80
    let avgOutputNeeded = orderQty / targetPcsAt
    let daysFortailorLine = avgOutputNeeded / tailers
    let totalDays = daysFortailorLine + 2 //idle days

    let totalCost1750 = totalDays * tailers * costPerTailer
    let revTailer = totalCost1750 / orderQty

    let totalCost2800 = totalDays * tailers * perMachine
    let revMachine = totalCost2800 / orderQty

    costing.manufacturingAndPieceCostDetails.minutesperDay = minutesperDay
    costing.manufacturingAndPieceCostDetails.targetPcsAt = targetPcsAt
    costing.manufacturingAndPieceCostDetails.avgOutputNeeded = avgOutputNeeded
    costing.manufacturingAndPieceCostDetails.daysFortailorLine = daysFortailorLine
    costing.manufacturingAndPieceCostDetails.totalDays = totalDays
    costing.manufacturingAndPieceCostDetails.revMachine = revMachine.toFixed(2)
    costing.manufacturingAndPieceCostDetails.revTailer = revTailer.toFixed(2)
    costing.manufacturingAndPieceCost.CMT = revTailer.toFixed(2)
    costing.manufacturingAndPieceCost.CMTSelected =
      costing.manufacturingAndPieceCost.CMT ===
        costing.manufacturingAndPieceCostDetails.revTailer
        ? "2800"
        : costing.manufacturingAndPieceCost.CMT ===
          costing.manufacturingAndPieceCostDetails.revMachine
          ? "1750"
          : ""

    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }
  updateWash = (name, value, index) => {
    let costing = { ...this.state.costing }
    if (name === "washType") {
      let price = this.state.washTypeList.find(
        x => x.value === value
      ).price
      costing.wash[index].price = price && Number(price).toFixed(2) || '0.00'

    }

    if (name) {
      costing.wash[index][name] = value
    }
    let weight = (costing.wash[index].weight && Number(costing.wash[index].weight)) || 0
    let price = (costing.wash[index].price && Number(costing.wash[index].price)) || 0
    costing.wash[index].totalCost = Number(weight * price).toFixed(2)
    costing.washTotalCost = costing.wash
      .reduce((arr, cur) => (cur.totalCost ? arr + Number(cur.totalCost) : arr + 0), 0)
      .toFixed(2)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  updateCostTotal = () => {
    let costing = { ...this.state.costing }
    let {
      fabricTotalCost,
      trimTotalCost,
      embroideryTotalCost,
      backingTotalCost,
      embelishmentTotalCost,
      washTotalCost,
      otherTotalCost,
      // trimPackTotalCost,
      smockingSheeringTotalCost
    } = this.state.costing
    let { fixedCharge, CMT } = costing.manufacturingAndPieceCost

    let totalCost =
      Number(fabricTotalCost || 0) +
      Number(trimTotalCost || 0) +
      Number(embroideryTotalCost || 0) +
      Number(backingTotalCost || 0) +
      Number(embelishmentTotalCost || 0) +
      Number(washTotalCost || 0) +
      Number(otherTotalCost || 0) +
      // Number(trimPackTotalCost||0) +
      Number(smockingSheeringTotalCost || 0) +
      Number(fixedCharge || 0) +
      Number(CMT || 0)

    let overHeads = Number(
      this.state.costing.manufacturingAndPieceCost.overHeads
    )
    let valueLoss = Number(
      this.state.costing.manufacturingAndPieceCost.valueLoss
    )

    costing.manufacturingAndPieceCost.totalCost = totalCost.toFixed(2)
    costing.manufacturingAndPieceCost.valueLossCost =
      (valueLoss * costing.manufacturingAndPieceCost.totalCost) / 100
    costing.manufacturingAndPieceCost.overHeadsCost =
      (overHeads *
        (Number(costing.manufacturingAndPieceCost.totalCost) +
          Number(costing.manufacturingAndPieceCost.valueLossCost))) /
      100
    costing.costingTotal =
      Number(totalCost) +
      Number(costing.manufacturingAndPieceCost.overHeadsCost) +
      Number(costing.manufacturingAndPieceCost.valueLossCost)

    costing.costingTotal = Number(costing.costingTotal).toFixed(2)
    setTimeout(() => {
      this.setState(
        {
          costing
        },
        () => this.convertOthers()
      )
    }, 100);
  }

  convertOthers = () => {
    let { costing } = { ...this.state };

  // Check if it's "add" or "edit" mode based on currency data
  let usd, gbp, eur;

  if (this.state.action === "add") {
    // In "add" mode, always use currencies from this.state.currencies
    ({ usd, gbp, eur } = this.state.currencies);
    //console.log(usd,gbp,eur,"usd,gpb,eur")
  } else if (this.state.action === "edit") {
    // In "edit" mode, first check if currencyConversion exists, otherwise use currencies
    if (this.state.costing && this.state.costing.currencyConversion) {
      ({ usd, gbp, eur } = this.state.costing.currencyConversion);
      //console.log(usd,gbp,eur,"usd,gpb,eur")
    } else {
      // If currencyConversion does not exist, use values from currencies
      ({ usd, gbp, eur } = this.state.currencies);
      //console.log(usd,gbp,eur,"usd,gpb,eur")
    }
  }
    costing.landedPrice = ((Number(costing.costingTotal) || 0) / usd).toFixed(2)
    // costing.agreedPrice = ((costing.costingTotal || 0) / usd).toFixed(2)
    costing.usdTotal = ((Number(costing.costingTotal) || 0) / usd).toFixed(2)
    //console.log(costing.usdTotal,"usdTotal")
    costing.gbpTotal = ((Number(costing.costingTotal) || 0) / gbp).toFixed(2)
    costing.euroTotal = ((Number(costing.costingTotal) || 0) / eur).toFixed(2)
    //console.log(costing, "costing")
    //console.log(this.state.costing.euroTotal,"this.state.costing.euroTotal")
    this.setState(
      {
        costing
      },
      () => this.landedCalc("shipmentTerm", costing.landedData.toValue)
    )
  }

  getTrimRefNo = (trimCategory, value, index, keyname) => {
    SampleServices.getTrimNumber(trimCategory, value)
      .then(async response => {
        if (index.toString()) {
          let costing = { ...this.state.costing }
          costing[keyname][index].trimList = response.text.data
          this.setState({
            costing
          })
        } else {
          this.setState({
            trimNumberList: response.text.data
          })
        }
      })
      .catch(error => alert(error.toString()))
  }

  getTrimInfo = (trim, index, keyname) => {
    let costing = { ...this.state.costing }
    if (keyname === "trim") {
      if (trim !== null) {
        costing.trim[index].trimNumber = trim._id
        costing.trim[index].description = trim.description
        costing.trim[index].quality = trim.quality
        costing.trim[index].sizeNumber = trim.sizeNumber
        costing.trim[index].size = `${trim.sizeNumber}-${trim.size}`
        costing.trim[index].unit = trim.unit
        costing.trim[index].supplierName = trim.supplierName
        costing.trim[index].price = trim.price
      } else {
        costing.trim[index].trimNumber = null
      }
    } else if (keyname === "smockingSheering") {
      let costing = { ...this.state.costing }
      if (trim !== null) {
        costing.smockingSheering[index].trimNumber = trim._id
        costing.smockingSheering[index].description = trim.description
        costing.smockingSheering[index].quality = trim.quality
        costing.smockingSheering[index].sizeNumber = trim.sizeNumber
        costing.smockingSheering[index].size = trim.size
        costing.smockingSheering[index].price = trim.price
      } else {
        costing.smockingSheering[index].trimNumber = null
      }
    }
    setTimeout(() => {
      this.setState({
        costing
      })
    }, 1000);
  }

  //smocking module start

  addSmocking = () => {
    let costing = { ...this.state.costing }
    costing.smockingSheering.push({ ...smockingSheeringTemplate })
    this.setState({
      costing
    })
  }

  removeSmocking = index => {
    let costing = { ...this.state.costing }
    costing.smockingSheering[index].totalCost = 0
    let cost = costing.smockingSheering.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0)
    costing.smockingSheeringTotalCost = Number(cost).toFixed(2)
    costing.smockingSheering = costing.smockingSheering.filter((data, i) => i !== index)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  // smocking module end

  //embroidery module start

  addEmbroidery = () => {
    let costing = { ...this.state.costing }
    costing.embroidery.push({ ...embroideryTemplate })
    this.setState({
      costing
    })
  }

  removeEmbroidery = index => {
    let costing = { ...this.state.costing }
    costing.embroidery[index].totalCost = 0
    costing.embroideryTotalCost = Number(costing.embroidery.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0)).toFixed(2)
    costing.embroidery = costing.embroidery.filter((data, i) => i !== index)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  //embroidery module end

  //backing module start

  addBacking = () => {
    let costing = { ...this.state.costing }
    costing.backing.push({ ...backingTemplate })
    this.setState({
      costing
    })
  }

  removeBacking = index => {
    let costing = { ...this.state.costing }
    let totalCost = costing.backing.find((x, i) => i == index).totalCost
    costing.backingTotalCost =
      Number(costing.backingTotalCost) - Number(totalCost)
    costing.backing = costing.backing.filter((data, i) => i !== index)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  //embellishment module start

  addEmbellishment = () => {
    let costing = { ...this.state.costing }
    costing.embellishment.push({ ...embellishmentTemplate })
    this.setState({
      costing
    })
  }

  removeEmbellishment = index => {
    let costing = { ...this.state.costing }
    costing.embellishment[index].totalCost = 0
    costing.embelishmentTotalCost = Number(Number(costing.embellishment.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
    costing.embellishment = costing.embellishment.filter((data, i) => i !== index)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  //embellishment module end

  //wash module start

  addWash = () => {
    let costing = { ...this.state.costing }
    costing.wash.push({ ...washTemplate })
    this.setState({
      costing
    })
  }

  removeWash = index => {
    let costing = { ...this.state.costing }
    costing.wash[index].totalCost = 0
    costing.washTotalCost = Number(costing.wash.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0)).toFixed(2)
    costing.wash = costing.wash.filter((data, i) => i !== index)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  //addGirlsWearArray
  addGirlsWearArray = (e, keyName, index) => {
    let { name, value } = e.target
    let costing = { ...this.state.costing }
    let grouping = [...costing.girlsWearing.grouping]
    grouping = grouping.map((data, i) => {
      let x = { ...data }
      if (x.name === keyName) {
        x.values = x.values.map((y, j) => {
          if (index === j) {
            y.value = Number(value) || 0
          }
          return y
        })
      }
      x.total = x.values.reduce((acc, c) => (Number(c.value) || 0) + acc, 0)
      return x
    })
    costing.girlsWearing.grouping = [...grouping]
    costing.girlsWearing.groupTotal = grouping.reduce((x, ac) => {
      return x + (ac.total || 0)
    }, 0)
    this.setState(
      {
        costing
      },
      () => this.toQuate()
    )
  }

  toQuate = () => {
    let costing = { ...this.state.costing }
    if (costing.girlsWearing && Object.keys(costing.girlsWearing).length)
      if (!costing.landedData || !costing.landedData.totalLandedValue) {
        // costing.landedData.totalLandedValue = 6.50 //SHOULD DELETE
        this.props.getalertMessage("info", "Total landed cost Empty!", 5000)
      } else {
        let total = Number(costing.landedData.totalLandedValue)

        let grouping = [...costing.girlsWearing.grouping]
        let groupTotal = costing.girlsWearing.groupTotal || 0
        let obj = {} //A,B,C,D,...
        let obj1 = {} //A+B,C+D,...
        let obj2 = {} //(C+D/groupTotal),(A+B/groupTotal),..
        let obj3 = {} //(A/A+B),(B/A+B),..
        let obj4 = {} // TOTAL-(C+D),TOTAL-(A+B), ...
        let obj5 = {} //

        grouping.forEach((x, i) => {
          let charAt = String.fromCharCode(65 + i)
          obj[charAt] = x.total
        })
        let j = 0
        var i,
          length = Object.keys(obj).length

        for (i = 0; i < length;) {
          let one = Number(obj[Object.keys(obj)[i]])
          let two = Number(obj[Object.keys(obj)[i + 1]])

          let s = String.fromCharCode(65 + j)
          obj1[s] = Number(one + two)

          obj3[String.fromCharCode(65 + (i ? i + 1 : i + 1))] = Number(
            Number(one) / Number(obj1[s])
          ).toFixed(2)
          obj3[String.fromCharCode(65 + (i ? i : 0))] = Number(
            Number(two) / Number(obj1[s])
          ).toFixed(2)
          i = i + 2
          j++
        }

        // Object.keys(obj3).map(x => { obj3[x] = Number(obj3[x]).toFixed(2) })
        Object.keys(obj1).map((x, i) => {
          let charAt = String.fromCharCode(65 + i)
          obj2[charAt] = Number(
            obj1[Object.keys(obj1)[i]] / groupTotal
          ).toFixed(2)
        })

        Object.keys(obj2)
          .reverse()
          .map((x, i) => {
            let charAt = String.fromCharCode(65 + i)
            if ((i + 1) % 2 == 0) {
              obj4[charAt] = Number(total + Number(obj2[x])).toFixed(2)
            } else {
              obj4[charAt] = Number(total - Number(obj2[x])).toFixed(2)
            }
          })

        let k = 0
        Object.keys(obj4).forEach((x, i) => {
          let charAt1 = String.fromCharCode(65 + k)
          let charAt2 = String.fromCharCode(65 + (k ? k + 1 : k + 1))
          obj5[charAt1] = Number(
            Number(obj4[x]) - Number(obj3[Object.keys(obj3)[k + 1]])
          ).toFixed(2)
          obj5[charAt2] = Number(
            Number(obj4[x]) + Number(obj3[Object.keys(obj3)[k]])
          ).toFixed(2)
          k = k + 2
        })

        costing.girlsWearing.toQuote = Object.values(obj5).map(x => Number(x))
        costing.girlsWearing.canQuote = Object.values(obj5).map(x => 0.0)
        costing.girlsWearing.agreedQuote = Object.values(obj5).map(x => 0.0)
        costing.girlsWearing.toQuateAvg = costing.girlsWearing.toQuote.reduce(
          (ac, c, i) => {
            return Number(ac) + Number(c) * Number([obj[Object.keys(obj)[i]]])
          },
          0
        )

        costing.girlsWearing.toQuateAvg = (
          Number(costing.girlsWearing.toQuateAvg) / Number(groupTotal)
        ).toFixed(2)

        this.setState({ costing })
      }
  }

  canQuote = (e, index) => {
    let { name, value } = e.target
    let costing = this.state.costing
    let grouping = costing.girlsWearing.grouping
    let groupTotal = costing.girlsWearing.groupTotal || 0
    let obj = {} //A,B,C,D,...

    grouping.forEach((x, i) => {
      let charAt = String.fromCharCode(65 + i)
      obj[charAt] = x.total
    })

    costing.girlsWearing.canQuote = costing.girlsWearing.canQuote.map(
      (x, i) => {
        if (i == index) {
          x = Number(value)
          return x
        }
        return Number(x)
      }
    )

    costing.girlsWearing.canQuateAvg = costing.girlsWearing.canQuote.reduce(
      (ac, c, i) => {
        return Number(ac) + Number(c) * Number([obj[Object.keys(obj)[i]]])
      },
      0
    )
    costing.girlsWearing.canQuateAvg = (
      Number(costing.girlsWearing.canQuateAvg) / Number(groupTotal)
    ).toFixed(2)

    this.setState({ costing })
  }

  agreedQuote = (e, index) => {
    let { name, value } = e.target
    let costing = this.state.costing
    let grouping = costing.girlsWearing.grouping
    let groupTotal = costing.girlsWearing.groupTotal || 0
    let obj = {} //A,B,C,D,...

    grouping.forEach((x, i) => {
      let charAt = String.fromCharCode(65 + i)
      obj[charAt] = x.total
    })

    costing.girlsWearing.agreedQuote = costing.girlsWearing.agreedQuote.map((x, i) => {
      if (i == index) {
        x = Number(value)
        return x
      }
      return Number(x)
    }
    )

    costing.girlsWearing.agreedQuoteAvg = costing.girlsWearing.agreedQuote.reduce(
      (ac, c, i) => {
        return Number(ac) + Number(c) * Number([obj[Object.keys(obj)[i]]])
      },
      0
    )
    costing.girlsWearing.agreedQuoteAvg = (
      Number(costing.girlsWearing.agreedQuoteAvg) / Number(groupTotal)
    ).toFixed(2)

    this.setState({ costing })
  }

  openPrint = val => {
    let costingPrint = JSON.parse(JSON.stringify(this.state.costingPrint))
    this.setState(
      {
        costingPrint,
        printLoading: true
      },
      () => {
        var divToPrint = document.getElementById(val)
        var newWin = window.open("", "mywindow")
        newWin.document.write(divToPrint.outerHTML)
        this.onPrintFinished(newWin.print())
        newWin.close()
      }
    )
  }

  onPrintFinished = () => {
    if (this.state.action !== "view") {
      this.props.history.push("/CostingPage", {
        action: this.state.action,
        _id: this.state._id
      })
    }
    // setTimeout(() => document.location.reload(true), 100)
  }
  toggleChange = (name, value) => {
    let costing = { ...this.state.costing }
    costing.toggle[name] = value
    if (value == false) {
      costing[`${name === "embellishment" && "embelishment" || name}TotalCost`] = 0.0
      if (name === "trim") {
        costing.trimPackTotalCost = 0.0
        costing.trimPack = {}
      } else if (name === "embroidery") {
        costing.backing = []
        costing.embroideryBacking = false
        costing.bitAttaching = false
        costing.backingTotalCost = 0.0
      }
      if (Array.isArray(costing[name])) {
        costing[name] = []
      } else {
        costing[name] = {}
      }
      this.setState({ costing }, () => this.updateCostTotal())
    } else {
      costing[name] = []
      this.setState({ costing }, () => this.updateCostTotal())
    }
    if (name === 'girlsWearing' && this.state.costing.customer) {
      if (value == true) {
        this._handleCustDeptChange(null, this.state.costing.customer, this.state.costing.customerDepartmentId)
      }
    }
  }

  toggleModal = () => {
    this.setState({
      modalToggle: true
    })
  }

  closeModal = () => {
    this.setState({
      modalToggle: false
    })
  }

  goToDiv = moduleName => {
    var ele = document.getElementById(moduleName)
    ele.scrollIntoView({ behavior: "smooth", block: "center" })
  }

  //customer and department select
  _handleCustDeptChange = (name, customer, customerDepartmentId) => {
    let costing = { ...this.state.costing }
    costing.customer = customer
    costing.customerDepartmentId = customerDepartmentId
    // setTimeout(() => {
    //   this.setState({ costing })
    // }, 10)
    if (customer) {
      CustomerServices.getCustomer(customer).then(res => {
        if (res.status === 200) {
          let result = res.text.data.departments
          result = result.find(x => x._id.toString() === customerDepartmentId)
          costing.manufacturingAndPieceCost.fixedCharge =
            costing.manufacturingAndPieceCost.fixedCharge ||
            Number(res.text.data.fabricBasicRequirements.fixedCharge).toFixed(2) ||
            "0.00"
          if (result.priceQuoteMethod === "SINGLE") {
            let fabricSizeList =
              result.priceQuotesizeSingle && result.priceQuotesizeSingle.length > 0
                ? result.priceQuotesizeSingle
                  .filter(x => Boolean(x.size))
                  .map(x => ({
                    label: x.period && `${x.size} ${x.period}`.trim() || x.size,
                    value: x.period && `${x.size} ${x.period}`.trim() || x.size
                  }))
                : []
              ; (costing.girlswear = false),
                this.setState({
                  // costing,
                  fabricSizeList
                })
          } else {
            if (this.state.action === "add" || (Array.isArray(costing.girlsWearing) && !costing.girlsWearing.length || !costing.girlsWearing)) {
              // costing.toggle.girlsWearing = true
              girlsTable = []
              let girlsWearing = []
              result.priceQuotesizeMultiple.forEach((x, i) => {
                let obj = {}
                obj.name = `${x.start}-${x.end}${x.period ? x.period.toUpperCase() : ""
                  }`
                let table = []
                for (let j = Number(x.start); j <= Number(x.end); j++) {
                  table.push({
                    to: j,
                    value: 0
                  })
                }
                obj.values = table
                obj.total = obj.values.reduce((x, ac) => {
                  return x + (ac.value || 0)
                }, 0)
                girlsWearing.push(obj)
              })

              costing.girlsWearing.grouping = girlsWearing
              costing.girlsWearing.groupTotal = girlsWearing.reduce((x, ac) => {
                return x + (ac.total || 0)
              }, 0)
            }

            let fabricSizeList =
              result.priceQuotesizeMultiple &&
                result.priceQuotesizeMultiple.length > 0
                ? result.priceQuotesizeMultiple.map(x => x.start && ({
                  label: x.end && `${x.start + "-" + x.end} ${x.period || ''}`.trim() || (x.start),
                  value: x.end && `${x.start + "-" + x.end} ${x.period || ''}`.trim() || (x.start)
                }))
                : []
            this.setState({
              // costing,
              // girlswearData,
              isLoading: false,
              fabricSizeList
            })
          }

          if (result.trimPack && result.trimPack.length > 0) {
            let trimPackList = result.trimPack.map(x => ({
              label: x.trimPackNo,
              value: x.trimPackNo
            }))
            if (costing.trimPack && !costing.trimPack.totalAmount) {
              tempTrimPack = result.trimPack.map((x) => {
                x.price = x.totalAmount
                x.consumption = (x.consumption && Number(x.consumption).toFixed(2)) || "0.00"
                return x
              })
              let trPack = result.trimPack.find(x => x.default == true)
              console.log(result.trimPack, "trPacktrPack");
              console.log(trPack, "trPacktrPack");
              if (trPack && trPack.price) {
                trPack.price = Number(trPack.price).toFixed(2)
              } else {
                trPack = { price: '0.00' }
              }
              costing.trimPack = trPack
            }
            this.setState({
              trimPackList
            })
          }
        }
      }).then(() => {
        console.log("here","trPacktrPack");
        this.setState({
          costing
        })
      }).catch((err) => {
        this.props.getalertMessage("error", err.text.message)
      })
    } else {
      console.log(costing.trimPack, "trPacktrPack");
      this.setState({
        costing
      })
    }
  }

  _handleInputChange = (name, value) => {
    let costing = { ...this.state.costing }
    if (name === "sampleRequestId") {
      this.changeSampleNo(value)
    } else {
      costing[name] = value
      this.setState({
        costing
      })
    }
  }

  getFabricNumber = (value, i) => {
    DevelopmentServices.getFabricNumber(value)
      .then(response => {
        if (response.status == 200) {
          let costing = this.state.costing
          costing.fabric[i].fabricList = response.text.data
          this.setState({ costing })
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  // getValueLoss = (value, i) => {
  //   // if (!value) {
  //   //   // Clear the search-specific options when input is empty
  //   //   this.setState({ valueLossSearch: [] });
  //   //   return;
  //   // }
  
  //   SystemServices.getValueLoss(value)
  //     .then(response => {
  //       if (response.status === 200) {
  //         let costing = {...this.state.costing};
  //         costing.fabric[i].valueLossList = response.text.data;
  //         this.setState({ costing });
  //       }
  //     });
  // };
  // getEmbValueLoss = (value, i) => {
  //   // if (!value) {
  //   //   // Clear the search-specific options when input is empty
  //   //   this.setState({ valueLossSearch: [] });
  //   //   return;
  //   // }
  
  //   SystemServices.getValueLoss(value)
  //     .then(response => {
  //       if (response.status === 200) {
  //         let costing = {...this.state.costing};
  //         costing.fabric[i].EmbValueLossList = response.text.data;
  //         this.setState({ costing });
  //       }
  //     });
  // };

  // getValueLoss = (inputValue, index) => {
  //   SystemServices.getValueLoss(inputValue)
  //     .then(response => {
  //       if (response.status === 200) {
  //         const fetchedOptions = response.text.data || [];
  //         const { costing } = this.state;
  
  //         // Retain the currently selected value for the row
  //         const currentValue = costing.fabric[index].valueLoss;
  //         const currentOption = currentValue
  //           ? { value: currentValue, label: currentValue }
  //           : null;
  
  //         // Merge current selection with fetched options (if not already included)
  //         const updatedOptions = currentOption && !fetchedOptions.some(option => option.value === currentValue)
  //           ? [currentOption, ...fetchedOptions]
  //           : fetchedOptions;
  
  //         this.setState({ valueLoss: updatedOptions });
  //       }
  //     });
  // };

  //other cost module start
  addOtherCost = () => {
    let costing = { ...this.state.costing }
    costing.otherCostDetails.push({
      label: "",
      value: "0.00"
    })
    this.setState({
      costing
    })
  }

  removeOtherCost = index => {
    let costing = { ...this.state.costing }
    costing.otherCostDetails[index].totalCost = 0
    costing.otherTotalCost = Number(costing.otherCostDetails.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0)).toFixed(2)
    costing.otherCostDetails = costing.otherCostDetails.filter((d, i) => index !== i)
    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  updateOtherCostdetails = (name, value, index) => {
    let costing = { ...this.state.costing }
    costing.otherCostDetails[index][name] = value

    if (name === "value") {
      let otherTotalCost = costing.otherCostDetails.reduce(
        (arr, cur) => (cur.value ? arr + Number(cur.value) : arr + 0),
        0
      )
      costing.otherTotalCost = otherTotalCost.toFixed(2)
    }

    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  //

  //Trim Pack

  getTrimPack = (customer, customerDepartmentId) => {
    CostingServices.getTrimPackByCustomer(customer, customerDepartmentId)
      .then(async response => {
        if (response.status == 200) {
          if (Object.keys(response.text.data).length) {
            let costing = { ...this.state.costing }
            let trimPackList = response.text.data.map(x => ({
              label: x.trimPackNo,
              value: x.trimPackNo
            }))
            tempTrimPack = response.text.data

            if (this.state.action !== 'add') {
              if (costing.trimPack && costing.trimPack.trimPackNo)

                tempTrimPack.map((x) => {
                  if (x.trimPackNo === costing.trimPack.trimPackNo) {
                    x.consumption = costing.trimPack.consumption
                  }
                })
            } else {
              costing.trimPack = response.text.data.find(x => x.default == true)
            }
            setTimeout(() => {
              this.setState({
                trimPackList,
                costing
              })
            }, 100)
          }
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  updateTrimPack = (name, val) => {
    let costing = this.state.costing
    if (name === "trimPackList") {
      let trimPackList = this.state.trimPackList
      tempTrimPack = tempTrimPack.map(x => {
        x.default = false
        if (x.trimPackNo === val) {
          x.default = true
          let consumption = costing.trimPack.consumption
            ? costing.trimPack.consumption
            : 0.0
          costing.trimPack = x
          costing.trimPack.consumption = consumption
          costing.trimPackTotalCost = (
            (costing.trimPack.price ? Number(costing.trimPack.price) : 0.0) *
            (costing.trimPack.consumption
              ? Number(costing.trimPack.consumption)
              : 0.0)
          ).toFixed(2)
          costing.trimTotalCost = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing.trim.reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
        }
        return x
      })
    }
    this.setState({
      costing
    })
  }

  getFabric = (value, index) => {
    let costing = { ...this.state.costing }
    costing.fabric[index].fabricNumber = value !== null ? value.value : null
    this.setState({
      costing
    })
  }

  //update values of modules

  updateValModules = (name, value, index, keyName) => {
    // embroideryData.stitchesMtr
    let costing = { ...this.state.costing }
    costing[keyName][index][name] = value
    if (name === "embForm") {
      costing[keyName][index].priceForStitches = this.state.embFormList.find(
        x => x.label === value
      ).price
      if (value.toLowerCase() === 'panel') {
        costing[keyName][index].stitchesMtr = ""
        costing[keyName][index].consumption = ""
      }
    }
    if (
      (keyName === "embroidery" && name === "consumption") ||
      (keyName === "embroidery" && name === "stitchesMtr")
    ) {
      let consumption = costing.embroidery[index].consumption
        ? costing.embroidery[index].consumption
        : 0
      let stitches = costing.embroidery[index].stitchesMtr
        ? costing.embroidery[index].stitchesMtr
        : 0
      costing.embroidery[index].stitchCount = (consumption * stitches).toFixed(
        2
      )
    }
    this.setState(
      {
        costing
      },
      () => {
        this.calcTotalCost(name, value, index, keyName)
        // this.updateCostTotal()
      }
    )
  }

  calcTotalCost = (name, value, index, keyName) => {
    let costing = { ...this.state.costing }
    if (keyName === "embroidery") {
      costing[keyName][index][name] = value
      let stitchCount = costing[keyName][index].stitchCount
        ? costing[keyName][index].stitchCount
        : 0
      let priceForStitches = costing[keyName][index].priceForStitches
        ? costing[keyName][index].priceForStitches
        : 0
      costing[keyName][index].totalCost =
        (Number(stitchCount) * Number(priceForStitches)) / 1000
      costing[`${keyName}TotalCost`] = costing[keyName].reduce((arr, cur) => (cur.totalCost ? arr + Number(cur.totalCost) : arr + 0), 0).toFixed(2)
      setTimeout(() => {
        this.setState(
          {
            costing
          },
          () => {
            this.updateCostTotal(),
              this.landedCalc("shipmentTerm", costing.landedData.toValue)
          }
        )
      }, 500)
    } else if (keyName === "trimPack") {
      costing[keyName][name] = value
      costing.trimTotalCost = costing.trimTotalCost - costing.trimPackTotalCost
      costing.trimPackTotalCost = (
        (costing[keyName].price ? Number(costing[keyName].price) : 0.0) *
        (costing[keyName].consumption
          ? Number(costing[keyName].consumption)
          : 0.0)
      ).toFixed(2)
      costing.trimTotalCost = Number(
        Number(costing.trimTotalCost) + Number(costing.trimPackTotalCost)
      ).toFixed(2)
      this.setState(
        {
          costing
        },
        () => {
          this.updateCostTotal(),
            this.landedCalc("shipmentTerm", costing.landedData.toValue)
        }
      )
    } else {
      costing[keyName][index][name] = value
      // const consumption = costing[keyName][index].consumption || 0
      // const price = costing[keyName][index].price || 0
      // const greige = costing[keyName][index].greige || 0
      // const gst = costing[keyName][index].gst || 0
      // costing[keyName][index].totalCost = consumption * greige * price % gst
      let totalCost;
      const consumption = parseFloat(costing[keyName][index].consumption) || 0;
      // const gst = parseFloat(costing[keyName][index].gst) || this.state.gst || 0;
      if(costing[keyName][index].emb){
        const embCost = parseFloat(costing[keyName][index].embCost);
        const greige = parseFloat(costing[keyName][index].greige) || 0;
        const valueLossData = this.state.valueLoss.find(data => data.value === costing[keyName][index].valueLoss);
        const valueLoss = valueLossData ? parseFloat(valueLossData.label) || 1 : 1;
        //console.log(valueLoss,"valueloss")
        const embValueLossData = this.state.valueLoss.find(data => data.value === costing[keyName][index].EmbValueLoss);
        const embValueLoss = embValueLossData ? parseFloat(embValueLossData.label) || 1 : 1;
        //console.log(embValueLoss,"emb")
        const dyingPrintData = this.state.dyingPrint.find(data => data.value === costing[keyName][index].dyingPrint);
        const dyingPrint = dyingPrintData ? parseFloat(dyingPrintData.label) || 0 : 0;
        const upChargeData = this.state.upCharge.find(data => data.value === costing[keyName][index].upcharge);
        const upCharge = upChargeData ? parseFloat(upChargeData.label) || 0 : 0;
        const gst = parseFloat(this.state.gst) || 0;
        // Emb Calculation
        const greVal = greige/valueLoss;
        //console.log(greVal);
        const greEmbVal = greVal+embCost;
        //console.log(greEmbVal);
        const embVal = greEmbVal/embValueLoss;
        //console.log(embVal);
        const dyingPrintVal =embVal+dyingPrint;
        //console.log(dyingPrintVal,"dyingPrintVal");
        const upChargeVal = dyingPrintVal*upCharge/100;
        //console.log(upChargeVal,"upChargeVal");
        const finalUpcharge = upChargeVal+dyingPrintVal;
        //console.log(finalUpcharge,"finalUpcharge");
        const gstCal = finalUpcharge*gst/100;
        //console.log(gstCal,"gstCal");

        // const baseCost = (((greige / valueLoss) + (embCost / valueLoss) + dyingPrint) % gst) +
        // ((greige / valueLoss) + (embCost / valueLoss) + dyingPrint);
        // const roundedBaseCost = Math.ceil(baseCost);
        const baseCost = gstCal+finalUpcharge;
        //console.log("baseCost", baseCost);
        //const roundedBaseCost = Math.ceil(baseCost);
        const roundedBaseCost = parseFloat(baseCost.toFixed(2));
        if (isNaN(roundedBaseCost)) {
          costing[keyName][index].price = 0.00;
          totalCost = 0.00;
        } else {
          costing[keyName][index].price = roundedBaseCost;
          totalCost = roundedBaseCost * consumption;
        }
        // costing[keyName][index].price = roundedBaseCost;
        // //console.log(costing[keyName][index].price,"price")
        // totalCost = roundedBaseCost * consumption;
      }else if(costing[keyName][index].yarn){
        const yarnDyedValue = parseFloat(costing[keyName][index].yardDyedCost);
         const gst = parseFloat(this.state.gst) || 0;
         const upChargeData = this.state.upCharge.find(data => data.value === costing[keyName][index].upcharge);
         const upCharge = upChargeData ? parseFloat(upChargeData.label) || 0 : 0;
         const upChargeVal = yarnDyedValue*upCharge/100;
         const finalUpcharge = upChargeVal+yarnDyedValue;
         const ydValue = finalUpcharge*gst/100
        const baseCost = ydValue+finalUpcharge;
        //const roundedBaseCost = Math.ceil(baseCost);
        const roundedBaseCost = parseFloat(baseCost.toFixed(2));
        if (isNaN(roundedBaseCost)) {
          costing[keyName][index].price = 0.00;
          totalCost = 0.00;
        } else {
          costing[keyName][index].price = roundedBaseCost;
          totalCost = roundedBaseCost * consumption;
        }
        // costing[keyName][index].price = roundedBaseCost;
        // totalCost = roundedBaseCost * consumption;
      }// Greige case
      else if (costing[keyName][index].greige) {
        const greige = parseFloat(costing[keyName][index].greige) || 0;
        const valueLossData = this.state.valueLoss.find(data => data.value === costing[keyName][index].valueLoss);
        const valueLoss = valueLossData ? parseFloat(valueLossData.label) || 1 : 1;
        const dyingPrintData = this.state.dyingPrint.find(data => data.value === costing[keyName][index].dyingPrint);
        const dyingPrint = dyingPrintData ? parseFloat(dyingPrintData.label) || 0 : 0;
        const gst = parseFloat(this.state.gst) || 0;
        const upChargeData = this.state.upCharge.find(data => data.value === costing[keyName][index].upcharge);
        const upCharge = upChargeData ? parseFloat(upChargeData.label) || 0 : 0;

        const greVal = greige/valueLoss;
        //console.log(greVal,"greVal");
        const dyingPrintVal = greVal+dyingPrint;
        //console.log(dyingPrintVal,"dyingPrintVal");
        const upChargeVal = dyingPrintVal*upCharge/100;
        //console.log(upChargeVal,"upChargeVal");
        const finalUpcharge = upChargeVal+dyingPrintVal;
        //console.log(finalUpcharge,"finalUpcharge");
        const gstVal = finalUpcharge*gst/100;
        //console.log(gstVal,"gstVal");


        // Greige calculation
        const baseCost = gstVal+finalUpcharge;
        //console.log("baseCost", baseCost);
        //const roundedBaseCost = Math.ceil(baseCost);
        const roundedBaseCost = parseFloat(baseCost.toFixed(2));
        // costing[keyName][index].price = roundedBaseCost;
        // totalCost = roundedBaseCost * consumption;
        if (isNaN(roundedBaseCost)) {
          costing[keyName][index].price = 0.00;
          totalCost = 0.00;
        } else {
          costing[keyName][index].price = roundedBaseCost;
          totalCost = roundedBaseCost * consumption;
        }
      }
      // Default case
      else {
        const price = parseFloat((costing[keyName][index].price)) || 0;

        // Default calculation (simple multiplication of consumption and price)
        totalCost = consumption * price;
      }
      // console.log(greige, valueLoss, dyingPrint, gst, consumption, price,baseCost.toFixed(2), "costing")
      // console.log(totalCost,"totalCost")
    
      // Update the totalCost in the state
      costing[keyName][index].totalCost = totalCost.toFixed(2);

      //costing[`${keyName}TotalCost`] = costing[keyName].reduce((arr, cur) => (cur.totalCost ? arr + cur.totalCost : arr + 0), 0 ) .toFixed(2)
      if (keyName === "trim") {
        //costing[`${keyName}TotalCost`] = Number((Number(costing.trimPackTotalCost) || 0) + Number(costing[keyName].reduce((arr, cur) => (cur.totalCost || 0) + arr, 0))).toFixed(2)
        costing[`${keyName}TotalCost`] = Number(
          (Number(costing.trimPackTotalCost) || 0) + 
          Number(
            Array.isArray(costing[keyName])
              ? costing[keyName].reduce(
                  (arr, cur) => arr + (cur && cur.totalCost ? Number(cur.totalCost) : 0), 
                  0
                )
              : 0
          )
        ).toFixed(2);
        
      } else {
        costing[`${keyName}TotalCost`] = Number(
          costing[keyName].reduce((arr, cur) => (Number(cur.totalCost) || 0) + arr, 0)
        ).toFixed(2)
      }
      this.setState(
        {
          costing
        },
        () => {
          this.updateCostTotal(),
            this.landedCalc("shipmentTerm", costing.landedData.toValue)
        }
      )
    }
  }

  updateValMod = (name, value, keyName) => {
    let costing = { ...this.state.costing }
    costing[keyName][name] = value
    this.setState({
      costing
    })
  }

  //update main
  updateMain = (name, value) => {
    let costing = { ...this.state.costing }
    costing[name] = value
    this.setState({
      costing
    })
  }

  landedCalc = (name, value) => {
    let costing = { ...this.state.costing }

    if (name === "shipmentTerm") {
      let { usdTotal } = { ...this.state.costing }
      let {
        conversionRate,
        freightCharges,
        duty,
        processingCost
      } = { ...this.state.costing.landedData }
      let toValue = value,
        rateValue = usdTotal / Number(conversionRate),
        freightChargesTotal = rateValue + Number(freightCharges),
        dutyValue = freightChargesTotal * Number(duty),
        processValue = dutyValue + Number(processingCost)

      costing.landedData = {
        ...costing.landedData,
        toValue: toValue,
        rateValue: rateValue.toFixed(2),
        freightChargesTotal: freightChargesTotal.toFixed(2),
        dutyValue: dutyValue.toFixed(2),
        processValue: processValue.toFixed(2),
        totalLandedValue: processValue.toFixed(2)
      }
      costing.shipmentTerm = value
    }

    this.setState(
      {
        costing
      },
      () => this.toQuate()
    )
  }

  overheadValueLossCalculator(e) {
    const costing = { ...this.state.costing }
    const { name, value } = e.target
    costing.manufacturingAndPieceCost[name] = value

    this.setState(
      {
        costing
      },
      () => this.updateCostTotal()
    )
  }

  landedWorkingCalculation = e => {
    let landedData = { ...this.state.costing.landedData }
    if (e && e.target) {
      const { name, value } = e.target
      landedData[name] = Number(value).toFixed(3)
    }
    // let { usdTotal } = this.state.costing;
    let Total = 0
    let sectdCurncy = this.state.costing.selectedConversion
    Total = this.state.costing[`${sectdCurncy}Total`]
    let { conversionRate, freightCharges, duty, processingCost } = landedData
    let toValue = this.state.costing.shipmentTerm,
      rateValue = Total / Number(conversionRate),
      freightChargesTotal = rateValue + Number(freightCharges),
      dutyValue = freightChargesTotal * Number(duty),
      processValue = dutyValue + Number(processingCost)

    landedData = {
      ...landedData,
      toValue: toValue,
      rateValue: rateValue.toFixed(2),
      freightChargesTotal: freightChargesTotal.toFixed(2),
      dutyValue: dutyValue.toFixed(2),
      processValue: processValue.toFixed(2),
      totalLandedValue: processValue.toFixed(2)
    }

    // costing.shipmentTerm = value
    this.setState(
      {
        costing: {
          ...this.state.costing,
          landedData
        }
      },
      () => this.toQuate()
    )
  }

  checkValidation = () => {
    if (this.validateArrayObject(this.state.costing, "costingType", null)) {
      this.createCosting();
      return true
    } else {
      this.props.getalertMessage("error", "Please select a Costing Type", 6000);
      return false
    }

  }

  validateArrayObject(data, key, val) {
    let values = data[key] !== val ? true : false
    return values
  }

  currencyConverter = e => {
    const { name, value } = e.target
    let costing = this.state.costing
    let toCurrencyConversion = value
    costing.toCurrencyConversion = toCurrencyConversion
    this.setState({ costing })
  }

  calConsumPrice = () => {
    setTimeout(() => {
      let costing = this.state.costing
      let trimPackTotalCost = costing.trimPack
        ? Number(costing.trimPack.price ? costing.trimPack.price : 0.0) *
        Number(
          costing.trimPack.consumption ? costing.trimPack.consumption : 0.0
        )
        : 0.0
      if (!!costing.fabric) {
        costing.fabric.forEach((x, i) => {
          this.calcTotalCost(null, null, i, "fabric")
        })
      }

      if (!!costing.embellishment) {
        costing.embellishment.forEach((x, i) => {
          this.updateEmbellishment(null, null, i)
        })
      }

      // if (!!costing.smockingSheering) {
      //   costing.smockingSheering.forEach((x, i) => {
      //     this.updateSmockingSheering(null, null, i)
      //   })
      // }

      if (!!costing.trim) {
        costing.trim.forEach((x, i) => {
          this.calcTotalCost(null, null, i, "trim")
        })
      }

      if (!!costing.embroidery) {
        costing.embroidery.forEach((x, i) => {
          this.calcTotalCost(null, null, i, "embroidery")
        })
      }

      if (!!costing.wash) {
        costing.wash.forEach((x, i) => {
          this.updateWash(null, null, i)
        })
      }
      costing.trimPackTotalCost = trimPackTotalCost.toFixed(2)

      this.setState({ costing, isLoading: false })
    }, 500)
  }

  changeToDecimal = (e, i, keyName) => {
    let costing = this.state.costing
    const { name, value } = e.target
    if (!value || value === '0.00') {
      this.props.getalertMessage("info", "Provide Valid Entry", 9000)
      if (i) {
        costing[keyName][i][name] = parseFloat("0").toFixed(2)
      } else {
        costing[keyName][name] = parseFloat("0").toFixed(2)
      }
    } else {
      if (i != null) {
        costing[keyName][i][name] = Number(value).toFixed(2)
      } else {
        costing[keyName][name] = Number(value).toFixed(2)
      }
    }
    this.setState({
      costing
    })
  }

  selectedConversion = e => {
    let { name, value } = e.target
    let costing = { ...this.state.costing }
    costing.selectedConversion = name
    costing.toCurrencyConversion = (name === "euro" && "eur") || name
    costing.landedPrice = costing[`${name}Total`]
    this.setState(
      {
        costing
      },
      () => this.landedWorkingCalculation()
    )
  }

  changeCMT = e => {
    if (e.target.value) {
      let costing = { ...this.state.costing }
      costing.manufacturingAndPieceCost.CMT = e.target.value
      costing.manufacturingAndPieceCost.CMTSelected =
        costing.manufacturingAndPieceCost.CMT ===
          costing.manufacturingAndPieceCostDetails.revTailer
          ? "2800"
          : costing.manufacturingAndPieceCost.CMT ===
            costing.manufacturingAndPieceCostDetails.revMachine
            ? "1750"
            : ""
      this.setState({ costing }, () => this.updateCostTotal())
    }
  }
  leaveCostingPage = obj => {
    const { nextPage } = obj
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="p-5 text-center">
            <h1>Are you sure?</h1>
            <p>You want to Leave this page?</p>
            <button type="button" class="primary" style={{ width: "20%" }} onClick={onClose}>
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={() => {
                this.setState({
                  costingPageLeave: true
                })
                if (this.checkValidation()) {
                  setTimeout(() => {
                    nextPage()
                    onClose()
                  }, 1000)
                } else {
                  onClose()
                }
              }}
            >
              Yes
            </button>
          </div>
        )
      },
      closeOnClickOutside: true
    })
  }
  confirmDuplicate = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className=" p-5 text-center">
            <button onClick={() => onClose()} className="close">X</button>
            <h3>Do you want to create a duplicate Costing sheet?</h3>
            {/* <p>Are you sure you would like to Duplicate?</p> */}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={onClose}
            >
              No
            </button>{" "}
            <button
              type="button"
              class="primary"
              style={{ width: "20%" }}
              onClick={() => {
                this.dumpState();
                onClose();
              }}
            >
              Yes
            </button>
          </div>
        );
      },
      closeOnClickOutside: true
    });
  };

  dumpState = () => {
    CostingServices.costingNumber()
      .then(response => {
        if (response.status == 200) {
          let costing = { ...this.state.costing }
          costing.costingNumber = response.text.data.costingNumber
          costing.createdAt = new Date()
          costing.orderDate = new Date()
          delete costing._id
          this.setState({
            costing,
            action: "add",
            _id: ""
          })
          this.props.getalertMessage("success", "Costing Sheet Successfully Duplicated!", 4000);
        } else if (response.status == 401) {
          this.props.unauthorisedFunc()
        } else {
          this.props.getalertMessage("error", response.text.message)
        }
      })
      .catch(error => this.props.getalertMessage("error", error.toString()))
  }

  goBackCosting = () => {
    let { action } = { ...this.state }
    if (action !== "view") {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <div className="p-5 text-center">
              <button onClick={() => onClose()} className="close">X</button>
              <h1>You are about to leave this page</h1>
              <p>Would you like to save before exiting?</p>
              <button
                type="button"
                class="primary"
                style={{ width: "20%" }}
                onClick={() => {
                  this.props.history.push({
                    pathname: "/list",
                    state: {
                      moduleName: 'COSTING',
                      type: "list"
                    }
                  })
                  onClose()
                  // if (this.state.goBack >= -1) {
                  //   this.props.history.goBack()
                  // } else {
                  //   this.props.history.go(this.state.goBack)
                  //   onClose()
                  // }
                }}
              >
                No
              </button>{" "}
              <button
                type="button"
                class="primary"
                style={{ width: "20%" }}
                onClick={() => {
                  if (this.checkValidation()) {
                    setTimeout(() => {
                      // this.props.history.goBack()
                      this.props.history.push({
                        pathname: "/list",
                        state: {
                          moduleName: 'COSTING',
                          type: "list"
                        }
                      })
                      onClose()
                    }, 1000)
                  } else {
                    onClose()
                  }
                }}
              >
                Yes
              </button>
            </div>
          )
        },
        closeOnClickOutside: true
      })
    } else {
      this.props.history.goBack()
    }

  }

  curSymbol = (data) => {
    switch (data) {
      case "usd":
        return "$"
      case "gbp":
        return "£"
      case "eur":
        return "€"
      default:
        return "$"
    }
  }

  setTitle = (value, arr) => {
    if (value) {
      return arr.find(x => x.value === value).label
    }
  }

  preventSpecialChars = (e) => {
    const invalidChars = ['-', '+', 'e', 'E', '.']; 
    if (invalidChars.includes(e.key)) {
      e.preventDefault(); // Prevent these characters from being entered
    }
  };
  // handleCurrencyChange = (e, currency) => {
  //   let costing = { ...this.state.costing };
  //   costing.currencyConversion[currency] = e.target.value; // Update the specific currency value
  //   this.setState({ costing });
  // };
  handleCurrencyChange = (e, currency) => {
    const value = e.target.value;
    // this.setState(prevState => ({
    //   costing: {
    //     ...prevState.costing,
    //     currencyConversion: {
    //       ...prevState.costing.currencyConversion,
    //       [currency]: value // Update the specific currency
    //     }
    //   }
    // }), () => {
    //   this.convertOthers();
    // });
  //   if (this.state.action === "add") {
  //     // Update both currencies and costing.currencyConversion in "add" mode
  //     this.setState(prevState => ({
  //       currencies: {
  //         ...prevState.currencies,
  //         [currency]: value // Update the specific currency in currencies
  //       },
  //       costing: {
  //         ...prevState.costing,
  //         currencyConversion: {
  //           ...prevState.costing.currencyConversion,
  //           usd: prevState.currencies.usd,  // Ensure we keep the existing usd, gbp, and eur
  //           gbp: prevState.currencies.gbp,
  //           eur: prevState.currencies.eur,
  //           [currency]: value // Update the specific currency in currencyConversion
  //         }
  //       }
  //     }), () => {
  //       this.convertOthers(); // Recalculate after updating both currencies and currencyConversion
  //     });
  //   } else if (this.state.action === "edit") {
  //     // Update only costing.currencyConversion when in "edit" mode
  //     this.setState(prevState => ({
  //       costing: {
  //         ...prevState.costing,
  //         currencyConversion: {
  //           ...prevState.costing.currencyConversion,
  //           usd: prevState.costing.currencyConversion.usd || prevState.currencies.usd,  // Ensure usd is kept or fallback to currencies
  //           gbp: prevState.costing.currencyConversion.gbp || prevState.currencies.gbp,
  //           eur: prevState.costing.currencyConversion.eur || prevState.currencies.eur,
  //           [currency]: value // Update the specific currency
  //         }
  //       }
  //     }), () => {
  //       this.convertOthers(); // Recalculate after updating currencyConversion
  //     });
  //   }
  // };
    this.setState(prevState => {
      const currencyConversion = prevState.costing.currencyConversion || {}; // Fallback to an empty object if undefined

      return {
          currencies: {
              ...prevState.currencies,
              [currency]: value // Update the specific currency in currencies
          },
          costing: {
              ...prevState.costing,
              currencyConversion: {
                  ...currencyConversion,
                  usd: currencyConversion.usd || prevState.currencies.usd, // Maintain existing USD or fallback to currencies
                  gbp: currencyConversion.gbp || prevState.currencies.gbp, // Maintain existing GBP or fallback to currencies
                  eur: currencyConversion.eur || prevState.currencies.eur, // Maintain existing EUR or fallback to currencies
                  [currency]: value // Update the specific currency in currencyConversion
              }
          }
      };
  }, this.convertOthers); // Call convertOthers after setting the state
  };

  optionChange = index => {
    let costing = { ...this.state.costing }
    costing.fabricTotalCost = Number(
      costing.fabric.reduce((arr, cur) => arr + (Number(cur.totalCost) || 0), 0)
  ).toFixed(2);    //console.log(costing.fabricTotalCost,"fabrictotal")
    this.setState({
      costing
    },
      () => this.updateCostTotal())
  }
  

  handleTypeChange = (index, type) => {
    // const updatedFabrics = this.state.costing.fabric.map((fabric, idx) => {
    //   if (idx === index) {
    //     return {
    //       ...fabric,
    //       emb: type === 'emb',  // Set emb to true if 'emb' is selected
    //       yarn: type === 'yarn', // Set yarn to true if 'yarn' is selected
    //       greigeset : type === 'greigeset'
    //     };
    //   }
    //   return fabric; // Ensure all other fabrics remain unchanged
    // });
  
    // this.setState(prevState => ({
    //   costing: {
    //     ...prevState.costing,
    //     fabric: updatedFabrics
    //   },
    // }));
    this.setState(prevState => {
      const updatedFabric = [...prevState.costing.fabric];
  
      // Reset all values and set only the selected type
      updatedFabric[index] = {
        ...updatedFabric[index],
        emb: type === 'emb',
        yarn: type === 'yarn',
        greigeset: type === 'greigeset',
        
        // Clear all other fields
        greige: null,
        valueLoss: null,
        embCost: null,
        EmbValueLoss: null,
        dyingPrint: null,
        upcharge: null,
        yardDyedCost: null,
        price:0,
        totalCost:0,
        gst:this.state.gst,
      };
  
      return {
        costing: {
          ...prevState.costing,
          fabric: updatedFabric
        }
      };
    },()=>{
      this.optionChange();
    });
  };  

  renderDynamicHeaders = (fabric) => {
    return(
    <tr className="border-bottom-0">
                        <th className="border-bottom-0 text-center" width="13%">
                          Fabric no
                        </th>
                        <th className="border-bottom-0 text-center" width="10%">
                          Count &amp; construction
                        </th>
                        <th className="border-bottom-0 text-center" width="10%">
                          Quality / Classification
                        </th>
                        <th className="border-bottom-0 text-center" width="9%">
                          Supplier
                        </th>
                        <th className="border-bottom-0 text-center" width="9%">
                          Position
                        </th>
                        <th className="border-bottom-0 text-center" width="8%">
                          Marker
                        </th>
                        <th className="border-bottom-0 text-center" width="11%">
                          Print-Direction
                        </th>
                        <th className="border-bottom-0" width="7%">
                          Size
                        </th>
                        <th className="border-bottom-0" width="6%">
                          Width
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          Consumption
                        </th>
                        

                        {/* <th className="border-bottom-0 text-center" width="5%">&nbsp;GST&nbsp;</th> */}
                        <th className="border-bottom-0 text-center" width="5%">
                          Price(INR)
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          Total(INR)
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addFabric()}
                          />
                        </th>
                      </tr>)
  }

  renderConditionalHeaders = (fabric) => {
    return(
      <tr className="border-bottom-0">
        <th className="border-bottom-0 text-center" width="5%">
                          Type
                        </th>
                        {/* Render specific headers based on the fabric type of this specific row */}
                        {fabric.emb && (
                          <React.Fragment>
                            <th className="border-bottom-0 text-center" width="5%">Greige</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">Emb</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">Dying/Print</th>
                            <th className="border-bottom-0 text-center" width="5%">Up-Charge%</th>
                            <th className="border-bottom-0 text-center" width="5%">&nbsp;GST&nbsp;</th>
                          </React.Fragment>
                        )}
                        {fabric.yarn && (
                          <React.Fragment>
                          <th className="border-bottom-0 text-center" width="5%">Yarn</th>
                          <th className="border-bottom-0 text-center" width="5%">Up-Charge%</th>
                          <th className="border-bottom-0 text-center" width="5%">&nbsp;GST&nbsp;</th>
                          </React.Fragment>
                        )}
                        {fabric.greigeset && (
                          <React.Fragment>
                            <th className="border-bottom-0 text-center" width="5%">Greige</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">Dying/Print</th>
                            <th className="border-bottom-0 text-center" width="5%">Up-Charge%</th>
                            <th className="border-bottom-0 text-center" width="5%">&nbsp;GST&nbsp;</th>
                          </React.Fragment>
                        )}
      </tr>
    )
  }

  renderFabricRow = (fabric, index) => {
    return (
      <tr>
                          <td className="border-top-0">
                            <div className="custom-async-select inline-external">
                              <Async
                                name="fabricNumber"
                                value={fabric.fabricNumber}
                                onInputChange={val =>
                                  this.getFabricNumber(val, index)
                                }
                                onChange={val => this.getFabricInfo(val, index)}
                                placeholder="fabric"
                                options={
                                  fabric.fabricList ? fabric.fabricList : []
                                }
                                disabled={this.state.disabled}
                                onSelectResetsInput={false}
                                onBlurResetsInput={false}
                              />
                            </div>
                            <img
                              className={"external-link cursor-hover"}
                              src={externalLink}
                              onClick={
                                () => {
                                  if (fabric.fabricNumber) {
                                    let action = this.state.action !== "add" && this.state.action || "edit";
                                    let search = "?" + new URLSearchParams({
                                      action: action,
                                      _id: fabric.fabricNumber,
                                    }).toString()
                                    window.open(`/developmentFabric${search}`, "_blank")
                                  }
                                }
                                // this.props.history.push(
                                //   "/developmentFabric",
                                //   {
                                //     action: this.state.action !== "add" && this.state.action || "edit",
                                //     _id: fabric.fabricNumber,
                                //     costingpage: { ...this.state },
                                //     route: "CostingPage"
                                //   }
                                // )
                              }
                            />
                          </td>
                          <td className="border-top-0">
                            {fabric.countAndConstruction}
                          </td>
                          <td className="border-top-0">
                            {fabric.qualityClassification}
                          </td>
                          <td className="border-top-0">
                            {fabric.supplierName}
                            <img
                              className={"external-link cursor-hover"}
                              src={selectLink}
                              onClick={() => {
                                this.getSupplierSectionList(
                                  fabric.fabricNumber,
                                  "fabric"
                                ),
                                  this.setState({
                                    fabricIndex: index
                                  })
                              }}
                            />
                          </td>
                          <td className="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="fabricPosition"
                              value={fabric.fabricPosition}
                              options={this.state.positionList || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                            <Field
                              //title={fabric.marker && this.setTitle(fabric.marker, this.state.markerList) || ""}
                              isFormGroup={false}
                              inputType="select"
                              inputName="marker"
                              value={fabric.marker}
                              options={this.state.markerList || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                            <Field
                              // title={(fabric.printDirection && this.state.printDirectionList) && this.setTitle(fabric.printDirection, this.state.printDirectionList) || ""}
                              isFormGroup={false}
                              inputType="select"
                              inputName="printDirection"
                              value={fabric.printDirection}
                              options={this.state.printDirectionList || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="size"
                              style={{ width: "100%" }}
                              value={fabric.size}
                              options={this.state.fabricSizeList || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                            <input
                              style={{ width: "80%" }}
                              type="text"
                              name={"width"}
                              value={fabric.width}
                              onChange={e =>
                                this.updateValModules(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                            <input
                              type="number"
                              className={"consumption-field"}
                              name="consumption"
                              style={{ width: "80%" }}
                              value={fabric.consumption}
                              disabled={this.state.disabled}
                              onChange={e =>
                                this.calcTotalCost(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              onBlur={e =>
                                this.changeToDecimal(e, index, "fabric")
                              }
                            />
                            <span
                              style={{ maxWidth: "20%", fontSize: ".55rem" }}
                            >
                              /mts
                            </span>
                          </td>
                          

                          
                          
                          {/* <td className="border-top-0">
                            <input
                              style={{ width: "100%" }}
                              type="text"
                              name={"gst"}
                              value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
                              onChange={e =>
                                this.updateValModules(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td> */}
                          <td className="border-top-0">
                            <input
                              type="number"
                              className={"consumption-field"}
                              style={{ width: "80%" }}
                              name={"price"}
                              value={fabric.price}
                              disabled={this.state.disabled}
                              onChange={e =>
                                this.calcTotalCost(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              onBlur={e =>
                                this.changeToDecimal(e, index, "fabric")
                              }
                            />
                            <span
                              style={{ maxWidth: "20%", fontSize: ".55rem" }}
                            >
                              /mts
                            </span>
                          </td>
                          <td className="border-top-0">
                            <NumberField
                              value={
                                fabric.totalCost
                                  ? Number(fabric.totalCost).toFixed(2)
                                  : 0.0
                              }
                              name={"totalCost"}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled
                            />
                          </td>
                          <td className="border-top-0">
                            <ButtonIcon
                              buttonType={"remove"}
                              addRemoveFunc={() => this.removeFabric(index)}
                            />
                          </td>
                        </tr>
    
    )
  }

  renderConditionalFabricRow = (fabric,index) => {
    return(
      <tr>
        <td>
                          <select
                            value={fabric.emb ? 'emb' : fabric.yarn ? 'yarn' : fabric.greigeset ? 'greigeset' :''} 
                            onChange={e => this.handleTypeChange(index, e.target.value)}
                            style={{ width: "80%" }}
                          >
                            <option value="">--select--</option> // Dummy default option
                            <option value="greigeset">Normal</option>
                            <option value="emb">Embroidery</option>
                            <option value="yarn">Yarn Dyed</option>
                          </select>
                        </td>
                        {fabric.emb && (
                            <React.Fragment>
                              
                              <td className="border-top-0">
                                <input
                                  type="number"
                                  className={"consumption-field"}
                                  name="greige"
                                  style={{ width: "80%" }}
                                  value={fabric.greige || ""}
                                  // onChange={e => this.updateValModules('greige', e.target.value, index, "fabric")}
                                  onChange={e => {
                                    let value = e.target.value;
                                
                                    // Check if the input is a valid number with up to two decimal places
                                    const regex = /^\d*\.?\d{0,2}$/;
                                    if (regex.test(value)) {
                                      // Update state only if the value is valid
                                      this.updateValModules('greige', value, index, "fabric");
                                    }
                                  }}
                                  onBlur={e =>
                                    this.changeToDecimal(e, index, "fabric")
                                  }
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td className="border-top-0">
                                <Field
                                  // className="rowWidth"
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="valueLoss"
                                  value={fabric.valueLoss||""}
                                  options={this.state.valueLoss || []} // Update with actual options for value loss
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                              {/* <Async
                                name="valueLoss"
                                value={fabric.valueLoss}
                                // value={
                                //   fabric.valueLoss
                                //     ? { value: fabric.valueLoss, label: fabric.valueLoss }
                                //     : null
                                // }
                                onInputChange={val =>
                                  this.getValueLoss(val, index)
                                }
                                //onChange={val => this.getFabricInfo(val, index)}
                              //   onChange={val => {
                              //     let costing = { ...this.state.costing };
                              //     costing.fabric[index].valueLoss = val ? val.value : null; 
                              //     this.setState({ costing });
                              // }}
                              // onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                              onChange={val => {
                                this.updateValModules("valueLoss", val ? val.value : null, index, "fabric");
                              }}
                                placeholder="Value Loss"
                                options={
                                  fabric.valueLossList ? fabric.valueLossList : []
                                }
                                // options={this.state.valueLossSearch.length > 0
                                //   ? this.state.valueLossSearch // Show search-specific options if available
                                //   :Array.isArray(this.state.valueLoss) ? this.state.valueLoss : []}
                                disabled={this.state.disabled}
                                onSelectResetsInput={false}
                                onBlurResetsInput={false}
                              /> */}
                              </td>
                              <td className="border-top-0">
                                <input
                                  type="number"
                                  className={"consumption-field"}
                                  name="emb"
                                  style={{ width: "80%" }}
                                  value={fabric.embCost || ""} 
                                  onChange={e => this.updateValModules('embCost', e.target.value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td className="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="EmbValueLoss"
                                  value={fabric.EmbValueLoss || ""}
                                  options={this.state.valueLoss || []} // Update with actual options for value loss
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                                {/* <Async
                                name="EmbValueLoss"
                                value={fabric.EmbValueLoss}
                                onInputChange={val =>
                                  this.getEmbValueLoss(val, index)
                                }
                                //onChange={val => this.getFabricInfo(val, index)}
                              //   onChange={val => {
                              //     let costing = { ...this.state.costing };
                              //     costing.fabric[index].valueLoss = val ? val.value : null; 
                              //     this.setState({ costing });
                              // }}
                              // onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                              onChange={val => {
                                this.updateValModules("EmbValueLoss", val ? val.value : null, index, "fabric");
                              }}
                                placeholder="Value Loss"
                                options={
                                  fabric.EmbValueLossList ? fabric.EmbValueLossList : []
                                }
                                // options={this.state.valueLossSearch.length > 0
                                //   ? this.state.valueLossSearch // Show search-specific options if available
                                //   :Array.isArray(this.state.valueLoss) ? this.state.valueLoss : []}
                                // disabled={this.state.disabled}
                                onSelectResetsInput={false}
                                onBlurResetsInput={false}
                              /> */}
                              </td>
                              <td className="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="dyingPrint"
                                  value={fabric.dyingPrint || ""}
                                  options={this.state.dyingPrint || []} // Update with actual options
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td className="border-top-0">
                              <Field
                                  // className="rowWidth"
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="upcharge"
                                  value={fabric.upcharge||""}
                                  options={this.state.upCharge || []} // Update with actual options for value loss
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                            </td>
                              <td className="border-top-0">
                            <input
                              style={{ width: "80%" }}
                              type="text"
                              name={"gst"}
                              // value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
                              value={this.state.gst}
                              onChange={e =>
                                this.updateValModules(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={true}
                            />
                          </td>
                            </React.Fragment>
                          )}

                          {fabric.yarn && (
                            <React.Fragment>
                              <td className="border-top-0">
                                <input
                                  type="number"
                                  className={"consumption-field"}
                                  name="yardDyedCost"
                                  style={{ width: "80%" }}
                                  value={fabric.yardDyedCost} // Assuming you have a field for Yarn value
                                  onChange={e => this.updateValModules('yardDyedCost', e.target.value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td className="border-top-0">
                              {/* <input
                                style={{ width: "80%" }}
                                type="text"
                                name={"upCharge"}
                                value="20%"
                                onChange={e =>
                                  this.updateValModules(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "fabric"
                                  )
                                }
                                disabled
                              /> */}
                              <Field
                                  // className="rowWidth"
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="upcharge"
                                  value={fabric.upcharge||""}
                                  options={this.state.upCharge || []} // Update with actual options for value loss
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                            </td>
                              <td className="border-top-0">
                            <input
                              style={{ width: "80%" }}
                              type="text"
                              name={"gst"}
                              // value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
                              value={this.state.gst}
                              onChange={e =>
                                this.updateValModules(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={true}
                            />
                          </td>
                            </React.Fragment>
                          )}
                          {fabric.greigeset && (
                            <React.Fragment>
                          <td className="border-top-0">
                            <input
                              type="number"
                              className={"consumption-field"}
                              name="greige"
                              style={{ width: "80%" }}
                              value={fabric.greige|| ""}
                              disabled={this.state.disabled}
                              // onChange={e =>
                              //   this.calcTotalCost(
                              //     e.target.name,
                              //     e.target.value,
                              //     index,
                              //     "fabric"
                              //   )
                              // }
                              onChange={e => {
                                let value = e.target.value;
                            
                                // Check if the input is a valid number with up to two decimal places
                                const regex = /^\d*\.?\d{0,2}$/;
                                if (regex.test(value)) {
                                  // Update state only if the value is valid
                                  this.updateValModules('greige', value, index, "fabric");
                                }
                              }}
                              onBlur={e =>
                                this.changeToDecimal(e, index, "fabric")
                              }
                            />
                            {/* <span
                              style={{ maxWidth: "20%", fontSize: ".55rem" }}
                            >
                              /mts
                            </span> */}
                          </td>
                          <td className="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="valueLoss"
                              value={fabric.valueLoss|| ""}
                              options={this.state.valueLoss || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />

                              {/* <Async
                                name="valueLoss"
                                value={fabric.valueLoss}
                                // value={
                                //   fabric.valueLoss
                                //     ? { value: fabric.valueLoss, label: fabric.valueLoss }
                                //     : null
                                // }
                                onInputChange={val =>
                                  this.getValueLoss(val, index)
                                }
                                //onChange={val => this.getFabricInfo(val, index)}
                              //   onChange={val => {
                              //     let costing = { ...this.state.costing };
                              //     costing.fabric[index].valueLoss = val ? val.value : null; 
                              //     this.setState({ costing });
                              // }}
                              // onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                              onChange={val => {
                                this.updateValModules("valueLoss", val ? val.value : null, index, "fabric");
                              }}
                                placeholder="Value Loss"
                                options={
                                  fabric.valueLossList ? fabric.valueLossList : []
                                }
                                // options={this.state.valueLossSearch.length > 0
                                //   ? this.state.valueLossSearch // Show search-specific options if available
                                //   :Array.isArray(this.state.valueLoss) ? this.state.valueLoss : []}
                                disabled={this.state.disabled}
                                onSelectResetsInput={false}
                                onBlurResetsInput={false}
                              /> */}
                          </td>
                          <td className="border-top-0">
                            <Field
                              isFormGroup={false}
                              inputType="select"
                              inputName="dyingPrint"
                              value={fabric.dyingPrint|| ""}
                              options={this.state.dyingPrint || []}
                              onChange={(name, value) =>
                                this.updateValModules(
                                  name,
                                  value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td className="border-top-0">
                          <Field
                                  // className="rowWidth"
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="upcharge"
                                  value={fabric.upcharge||""}
                                  options={this.state.upCharge || []} // Update with actual options for value loss
                                  onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                                  disabled={this.state.disabled}
                                />
                          </td>
                          <td className="border-top-0">
                            <input
                              style={{ width: "80%" }}
                              type="text"
                              name={"gst"}
                              // value={fabric.gst !== null && fabric.gst !== undefined ? fabric.gst : this.state.gst}
                              value={this.state.gst}
                              onChange={e =>
                                this.updateValModules(
                                  e.target.name,
                                  e.target.value,
                                  index,
                                  "fabric"
                                )
                              }
                              disabled={true}
                            />
                          </td>
                          </React.Fragment>
                          )}
      </tr>
    )
  }

  render() {
    const { costing } = this.state
    const { toggle } = this.state.costing
    let girlsWearing = this.state.costing.girlsWearing
    // console.log(costing,"costing")
    return (
      <Fragment>
        <div className="right-section" id={"costingColr"}>
          <div className="row bg-white nopadding">
            {this.state.isLoading && <Loading />}
            <div className="costing-wraper">
              {/* title section of right section */}
              <div className="col-md-12 no-padding d-flex align-items-center mt-1">
                <div className="col-md-6 no-padding text-right">
                  <h6 className="mb-0 text-color-green font-weight-bold">
                    COSTING
                  </h6>
                </div>
                <div className="col-md-6 no-padding">
                  <Audit
                    _id={this.state._id}
                    moduleName={"Costingid"}
                    fontSize={"14px"}
                  />
                  {/* <button
                    type="button"
                    className="primary pull-right px-2 py-1 mr-3"
                  >
                    <i className="fa fa-pencil-square-o font-size" />
                  </button>
                  <button
                    type="button"
                    className="primary pull-right px-2 py-1 mr-3"
                  // onClick={() => this.toggleModal()}
                  >
                    <i className="fa fa-calendar-check-o font-size" />
                  </button>
                  <button
                    type="button"
                    className="primary pull-right px-2 py-1 mr-3"
                  >
                    <i className="fa fa-download font-size" />
                  </button> */}
                  <button
                    type="button"
                    className="primary pull-right px-2 py-1 mr-3"
                    onClick={e => {
                      // this.checkValidation()
                      this.setState({ isLoading: true })
                      setTimeout(() => {
                        this.updateCostingPrintValues()
                        setTimeout(() => {
                          this.setState({ isLoading: false })
                          this.openPrint("printCosting")
                        }, 3000)
                      }, 2000)
                    }}
                  // onClick={e => this.openPrint("printCosting")}
                  >
                    <i className="fa fa-print font-size" />
                  </button>
                </div>
              </div>
              <div className="col-md-12 no-padding">
                <div className="col-md-6 p-0 my-0 d-flex justify-content-start">
                  <span
                    className="p-2 cursor-hover text-left mr-3"
                    onClick={() => {
                      this.goBackCosting()

                    }}
                    title="Go Back"
                  >
                    <img width={"20px"} src={leftArrowImage} />
                  </span>
                  <div className="form-group p-0 my-1">
                    <div className="custom-async-select">
                      <Field
                        className={"py-0 my-0"}
                        isFormGroup={true}
                        inputType="text"
                        inputName="costingNumber"
                        label="Costing ID"
                        value={this.state.costing.costingNumber}
                        onChange={this._handleInputChange}
                        disabled={this.state.disabled || true}
                      />
                    </div>
                  </div>
                  <div className="form-group p-0 my-1 mx-2">
                    <div className="custom-async-select">
                      <label className="">Date Created</label>
                      <p>{moment(this.state.costing.orderDate).format("HH:mm DD MMM YYYY")}</p>
                    </div>
                  </div>
                </div>
              </div>
              {/* Magnum second section */}
              <div className="col-md-12 p-0">
                <div className="col-md-1 p-0 my-0">
                  <div className="form-group py-0 my-0">
                    <label for="no">Mag Style No/Ref</label>
                    {/* <label for="no">Costing ID</label> */}
                    <div className="custom-async-select">
                      <Async

                        name="styleReferenceId"

                        value={costing.styleReferenceId}
                        onInputChange={e => this.getMagnumStyleNo(e)}
                        onChange={this.changeStyleNo}
                        placeholder="Find Style No"
                        options={this.state.styleNoInfo}
                        disabled={this.state.disabled}
                        onSelectResetsInput={false}
                        onBlurResetsInput={false}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-md-7 pl-0 py-0 my-0">
                  <div className="col-md-12 p-0">
                    <div className="col-sm-5">
                      <Field
                        className={"py-0 my-0"}
                        isFormGroup={true}
                        inputType="text"
                        inputName="magnumStyleName"
                        label="Mag Style Name"
                        value={costing.magnumStyleName}
                        onChange={this._handleInputChange}
                        disabled={this.state.disabled || true}
                      />
                    </div>
                    <div className="col-md-4 p-0 pr-1">
                      <div className="col-md-12">
                        <Field
                          className={"py-0 my-0"}
                          isFormGroup={true}
                          inputType="text"
                          inputName="customerName"
                          label="Customer / Department"
                          value={costing.customerName}
                          onChange={this._handleInputChange}
                          disabled={true}
                        />
                      </div>
                      {/* <div className="col-md-2 p-0 pt-4">
                        <span
                          className="view"
                          style={{ cursor: "pointer" }}
                          title={`View ${costing.customerName || "customer"}`}
                          onClick={() =>
                            costing.customer && this.props.history.push("/CustomerPage", {
                              action: "view",
                              _id: costing.customer,
                            }) || ''
                          }
                        ><i class="material-icons">visibility</i></span>
                      </div> */}
                      {/* <CustomerDeptSelect
                        options={this.state.customerList}
                        value={`${costing.customer}-${costing.customerDepartmentId}`}
                        onChange={this._handleCustDeptChange}
                        disabled={true}
                        className={" py-0 my-0"}
                        notMandate={true}
                      /> */}
                    </div>
                    <div className="col-md-3 px-0">
                      <div className="form-group  py-0 my-0">
                        <label for="no">Sample Request No</label>
                        <div className="custom-async-select">
                          <Async
                            name="sampleRequestId"
                            value={costing.sampleRequestId}
                            onInputChange={e => this.getSampleRqNo(e)}
                            onChange={this.changeSampleNo}
                            placeholder="Find Sample"
                            options={this.state.sampleRequestNumbersList}
                            disabled={this.state.disabled}
                            onSelectResetsInput={false}
                            onBlurResetsInput={false}
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-md-2 py-0 my-0">
                  <Field
                    className={"py-0 my-0"}
                    isFormGroup={true}
                    inputType="text"
                    inputName="customerRefNumber"
                    label="Customer Ref No."
                    value={costing.customerRefNumber}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled || true}
                  />
                </div>
                <div className="col-md-2 py-0 my-0">
                  <Field
                    isFormGroup={true}
                    className={"py-0 my-0"}
                    inputType="select"
                    inputName="costingType"
                    label="Costing Type*"
                    options={this.state.costingTypeList}
                    value={costing.costingType}
                    onChange={this._handleInputChange}
                    disabled={this.state.disabled}
                  />
                </div>
              </div>
              <div className="col-md-12 no-padding">
                <ul
                  className="nav-locator add-cost-li m-0 "
                  style={{ width: "100%" }}
                >
                  {Object.keys(toggle).map(keyName => {
                    return (
                      <li style={{ width: "14.2857142857%" }}>
                        <Field
                          className={"py-0 my-0"}
                          isFormGroup={true}
                          inputType="checkboxToggle"
                          inputName={keyName}
                          value={toggle[keyName]}
                          label={
                            keyName === "girlsWearing"
                              ? "Girls wear"
                              : keyName === "smockingSheering"
                                ? "Smocking/Shirring"
                                : keyName
                          }
                          onChange={this.toggleChange}
                          disabled={this.state.disabled}
                        />
                      </li>
                    )
                  })}
                </ul>
              </div>
              
              <table className="costingtable" id="fabric">
                <tbody>
                  {toggle.fabric && (
                    <Fragment>
                      {/* Fabric module start */}
                      <ModuleHeader header={"Fabric Cost Details"} />

                      { this.state.costing.fabric.length === 0 ? (
                        <tr className="border-bottom-0">
                        <th className="border-bottom-0 text-center" width="13%">
                          Fabric no
                        </th>
                        <th className="border-bottom-0 text-center" width="10%">
                          Count &amp; construction
                        </th>
                        <th className="border-bottom-0 text-center" width="10%">
                          Quality / Classification
                        </th>
                        <th className="border-bottom-0 text-center" width="9%">
                          Supplier
                        </th>
                        <th className="border-bottom-0 text-center" width="9%">
                          Position
                        </th>
                        <th className="border-bottom-0 text-center" width="8%">
                          Marker
                        </th>
                        <th className="border-bottom-0 text-center" width="11%">
                          Print-Direction
                        </th>
                        <th className="border-bottom-0" width="7%">
                          Size
                        </th>
                        <th className="border-bottom-0" width="6%">
                          Width
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          Consumption
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          Type
                        </th>
                        {/* Render specific headers based on the fabric type of this specific row */}
                        {/* {fabric.emb && (
                          <React.Fragment>
                            <th className="border-bottom-0 text-center" width="5%">Greige</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">&nbsp;&nbsp;Emb&nbsp;&nbsp;&nbsp;</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">Dying/Print</th>
                          </React.Fragment>
                        )}
                        {fabric.yarn && (
                          <th className="border-bottom-0 text-center" width="5%">Yarn</th>
                        )}
                        {fabric.greigeset && (
                          <React.Fragment>
                            <th className="border-bottom-0 text-center" width="5%">Greige</th>
                            <th className="border-bottom-0 text-center" width="10%">Value&nbsp;Loss</th>
                            <th className="border-bottom-0 text-center" width="5%">Dying/Print</th>
                          </React.Fragment>
                        )} */}

                        {/* <th className="border-bottom-0 text-center" width="5%">&nbsp;GST&nbsp;</th> */}
                        <th className="border-bottom-0 text-center" width="5%">
                          Price(INR)
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          Total(INR)
                        </th>
                        <th className="border-bottom-0 text-center" width="5%">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addFabric()}
                          />
                        </th>
                      </tr>) : (
                        <React.Fragment>
                      {this.state.costing.fabric.map((fabric, index) => (
                        <table key={`table-${index}`} className="costingtable" style={{ marginBottom: '25px' }} id={`fabric-table-${index}`}>
                          <thead style={{ borderBottom: 'none' }}>{this.renderDynamicHeaders(fabric, index)}</thead>
                          <tbody>{this.renderFabricRow(fabric, index)}</tbody>
                          <thead style={{ borderBottom: 'none' }}>{this.renderConditionalHeaders(fabric, index)}</thead>
                          <tbody>{this.renderConditionalFabricRow(fabric, index)}</tbody>
                        </table>
                      ))}
                    <tr style={{
                      display: 'flex',
                      justifyContent: 'flex-end',
                      marginRight: '25px'
                    }}>
  
                      <TotalCostRow
                        colSpan="11"
                        moduleName={"Fabric"}
                        totalCostValue={costing.fabricTotalCost || "0.00"}
                        name={"fabricTotalCost"}
                        onChange={(name, value) => this.updateMain(name, value)}
                      />
                      </tr>
                      </React.Fragment>
                      )}
                    </Fragment>
                  )}
                </tbody>
              </table>
              {toggle.trim && (
                <Fragment>
                  <span id="trim"></span>
                  <ModuleHeader header={"Trim Cost Details"} />
                  <table className="costingtable">
                    <tbody>
                      <tr className="border-bottom-0">
                        <th className="border-bottom-0" width="15%">
                          Trim Category
                        </th>
                        <th className="border-bottom-0" width="15%">
                          Trim Ref no
                        </th>
                        <th className="border-bottom-0" width="15%">
                          Description
                        </th>
                        <th className="border-bottom-0" width="10%">
                          Quality
                        </th>
                        <th className="border-bottom-0" width="20%">
                          Supplier
                        </th>
                        <th className="border-bottom-0" width="10%">
                          Size
                        </th>
                        <th className="border-bottom-0">Consp/ unit</th>
                        <th className="border-bottom-0">Price / unit</th>
                        <th>
                          <Totalheader />
                        </th>
                        <th className="border-bottom-0">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addTrim()}
                          />
                        </th>
                      </tr>
                      {costing.trimPack && costing.trimPack.trimPackNo !== "" && (
                        <tr className="">
                          <td className="font-weight-bold">Trims Pack</td>
                          <td title="Trimpack no">
                            <span className="py-2 d-block">
                              <Field
                                isFormGroup={false}
                                inputType="select"
                                inputName="trimPackList"
                                value={costing.trimPack.trimPackNo}
                                options={this.state.trimPackList}
                                onChange={this.updateTrimPack}
                                disabled={this.state.disabled}
                              />
                            </span>
                          </td>
                          <td title="Type of GMT">
                            {costing.trimPack.typeOfGmt}
                          </td>
                          <td title="Packaging Method">
                            {costing.trimPack.packagingMethod}
                          </td>
                          <td title="Packing Type">
                            {costing.trimPack.packingType}
                          </td>
                          <td title="Sub Type">{costing.trimPack.subType}</td>
                          <td title="Consumption">
                            <input
                              type="number"
                              className={"consumption-field"}
                              style={{ width: "4rem" }}
                              name={"consumption"}
                              value={costing.trimPack.consumption}
                              disabled={this.state.disabled}
                              onChange={e =>
                                this.calcTotalCost(
                                  e.target.name,
                                  e.target.value,
                                  null,
                                  "trimPack"
                                )
                              }
                              onBlur={e =>
                                this.changeToDecimal(e, null, "trimPack")
                              }
                            />
                            <span
                              style={{ maxWidth: "20%", fontSize: ".55rem" }}
                            >
                              /pack
                            </span>
                          </td>
                          <td title="Price">
                            <input
                              type="number"
                              style={{ width: "4rem" }}
                              className={"consumption-field"}
                              name={"price"}
                              value={costing.trimPack.price}
                              disabled={this.state.disabled}
                              onChange={e =>
                                this.calcTotalCost(
                                  e.target.name,
                                  e.target.value,
                                  null,
                                  "trimPack"
                                )
                              }
                              onBlur={e =>
                                this.changeToDecimal(e, null, "trimPack")
                              }
                            />
                            <span
                              style={{ maxWidth: "20%", fontSize: ".55rem" }}
                            >
                              /pack
                            </span>
                          </td>
                          <td>
                            <NumberField
                              name={"trimPackTotalCost"}
                              value={costing.trimPackTotalCost || 0.00}
                              // onChange={this.updateTotalCost}
                              disabled={true}
                            />
                          </td>
                        </tr>
                      )}
                      {costing.trim.map((trim, index) => {
                        return (
                          <tr>
                            <td className="">
                              <Field
                                isFormGroup={false}
                                inputType="select"
                                inputName="trimCategory"
                                value={trim.trimCategory}
                                index={index}
                                options={this.state.trimCategoryList}
                                onChange={this.updateTrim}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td className="">
                              <div className="custom-async-select inline-external">
                                <Async
                                  name="trimNumber"
                                  value={trim.trimNumber}
                                  onInputChange={value =>
                                    this.getTrimRefNo(
                                      trim.trimCategory,
                                      value,
                                      index,
                                      "trim"
                                    )
                                  }
                                  onChange={value =>
                                    this.getTrimInfo(value, index, "trim")
                                  }
                                  placeholder="Find trimRefNo"
                                  options={trim.trimList ? trim.trimList : []}
                                  disabled={this.state.disabled}
                                  onSelectResetsInput={false}
                                  onBlurResetsInput={false}
                                />
                              </div>
                              <img
                                className={"external-link cursor-hover"}
                                src={externalLink}
                                onClick={
                                  () => {
                                    if (trim.trimNumber) {
                                      let action = this.state.action !== "add" && this.state.action || "edit";
                                      let search = "?" + new URLSearchParams({
                                        action: action,
                                        _id: trim.trimNumber,
                                      }).toString()
                                      window.open(`/Trim${search}`, "_blank")
                                    }
                                  }
                                  // this.props.history.push(
                                  //   "/Trim",
                                  //   {
                                  //     action: this.state.action !== "add" && this.state.action || "edit",
                                  //     _id: trim.trimNumber,
                                  //     costingpage: { ...this.state },
                                  //     route: "CostingPage"
                                  //   }
                                  // )
                                  // () =>
                                  //   this.leaveCostingPage({
                                  //     nextPage: () => {
                                  //       this.props.history.push("/Trim", {
                                  //         action: "edit",
                                  //         _id: trim.trimNumber
                                  //       })
                                  //     }
                                  //   })
                                  // this.props.history.push("/Trim", {
                                  //   action: "edit",
                                  //   _id: trim.trimNumber
                                  // })
                                }
                              />
                            </td>
                            <td className="">
                              <p className="pt-3">{trim.description}</p>
                            </td>
                            <td className="">
                              <p className="pt-3">{trim.quality}</p>
                            </td>
                            <td className="">
                              {trim.supplierName}
                              <img
                                className={"external-link cursor-hover d-inline"}
                                src={selectLink}
                                onClick={() => {
                                  this.getSupplierSectionList(
                                    trim.trimNumber,
                                    "trim"
                                  ),
                                    this.setState({
                                      trimIndex: index
                                    })
                                }}
                              />
                              {/* <span
                                className="custom-height-button-btn"
                                onClick={() =>
                                  this.getSupplierSecData(trim._id)
                                }
                              /> */}
                            </td>
                            <td className="">
                              <p className="pt-3">{trim.size}</p>
                            </td>
                            <td className="">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"consumption"}
                                value={trim.consumption}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.calcTotalCost(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "trim"
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "trim")
                                }
                              />
                              <span title={trim.unit}
                                style={{ maxWidth: "20%", fontSize: trim.unit.length >= 5 && ".40rem" || trim.unit.length <= 3 && ".7rem" || "0.55rem", fontWeight: trim.unit.length >= 5 && "900" || "normal" }}
                              >
                                /{trim.unit || "Pack"}
                              </span>
                            </td>
                            <td className="">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"price"}
                                value={trim.price}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.calcTotalCost(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "trim"
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "trim")
                                }
                              />
                              <span title={trim.unit}
                                style={{ maxWidth: "20%", fontSize: trim.unit.length >= 5 && ".40rem" || trim.unit.length <= 3 && ".7rem" || "0.55rem", fontWeight: trim.unit.length >= 5 && "900" || "normal" }}
                              >
                                /{trim.unit || "Pack"}
                              </span>
                            </td>
                            <td>
                              <NumberField
                                // style={{ width: "100%" }}
                                name={"totalCost"}
                                value={
                                  trim.totalCost
                                    ? Number(trim.totalCost).toFixed(2)
                                    : 0.0
                                }
                                onChange={(name, value) =>
                                  this.updateValModules(
                                    name,
                                    value,
                                    index,
                                    "trim"
                                  )
                                }
                                disabled={true}
                              />
                            </td>
                            <td className="">
                              <ButtonIcon
                                buttonType={"remove"}
                                addRemoveFunc={() => this.removeTrim(index)}
                              />
                            </td>
                          </tr>
                        )
                      })}
                      <TotalCostRow
                        colSpan="8"
                        moduleName={"Trim"}
                        totalCostValue={costing.trimTotalCost}
                        name={"trimTotalCost"}
                        onChange={(name, value) => this.updateMain(name, value)}
                      />
                    </tbody>
                  </table>
                </Fragment>
              )}
              <table className="costingtable" id="smockingshirring">
                <tbody>
                  {toggle.smockingSheering && (
                    <Fragment>
                      <ModuleHeader header={"Smocking/Shirring"} />
                      <tr className="border-bottom-0">
                        <th className="border-bottom-0" width="15%">
                          Trim Category
                        </th>
                        <th className="border-bottom-0" width="20%">
                          Trim Ref No
                        </th>
                        <th className="border-bottom-0" width="10%">
                          Placement
                        </th>
                        <th className="border-bottom-0" width="15%">
                          Type
                        </th>
                        <th className="border-bottom-0" width="10%">
                          No of Rows
                        </th>
                        <th className="border-bottom-0" width="10%">
                          Length In Mtr
                        </th>
                        {/* <th className="border-bottom-0" /> */}
                        <th></th>
                        <th></th>
                        <th></th>
                        <th className="border-bottom-0" width="13%">
                          Total Reqrd-Mtrs
                        </th>
                        <th className="border-bottom-0" width="5%">
                          Price/mtrs
                        </th>
                        <Totalheader />
                        <th className="border-bottom-0" width="10%">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addSmocking()}
                          />
                        </th>
                      </tr>
                      {costing.smockingSheering.map(
                        (smockingSheering, index) => {
                          return (
                            <tr>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="trimCategory"
                                  value={smockingSheering.trimCategory}
                                  index={index}
                                  options={this.state.trimCategoryList}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <div className="custom-async-select inline-external">
                                  <Async
                                    name="trimNumber"
                                    value={smockingSheering.trimNumber}
                                    onInputChange={value =>
                                      this.getTrimRefNo(
                                        smockingSheering.trimCategory,
                                        value,
                                        index,
                                        "smockingSheering"
                                      )
                                    }
                                    onChange={value =>
                                      this.getTrimInfo(
                                        value,
                                        index,
                                        "smockingSheering"
                                      )
                                    }
                                    placeholder="Find trimRefNo"
                                    options={
                                      smockingSheering.trimList
                                        ? smockingSheering.trimList
                                        : []
                                    }
                                    disabled={this.state.disabled}
                                    onSelectResetsInput={false}
                                    onBlurResetsInput={false}
                                  />
                                </div>
                                <img
                                  className={"external-link cursor-hover"}
                                  src={externalLink}
                                  onClick={
                                    () =>
                                      this.props.history.push(
                                        "/Trim",
                                        {
                                          action: this.state.action !== "add" && this.state.action || "edit",
                                          _id: smockingSheering.trimNumber,
                                          costingpage: { ...this.state },
                                          route: "CostingPage"
                                        }
                                      )
                                    // () =>
                                    //   this.leaveCostingPage({
                                    //     nextPage: () => {
                                    //       this.props.history.push("/Trim", {
                                    //         action: "edit",
                                    //         _id: smockingSheering.trimNumber
                                    //       })
                                    //     }
                                    //   })
                                    // this.props.history.push("/Trim", {
                                    //   action: "view",
                                    //   _id: smockingSheering.trimNumber
                                    // })
                                  }
                                // onClick={() =>
                                //   this.props.history.push("/Trim", {
                                //     action: "view",
                                //     _id: smockingSheering.trimNumber
                                //   })
                                // }
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="placement"
                                  index={index}
                                  value={smockingSheering.placement}
                                  options={this.state.trimPlacementList}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="type"
                                  value={smockingSheering.type}
                                  index={index}
                                  options={[
                                    {
                                      label: "Both Elastic",
                                      value: "Both Elastic"
                                    },
                                    {
                                      label: "Top TTH / Bottom Elastic",
                                      value: "Top TTH / Bottom Elastic"
                                    }
                                  ]}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td>
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="noOfRow"
                                  value={smockingSheering.noOfRow}
                                  index={index}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td className="border-top-0">
                                <Field
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="length"
                                  index={index}
                                  value={smockingSheering.length}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled}
                                />
                              </td>
                              <td></td>
                              <td></td>
                              <td></td>
                              <td className="border-top-0 ml-5">
                                <Field
                                  style={{
                                    width: "4rem",
                                    marginTop: "0",
                                    marginBottom: "0",
                                    marginRight: "auto",
                                    marginLeft: "auto"
                                  }}
                                  isFormGroup={false}
                                  inputType="number"
                                  inputName="totalReq"
                                  index={index}
                                  value={smockingSheering.totalReq}
                                  onChange={this.updateSmockingSheering}
                                  disabled={this.state.disabled || true}
                                />
                              </td>
                              <td className="border-top-0">
                                <input
                                  type="number"
                                  className={"consumption-field"}
                                  style={{
                                    width: "4rem",
                                    marginTop: "0",
                                    marginBottom: "0",
                                    marginRight: "auto",
                                    marginLeft: "auto"
                                  }}
                                  name={"price"}
                                  value={smockingSheering.price}
                                  disabled={this.state.disabled}
                                  onChange={e =>
                                    this.updateSmockingSheering(
                                      e.target.name,
                                      e.target.value,
                                      index
                                    )
                                  }
                                  onBlur={e =>
                                    this.changeToDecimal(
                                      e,
                                      index,
                                      "smockingSheering"
                                    )
                                  }
                                />
                                <span style={{ maxWidth: "20%" }}>/Mts</span>
                              </td>
                              <td>
                                <NumberField
                                  name={"totalCost"}
                                  value={
                                    smockingSheering.totalCost
                                      ? Number(
                                        smockingSheering.totalCost
                                      ).toFixed(2)
                                      : 0.0
                                  }
                                  // onChange={this.updateTotalCost}
                                  disabled={true}
                                />
                              </td>
                              <td>
                                <ButtonIcon
                                  buttonType={"remove"}
                                  addRemoveFunc={() =>
                                    this.removeSmocking(index)
                                  }
                                />
                              </td>
                            </tr>
                          )
                        }
                      )}
                      {/* <TotalCostRow moduleName={"Smocking"} totalCostValue={"44"} /> */}
                      <TotalCostRow
                        colSpan="11"
                        moduleName={"Smocking"}
                        totalCostValue={costing.smockingSheeringTotalCost}
                        name={"smockingSheeringTotalCost"}
                        onChange={(name, value) => this.updateMain(name, value)}
                      />
                    </Fragment>
                  )}
                </tbody>
              </table>
              <table className="costingtable" id="embroidery">
                <tbody>
                  {toggle.embroidery && (
                    <Fragment>
                      {/* <ModuleHeader header={"Embroidery Cost Details"} /> */}
                      <tr>
                        <td className="border-bottom-0 text-left" colSpan={"2"}>
                          <h6 className="mb-0 text-primary font-weight-bold">
                            {"Embroidery Cost Details"}
                          </h6>
                        </td>
                        <td>backing</td>
                        <td>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="embroideryBacking"
                            className="my-0 py-0"
                            value={this.state.costing.embroideryBacking}
                            // label="backing"
                            onChange={() => {
                              let costing = this.state.costing
                              costing.embroideryBacking = !this.state.costing
                                .embroideryBacking
                              this.setState({
                                costing: costing
                              })
                            }}
                            disabled={this.state.disabled}
                          />
                        </td>
                        <td>bit attaching</td>
                        <td>
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="bitAttaching"
                            className="my-0 py-0"
                            value={this.state.costing.bitAttaching}
                            onChange={() => {
                              let costing = this.state.costing
                              costing.bitAttaching = !this.state.costing
                                .bitAttaching
                              this.setState({
                                costing: costing
                              })
                            }}
                            disabled={this.state.disabled}
                          />
                        </td>
                        <td colSpan="5" />
                      </tr>

                      <tr className="border-bottom-0">
                        <th className="border-bottom-0 text-left" colSpan="1">
                          Emb Placement
                        </th>
                        <th className="border-bottom-0" colSpan="1">
                          Emb form
                        </th>
                        <th className="border-bottom-0">No of Colors</th>
                        <th className="border-bottom-0 text-right" colSpan="2">
                          Frames
                        </th>
                        <th className="border-bottom-0 text-right" colSpan="2">
                          Stitches/Mtr
                        </th>
                        <th className="border-bottom-0">Consumption/Unit</th>
                        <th></th>
                        <th className="border-bottom-0">Stitches Count</th>
                        <th className="border-bottom-0">
                          Prices/1000 Stitches
                        </th>
                        <Totalheader />
                        <th className="border-bottom-0 text-left">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addEmbroidery()}
                          />
                        </th>
                      </tr>
                      {costing.embroidery.map((embroideryData, index) => {
                        return (
                          <tr className="">
                            <td className="border-top-0" colSpan="1">
                              <span className="d-block py-1">
                                <Field
                                  style={{
                                    width: "10rem",
                                    margin: "0 auto",
                                    marginLeft: "0"
                                  }}
                                  isFormGroup={false}
                                  inputType="select"
                                  inputName="embPlacement"
                                  value={embroideryData.embPlacement}
                                  options={this.state.embPlacementList}
                                  onChange={(name, value) =>
                                    this.updateValModules(
                                      name,
                                      value,
                                      index,
                                      "embroidery"
                                    )
                                  }
                                  disabled={this.state.disabled}
                                />
                              </span>
                            </td>
                            <td className="border-top-0" colSpan="1">
                              <Field
                                style={{
                                  width: "10rem",
                                  margin: "0 auto",
                                  marginLeft: "0"
                                }}
                                isFormGroup={false}
                                inputType="select"
                                inputName="embForm"
                                value={embroideryData.embForm}
                                options={this.state.embFormList}
                                onChange={(name, value) =>
                                  this.updateValModules(
                                    name,
                                    value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td className="border-top-0" colSpan="2">
                              <Field
                                style={{
                                  width: "10rem",
                                  margin: "0 auto",
                                  marginLeft: "0"
                                }}
                                isFormGroup={false}
                                inputType="select"
                                inputName="noOfCols"
                                value={embroideryData.noOfCols}
                                options={this.state.noOfColorList}
                                onChange={(name, value) =>
                                  this.updateValModules(
                                    name,
                                    value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td className="border-top-0" colSpan="2">
                              <Field
                                style={{
                                  width: "10rem",
                                  margin: "0 auto",
                                  marginLeft: "0"
                                }}
                                isFormGroup={false}
                                inputType="select"
                                inputName="frames"
                                value={embroideryData.frames}
                                options={this.state.framesList}
                                onChange={(name, value) =>
                                  this.updateValModules(
                                    name,
                                    value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td className="border-top-0">
                              <Field
                                isFormGroup={false}
                                inputType="number"
                                inputName="stitchesMtr"
                                value={embroideryData.stitchesMtr}
                                onChange={(name, value) =>
                                  this.updateValModules(
                                    name,
                                    value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                disabled={
                                  this.state.disabled ||
                                  embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel"
                                }
                              />
                            </td>
                            <td className="border-top-0">
                              <input
                                type="number"
                                className={"consumption-field"}
                                name={"consumption"}
                                value={embroideryData.consumption}
                                disabled={
                                  this.state.disabled ||
                                  embroideryData.embForm && embroideryData.embForm.toLowerCase() === "panel"
                                }
                                onChange={e =>
                                  this.updateValModules(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "embroidery")
                                }
                              />
                              <span style={{ maxWidth: "20%" }}>/mtrs</span>
                            </td>
                            <td></td>
                            {/* <td className="border-top-0" /> */}
                            <td className="border-top-0">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"stitchCount"}
                                value={embroideryData.stitchCount}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.updateValModules(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "embroidery")
                                }
                              />
                            </td>
                            <td className="border-top-0">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"priceForStitches"}
                                value={embroideryData.priceForStitches}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.updateValModules(
                                    e.target.name,
                                    e.target.value,
                                    index,
                                    "embroidery"
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "embroidery")
                                }
                              />
                            </td>
                            <td>
                              <NumberField
                                name={"totalCost"}
                                value={
                                  embroideryData.totalCost
                                    ? Number(embroideryData.totalCost).toFixed(
                                      2
                                    )
                                    : embroideryData.totalCost
                                }
                                // onChange={this.updateTotalCost}
                                disabled={true}
                              />
                            </td>
                            <td>
                              <ButtonIcon
                                buttonType={"remove"}
                                addRemoveFunc={() =>
                                  this.removeEmbroidery(index)
                                }
                              />
                            </td>
                          </tr>
                        )
                      })}
                      <TotalCostRow
                        colSpan="11"
                        moduleName={"Embroidery"}
                        totalCostValue={costing.embroideryTotalCost}
                        name={"embroideryTotalCost"}
                        onChange={(name, value) => this.updateMain(name, value)}
                      />
                      {this.state.costing.embroideryBacking && (
                        <Fragment>
                          <tr className={`border-bottom-0`}>
                            <th className="border-bottom-0">Backing</th>
                            <th className="border-bottom-0">Width</th>
                            <th className="border-bottom-0">Placement</th>
                            <th colSpan="6"></th>
                            <th className="border-bottom-0">Consumption</th>
                            <th className="border-bottom-0">Prices/Mtrs</th>
                            <Totalheader />

                            <th
                              className="border-bottom-0"
                            // width="11.1111111111%"
                            >
                              <ButtonIcon
                                buttonType={"add"}
                                addRemoveFunc={() => this.addBacking()}
                              />
                            </th>
                          </tr>
                          {costing.backing.map((backing, index) => {
                            return (
                              <tr>
                                <td>
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="backingType"
                                    value={backing.backingType}
                                    options={this.state.backingTypeList}
                                    onChange={(name, value) =>
                                      this.calcTotalCost(
                                        name,
                                        value,
                                        index,
                                        "backing"
                                      )
                                    }
                                    label={"Backing "}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td>
                                  <Field
                                    isFormGroup={false}
                                    inputType="text"
                                    inputName="width"
                                    value={backing.width}
                                    options={backing.widthList}
                                    onChange={(name, value) =>
                                      this.calcTotalCost(
                                        name,
                                        value,
                                        index,
                                        "backing"
                                      )
                                    }
                                    label={"Width"}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td>
                                  <Field
                                    isFormGroup={false}
                                    inputType="select"
                                    inputName="placement"
                                    value={backing.placement}
                                    options={this.state.embPlacementList}
                                    onChange={(name, value) =>
                                      this.calcTotalCost(
                                        name,
                                        value,
                                        index,
                                        "backing"
                                      )
                                    }
                                    label={"Placement "}
                                    disabled={this.state.disabled}
                                  />
                                </td>
                                <td colSpan="6"></td>
                                <td>
                                  <input
                                    type="number"
                                    style={{ width: "4rem" }}
                                    className={"consumption-field"}
                                    name={"consumption"}
                                    value={backing.consumption}
                                    disabled={this.state.disabled}
                                    onChange={e =>
                                      this.calcTotalCost(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        "backing"
                                      )
                                    }
                                    onBlur={e =>
                                      this.changeToDecimal(e, index, "backing")
                                    }
                                  />
                                </td>
                                <td className="border-top-0">
                                  <input
                                    type="number"
                                    style={{ width: "4rem" }}
                                    className={"consumption-field"}
                                    name={"price"}
                                    value={backing.price}
                                    disabled={this.state.disabled}
                                    onChange={e =>
                                      this.calcTotalCost(
                                        e.target.name,
                                        e.target.value,
                                        index,
                                        "backing"
                                      )
                                    }
                                    onBlur={e =>
                                      this.changeToDecimal(e, index, "backing")
                                    }
                                  />
                                  <span style={{ maxWidth: "20%" }}>
                                    /{backing.units || "Mts"}
                                  </span>
                                </td>
                                <td>
                                  <NumberField
                                    name={"totalCost"}
                                    value={
                                      backing.totalCost
                                        ? Number(backing.totalCost).toFixed(2)
                                        : 0.0
                                    }
                                    // onChange={this.updateTotalCost}
                                    disabled={true}
                                  />
                                </td>
                                <td>
                                  <ButtonIcon
                                    buttonType={"remove"}
                                    addRemoveFunc={() =>
                                      this.removeBacking(index)
                                    }
                                  />
                                </td>
                              </tr>
                            )
                          })}
                          <TotalCostRow
                            colSpan="11"
                            moduleName={"Backing"}
                            totalCostValue={costing.backingTotalCost}
                            name={"backingTotalCost"}
                            onChange={(name, value) =>
                              this.updateMain(name, value)
                            }
                          />
                        </Fragment>
                      )}
                    </Fragment>
                  )}
                </tbody>
              </table>
              {toggle.embellishment && (
                <table className="costingtable" id="embelishment">
                  <tbody>
                    <ModuleHeader
                      colSpan="12"
                      header={"Embellishment Cost Details"}
                    />
                  </tbody>
                </table>
              )}
              <table className="costingtable w-100 ">
                <tbody>
                  {toggle.embellishment && (
                    <Fragment>
                      <tr
                        className="d-flex justify-content-end ml-auto mr-0"
                        style={{ width: "99.3%" }}
                      >
                        <th className="border-bottom-0 text-center" width="10%">
                          Type
                        </th>
                        <th className="border-bottom-0 text-center" width="10%">
                          HH:MM
                        </th>
                        <th className="border-bottom-0 text-center" width="7%">
                          Price/ 30mins
                        </th>
                        <Totalheader />
                        <th className="border-bottom-0 mr-0">
                          <ButtonIcon
                            buttonType={"add"}
                            addRemoveFunc={() => this.addEmbellishment()}
                          />
                        </th>
                      </tr>

                      {costing.embellishment.map((embellishment, index) => {
                        return (
                          <tr className="d-flex justify-content-end ml-auto mr-0">
                            <td>
                              <Field
                                isFormGroup={false}
                                style={{ width: "7rem" }}
                                inputType="select"
                                inputName="embType"
                                value={embellishment.embType}
                                options={this.state.embTypeList}
                                onChange={this.updateEmbellishment}
                                index={index}
                                label={"Type "}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <Field
                                isFormGroup={false}
                                // style={{ width: "5rem" }}
                                inputType="time"
                                inputName="hoursMinutes"
                                value={embellishment.hoursMinutes || `${new Date().getFullYear(), new Date().getMonth(), new Date().getDay()}`}
                                onChange={this.updateEmbellishment}
                                index={index}
                                label={"HH:MM "}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td>
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"pricePerHalfHour"}
                                value={embellishment.pricePerHalfHour}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.updateEmbellishment(e.target.name, e.target.value, index)
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "embellishment")
                                }
                              />
                            </td>
                            <td>
                              <NumberField
                                style={{
                                  margin: "auto 0 auto auto !important",
                                  padding: "auto 0 auto auto !important"
                                }}
                                name={"totalCost"}
                                value={embellishment.totalCost && Number(embellishment.totalCost).toFixed(2)}
                                // onChange={this.updateTotalCost}
                                disabled={true}
                              />
                            </td>
                            <td>
                              <ButtonIcon
                                buttonType={"remove"}
                                addRemoveFunc={() =>
                                  this.removeEmbellishment(index)
                                }
                              />
                            </td>
                          </tr>
                        )
                      })}
                      <span
                        className="d-inline-flex justify-content-end"
                        style={{ width: "98.1%" }}
                      >
                        <TotalCostRow
                          // trClassName={"d-flex justify-content-end"}
                          colSpan="11"
                          moduleName={"embellishment"}
                          totalCostValue={costing.embelishmentTotalCost && Number(costing.embelishmentTotalCost).toFixed(2)}
                          name={"embelishmentTotalCost"}
                        // onChange={(name, value) => this.updateMain(name, value)}
                        />
                      </span>
                    </Fragment>
                  )}
                </tbody>
              </table>

              {toggle.wash && (
                <Fragment>
                  <table>
                    <tbody>
                      <tr className="d-flex justify-content-start align-items-center">
                        <td width="15%" className="border-bottom-0 text-left">
                          <h6 className="mb-0 text-primary font-weight-bold">
                            Wash Cost Details
                          </h6>
                        </td>
                        <td width="5%" className="font-weight-bold">
                          Tacking
                        </td>
                        <td width="7%">
                          <Field
                            isFormGroup={true}
                            inputType="checkboxToggle"
                            inputName="tacking"
                            className="my-0 py-0"
                            value={costing.tacking}
                            onChange={() => {
                              let costing = this.state.costing
                              costing.tacking = !costing.tacking
                              this.setState({
                                costing
                              })
                            }}
                            disabled={this.state.disabled}
                          />
                        </td>
                        <td width="63%" className="border-bottom-0 d-flex justify-content-end mr-0 ml-auto p-0" >
                          <th
                            className="border-bottom-0 text-center"
                            width="15%"
                          >
                            Type of wash
                          </th>
                          <th
                            className="border-bottom-0 text-center"
                            width="11%"
                          >
                            Laundry Unit
                          </th>
                          <th
                            className="border-bottom-0 text-right"
                            width="8%"
                          >
                            Wt/Gmt
                          </th>
                          <th
                            className="border-bottom-0 text-right px-0"
                            width="10%"
                          >
                            Price / Kg / Gmt
                          </th>
                          <Totalheader center={true} />
                          <th className="text-right px-0">
                            <ButtonIcon
                              buttonType={"add"}
                              addRemoveFunc={() => this.addWash()}
                            />
                          </th>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="costingtable" id="wash">
                    <tbody>
                      {/* <tr className="border-bottom-0 d-flex justify-content-end">
                        
                      </tr> */}
                      {costing.wash.map((wash, index) => {
                        return (
                          <tr className="border-bottom-0 d-flex justify-content-end">
                            {/* <td colSpan={"8"}></td> */}
                            <td width="8.1111111111%">
                              <Field
                                isFormGroup={false}
                                inputType="select"
                                inputName="washType"
                                index={index}
                                value={wash.washType}
                                options={this.state.washTypeList}
                                label={"Wash Type"}
                                onChange={this.updateWash}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td width="7.1111111111%">
                              <Field
                                isFormGroup={false}
                                inputType="select"
                                inputName="laundryUnit"
                                index={index}
                                value={wash.laundryUnit}
                                options={this.state.laundryUnitList}
                                label={"laundry Unit"}
                                onChange={this.updateWash}
                                disabled={this.state.disabled}
                              />
                            </td>
                            <td width="7.1111111111%">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"weight"}
                                value={wash.weight}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.updateWash(
                                    e.target.name,
                                    e.target.value,
                                    index
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "wash")
                                }
                              />
                            </td>
                            <td width="5.1111111111%">
                              <input
                                type="number"
                                style={{ width: "4rem" }}
                                className={"consumption-field"}
                                name={"price"}
                                value={wash.price}
                                disabled={this.state.disabled}
                                onChange={e =>
                                  this.updateWash(
                                    e.target.name,
                                    e.target.value,
                                    index
                                  )
                                }
                                onBlur={e =>
                                  this.changeToDecimal(e, index, "wash")
                                }
                              />
                            </td>
                            <td>
                              <NumberField
                                // style={{ margin: "auto", padding: "auto" }}
                                name={"totalCost"}
                                value={wash.totalCost && Number(wash.totalCost).toFixed(2)}
                                onChange={this.updateWash}
                                disabled={true}
                              />
                            </td>
                            <td>
                              <ButtonIcon
                                buttonType={"remove"}
                                addRemoveFunc={() => this.removeWash(index)}
                              />
                            </td>
                          </tr>
                        )
                      })}
                      <span
                        className="d-inline-flex justify-content-end"
                        style={{ width: "98%" }}
                      >
                        <TotalCostRow
                          // trClassName={"d-flex justify-content-end"}
                          colSpan="11"
                          moduleName={"Wash"}
                          totalCostValue={costing.washTotalCost && Number(costing.washTotalCost).toFixed(2)}
                          name={"washTotalCost"}
                          onChange={(name, value) =>
                            this.updateMain(name, value)
                          }
                        />
                      </span>
                    </tbody>
                  </table>
                </Fragment>
              )}

              <table className="costingtable">
                <tbody>
                  <ModuleHeader header={"Other Charges"} />
                  {costing.otherCostDetails.map((data, index) => {
                    return (
                      <Fragment>
                        <tr className="d-flex justify-content-end">
                          <td style={{ width: "30%" }}>
                            <input
                              style={{ width: "100%", textAlign: "right" }}
                              type="text"
                              value={data.label}
                              onChange={e =>
                                this.updateOtherCostdetails(
                                  "label",
                                  e.target.value,
                                  index
                                )
                              }
                              autoComplete={true}
                              disabled={this.state.disabled}
                            />
                          </td>
                          <td>
                            <input
                              type="number"
                              className={"number-field"}
                              name={"value"}
                              value={data.value}
                              disabled={this.state.disabled}
                              id={`otId${index}`}
                              onChange={e =>
                                this.updateOtherCostdetails(
                                  "value",
                                  e.target.value,
                                  index
                                )
                              }
                              onBlur={e =>
                                this.changeToDecimal(
                                  e,
                                  index,
                                  "otherCostDetails"
                                )
                              }
                            />
                          </td>
                          <td>
                            {costing.otherCostDetails.length === 1 && (
                              <ButtonIcon
                                buttonType={"remove"}
                                addRemoveFunc={() => {
                                  this.removeOtherCost(0)
                                }}
                              />
                            )}
                            <ButtonIcon
                              buttonType={index == 0 ? "add" : "remove"}
                              addRemoveFunc={() => {
                                index == 0
                                  ? this.addOtherCost()
                                  : this.removeOtherCost(index)
                              }}
                            />
                          </td>
                        </tr>
                      </Fragment>
                    )
                  })}
                  {!costing.otherCostDetails.length && (
                    <tr>
                      <td className="d-flex justify-content-end">
                        <ButtonIcon
                          buttonType={"add"}
                          addRemoveFunc={() => {
                            this.addOtherCost()
                          }}
                        />
                      </td>
                    </tr>
                  )}
                  {costing.otherCostDetails.length != 0 && (
                    <span
                      className="d-flex justify-content-end"
                      style={{ marginRight: "1.68rem" }}
                    >
                      <TotalCostRow
                        colSpan="10"
                        moduleName={"Other"}
                        totalCostValue={costing.otherTotalCost && Number(costing.otherTotalCost).toFixed(2)}
                        name={"otherTotalCost"}
                        onChange={(name, value) => this.updateMain(name, value)}
                      />
                    </span>
                  )}
                </tbody>
              </table>

              <table className="costingtable" id="manufacturing">
                <tbody>
                  <Fragment>
                    <ModuleHeader
                      header={" Manufacturing Process / Piece Cost Details"}
                    />
                    <tr className="border-bottom-0">
                      <th
                        className="border-bottom-0 text-left"
                      // width="11.1111111111%"
                      >
                        Select SMV
                      </th>
                      <th
                        className="border-bottom-0"
                      // width="11.1111111111%"
                      >
                        Order Qty
                      </th>
                      {/* <th className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? 'd-none' : ''}>
                        Mins.Per Day
                      </th> */}
                      <th colSpan={"1"} />
                      <th
                        className="border-bottom-0"
                      // width="11.1111111111%"
                      >
                        SAM @ 80%
                      </th>
                      <th colSpan={"1"} />
                      {/* <th
                        className="border-bottom-0"
                      // width="11.1111111111%"
                      >
                        SAM @ 80%
                      </th> */}
                      <th
                        className="border-bottom-0"
                      // width="11.1111111111%"
                      >
                        Rev/Tailor @{" "}
                        {costing.manufacturingAndPieceCostDetails.perMachine}
                      </th>
                      <th
                        className="border-bottom-0"
                      // width="11.1111111111%"
                      >
                        Rev/Machine @{" "}
                        {costing.manufacturingAndPieceCostDetails.costPertailor}
                      </th>
                      {/* <th className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? '' : 'd-none'} colSpan={"1"} />
                      <th className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? '' : 'd-none'} colSpan={"1"} /> */}
                      <th></th>
                      <th></th>
                      <th></th>
                      <th colSpan={"2"} className="text-right">
                        Fixed Charges
                      </th>
                      <th>
                        {/* <span
                          style={{
                            color: "rgba(0, 0, 0, 0.87)",
                            fontWeight: "lighter"
                          }}
                        >
                        </span> */}
                        <input
                          className={"number-field"}
                          type="number"
                          name={"fixedCharge"}
                          value={costing.manufacturingAndPieceCost.fixedCharge}
                          disabled={this.state.disabled}
                          // style={}
                          onChange={e =>
                            this.manufactureUpdate(
                              e.target.name,
                              e.target.value
                            )
                          }
                          onBlur={e =>
                            this.changeToDecimal(
                              e,
                              null,
                              "manufacturingAndPieceCost"
                            )
                          }
                        // style={{ marginRight: '-20px' }}
                        />
                      </th>
                      <th />
                    </tr>
                    <tr>
                      <td>
                        <Field
                          isFormGroup={false}
                          inputType="select"
                          inputName="sectedsmv"
                          value={costing.manufacturingAndPieceCostDetails.smv}
                          options={this.state.selectSmv}
                          onChange={this.getOneSmv}
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td>
                        <NumberField
                          name={"orderQty"}
                          value={costing.manufacturingAndPieceCostDetails.orderQty}
                          onChange={this.manufactureUpdate}
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td></td>
                      {/* <td className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? 'd-none' : ''}>
                        <NumberField
                          name={'minutesperDay'}
                          value={costing.manufacturingAndPieceCostDetails.minutesperDay}
                          onChange={this.getOneSmv}
                          disabled={this.state.disabled}
                        />
                      </td> */}
                      <td>
                        <Field
                          style={{ width: "4rem", margin: "0 auto" }}
                          isFormGroup={false}
                          inputType="number"
                          inputName="smv100"
                          value={costing.manufacturingAndPieceCostDetails.smv100}
                          onChange={this.getOneSmv}
                          disabled={this.state.disabled}
                        />
                      </td>
                      <td></td>
                      {/* <td>
                        <Field
                          style={{ width: "4rem", margin: "0 auto" }}
                          isFormGroup={false}
                          inputType="number"
                          inputName="smv80"
                          value={costing.manufacturingAndPieceCostDetails.smv80}
                          // onChange={this.getOneSmv}
                          disabled={true}
                        />
                      </td> */}
                      <td>
                        <NumberField
                          name={"revTailer"}
                          value={
                            costing.manufacturingAndPieceCostDetails.revTailer
                          }
                          onChange={this.manufactureUpdate}
                          disabled={true}
                        />
                      </td>
                      <td>
                        <NumberField
                          name={"revMachine"}
                          value={
                            costing.manufacturingAndPieceCostDetails.revMachine
                          }
                          onChange={this.manufactureUpdate}
                          disabled={true}
                        />
                      </td>
                      <td></td>
                      <td></td>
                      <td></td>
                      <td></td>
                      {/* <td className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? '' : 'd-none'}></td>
                      <td className={(this.state.selectSmv && this.state.selectSmv.length > 0) ? '' : 'd-none'}></td> */}
                      <td>
                        <label className="font-13 text-right">
                          <span className="text-primary">CMT @ </span>
                          <select
                            value={costing.manufacturingAndPieceCost.CMT}
                            disabled={
                              !costing.manufacturingAndPieceCostDetails || !costing.manufacturingAndPieceCostDetails.revTailer
                            }
                            onChange={this.changeCMT}
                          >
                            <option>-select-</option>
                            <option
                              value={
                                costing.manufacturingAndPieceCostDetails
                                  .revTailer || 0.0
                              }
                            >
                              {/* 2800 */}{
                                costing.manufacturingAndPieceCostDetails.perMachine
                              }
                            </option>
                            <option
                              value={
                                costing.manufacturingAndPieceCostDetails
                                  .revMachine || 0.0
                              }
                            >
                              {/* 1750 */}
                              {
                                costing.manufacturingAndPieceCostDetails.costPertailor
                              }
                            </option>
                          </select>
                        </label>
                      </td>
                      <td>
                        <NumberField
                          name={"CMT"}
                          value={costing.manufacturingAndPieceCost.CMT || "0.00"}
                          onChange={this.manufactureUpdate}
                        // disabled
                        // style={{ marginRight: '-20px' }}
                        />
                      </td>
                    </tr>
                    <TotalCostRow
                      colSpan={12}
                      moduleName={"Manufacturing"}
                      totalCostValue={
                        costing.manufacturingAndPieceCost.totalCost
                      }
                    />
                  </Fragment>
                </tbody>
              </table>
              <table className="costingtable">
                <tbody>
                  <tr>
                    <td />
                    <td className="border-top-0">
                      <p className="radio-inline nopadding">
                        <input
                          name="group"
                          type="radio"
                          className="filled-in hide-all"
                          id="sample"
                          value="sample"
                          checked={
                            this.state.costing.selectedMenu.name === "sample"
                          }
                          onChange={e => {
                            let costing = this.state.costing
                            costing.selectedMenu.name = e.target.value
                            this.setState({
                              costing
                            })
                          }}
                        />
                        <label for="sample" />
                      </p>
                      <label>Sample</label>
                      <select
                        name="sample"
                        value={this.state.costing.selectedMenu.name === "sample" && this.state.costing.selectedMenu.value}
                        onChange={e => {
                          let costing = this.state.costing
                          costing.selectedMenu.value = e.target.value
                          costing.selectedMenu.date = new Date()
                          this.setState({
                            costing
                          })
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.costing.selectedMenu.name != "sample"
                        }
                        className="form-control"
                      >
                        <option key="" value="">
                          --select--
                        </option>
                        {this.state.sampleList.map((data, i) => (
                          <option key={i} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="border-top-0">
                      <label>Dated</label>
                      <span
                        style={{ display: "inline-block", marginTop: "30px" }}
                      >
                        <Field
                          isFormGroup={false}
                          inputType={"date"}
                          inputName={"sampleDate"}
                          value={
                            this.state.costing.selectedMenu.name === "sample"
                              ? this.state.costing.selectedMenu.date
                              : null
                          }
                          onChange={this.manufactureUpdate}
                          disabled={
                            this.state.disabled ||
                            this.state.costing.selectedMenu.name != "sample"
                          }
                        />
                      </span>
                    </td>
                    {/* <td className="border-top-0 text-right naming" /> */}
                    <td className="border-top-0">
                      <p className="radio-inline nopadding">
                        <input
                          name="group"
                          type="radio"
                          className="filled-in hide-all"
                          id="pattern"
                          value="pattern"
                          checked={
                            this.state.costing.selectedMenu.name === "pattern"
                          }
                          onChange={e => {
                            let costing = this.state.costing
                            costing.selectedMenu.name = e.target.value
                            this.setState({
                              costing
                            })
                          }}
                        />
                        <label for="pattern" />
                      </p>
                      <label>Pattern</label>
                      <select
                        name="pattern"
                        value={this.state.costing.selectedMenu.name === "pattern" && this.state.costing.selectedMenu.value}
                        onChange={e => {
                          let costing = this.state.costing
                          costing.selectedMenu.value = e.target.value
                          this.setState({
                            costing
                          })
                        }}
                        disabled={
                          this.state.disabled ||
                          this.state.costing.selectedMenu.name != "pattern"
                        }
                        className="form-control"
                      >
                        <option key="" value="">
                          --select--
                        </option>
                        {this.state.patternList.map((data, i) => (
                          <option key={i} value={data.value}>
                            {data.label}
                          </option>
                        ))}
                      </select>
                    </td>
                    <td className="border-top-0">
                      <label>Dated</label>
                      <span
                        style={{ display: "inline-block", marginTop: "30px" }}
                      >
                        <Field
                          isFormGroup={false}
                          inputType={"date"}
                          inputName={"patternDate"}
                          value={
                            this.state.costing.selectedMenu.name === "pattern"
                              ? this.state.costing.selectedMenu.date
                              : null
                          }
                          onChange={this.manufactureUpdate}
                          disabled={
                            this.state.disabled ||
                            this.state.costing.selectedMenu.name != "pattern"
                          }
                        />
                      </span>
                    </td>
                    <td className="border-top-0 text-right naming">
                      <span
                        className="w-100 d-inline-flex align-items-end"
                        style={{
                          justifyContent: "flex-end",
                          paddingLeft: "15.7rem"
                        }}
                      >
                        Value Loss % :
                        <input
                          type="number"
                          name="valueLoss"
                          style={{ width: "4rem" }}
                          className="text-right"
                          value={
                            this.state.costing.manufacturingAndPieceCost
                              .valueLoss
                          }
                          onChange={e => this.overheadValueLossCalculator(e)}
                        />
                        %
                      </span>
                    </td>
                    {/* <td className="text-right text-green">

                    </td> */}
                    <td>
                      <NumberField
                        style={{ marginRight: "15px", marginLeft: "-0.8rem" }}
                        name={"valueLossCost"}
                        value={Number(
                          this.state.costing.manufacturingAndPieceCost
                            .valueLossCost
                        ).toFixed(2)}
                        // onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
              </table>

              <table
                className="costingtable ml-auto mr-0"
                style={{ width: "40%" }}
              >
                <tbody>
                  <tr>
                    <td colSpan="12"></td>
                    <td className="border-top-0 naming text-right">
                      Contribution to overheads % :
                      <input
                        type="number"
                        name="overHeads"
                        style={{ width: "4rem" }}
                        className="text-right"
                        value={
                          this.state.costing.manufacturingAndPieceCost.overHeads
                        }
                        onChange={e => this.overheadValueLossCalculator(e)}
                      />
                      %
                    </td>
                    {/* <td className="text-right text-green">
                      {/* <label>{this.state.others.overHeads}%</label> */}

                    {/* </td> */}
                    <td>
                      <NumberField
                        name={"overHeadsCost"}
                        style={{ width: "4rem", marginLeft: "-1.5rem" }}
                        value={Number(
                          this.state.costing.manufacturingAndPieceCost
                            .overHeadsCost
                        ).toFixed(2)}
                        // onChange={(name, value) => this.updateValModules(name, value, index, "fabric")}
                        disabled
                      />
                    </td>
                  </tr>
                </tbody>
              </table>
              <table
                className="costingtable float-right"
                // style={{ marginRight: "-0.7rem", overflow: 'hidden' }}
                style={{ width: '21%' }}
              >
                <tbody>
                  <TotalCostRow

                    moduleName={""}
                    totalCostValue={
                      costing.costingTotal
                        ? Number(costing.costingTotal).toFixed(2)
                        : costing.costingTotal
                    }
                  />
                </tbody>
              </table>

              <table className="costingtable">
                <tbody>
                  <tr>
                    <td colspan="11" className="border-top-0 text-right naming">
                      <table>
                        <tbody>
                          <tr>
                            <td colspan="11" className="border-top-0 text-right naming">
                              <p className="radio-inline  pr-3">
                                <input
                                  name="usd"
                                  type="radio"
                                  className="filled-in hide-all"
                                  id="rad1"
                                  value="usd"
                                  checked={
                                    this.state.costing.selectedConversion === "usd"
                                  }
                                  onChange={this.selectedConversion}
                                />
                                <label for="rad1">
                                  USD-$-
                                  <input
                                    type="number"
                                    className={"custom-number-field1"}
                                    // value={
                                    //   this.state.action === "add" 
                                    //     ? (this.state.currencies && this.state.currencies.usd) || '' 
                                    //     : (this.state.costing && this.state.costing.currencyConversion && this.state.costing.currencyConversion.usd) ||this.state.currencies.usd
                                    // }
                            
                                    value={this.state.action === "add"
                                      ? (this.state.currencies && this.state.currencies.usd) || '' // Add mode uses currencies
                                      : (this.state.costing && this.state.costing.currencyConversion && this.state.costing.currencyConversion.usd) 
                                        ? this.state.costing.currencyConversion.usd // Edit mode with currencyConversion
                                        : this.state.currencies.usd || '' // If currencyConversion is missing, use currencies
                                  }
                                    onChange={(e) => this.handleCurrencyChange(e, 'usd')}
                                    onKeyDown={this.preventSpecialChars}
                                    />
                                  {/* <input
                        type="number"
                        name="usd"
                        style={{ width: "2rem" }}
                        
                        value={
                          this.state.currencies.usd
                        }
                        onChange={e => this.handleCurrencyChange("usd", e.target.value)}
                        onKeyDown={this.preventSpecialChars}
                        disabled
                      /> */}
                                  <span className="text-center text-dark px-4" style={{ fontSize: '16px', color: '#292b2c' }}>
                                    $ {this.state.costing.usdTotal}
                                  </span>
                                </label>
                              </p>
                            </td>
                          </tr>
                          <tr>
                            <td colspan="11" className="border-top-0 text-right naming">
                              <p className="radio-inline  pr-3">
                                <input
                                  name="gbp"
                                  type="radio"
                                  className="filled-in hide-all"
                                  id="rad2"
                                  value="gbp"
                                  checked={
                                    this.state.costing.selectedConversion === "gbp"
                                  }
                                  onChange={this.selectedConversion}
                                />
                                <label for="rad2">
                                  GBP-£-
                                  <input
                                    type="number"
                                    className={"custom-number-field1"}
                                    value={
                                      this.state.action === "add"
                                        ? (this.state.currencies && this.state.currencies.gbp) || '' // Add mode uses currencies
                                        : (this.state.costing && this.state.costing.currencyConversion && this.state.costing.currencyConversion.gbp) 
                                          ? this.state.costing.currencyConversion.gbp // Edit mode with currencyConversion
                                          : this.state.currencies.gbp || '' // If currencyConversion is missing, use currencies
                                    }
                                    onChange={(e) => this.handleCurrencyChange(e, 'gbp')}
                                    onKeyDown={this.preventSpecialChars}
                                    
                                    />
                                  {/* <input
                        type="number"
                        name="gbp"
                        style={{ width: "2rem" }}
                        
                        value={
                          this.state.currencies.gbp
                        }
                        onChange={e => this.handleCurrencyChange("gbp", e.target.value)}
                        onKeyDown={this.preventSpecialChars}
                        disabled
                      /> */}
                                  <span className="text-center px-4" style={{ fontSize: '16px', color: '#292b2c' }}>
                                    £ {this.state.costing.gbpTotal}
                                  </span>
                                </label>

                              </p>

                            </td>
                          </tr>
                          <tr>
                            <td colspan="11" className="border-top-0 text-right naming">
                              <p className="radio-inline pr-3">
                                <input
                                  name="euro"
                                  type="radio"
                                  className="filled-in hide-all"
                                  id="rad3"
                                  value="euro"
                                  checked={
                                    this.state.costing.selectedConversion === "euro"
                                  }
                                  onChange={this.selectedConversion}
                                />
                                <label for="rad3">
                                  Euro-€-
                                  {/* {this.state.currencies.eur} */}
                                  <input
                                    type="number"
                                    className={"custom-number-field1"}
                                    value={this.state.action === "add"
                                      ? (this.state.currencies && this.state.currencies.eur) || '' // Add mode uses currencies
                                      : (this.state.costing && this.state.costing.currencyConversion && this.state.costing.currencyConversion.eur) 
                                        ? this.state.costing.currencyConversion.eur // Edit mode with currencyConversion
                                        : this.state.currencies.eur || '' // If currencyConversion is missing, use currencies
                                  }
                                    onChange={(e) => this.handleCurrencyChange(e, 'eur')}
                                    onKeyDown={this.preventSpecialChars}
                                    />
                                  {/* <input
                        type="number"
                        name="eur"
                        style={{ width: "2rem" }}
                        
                        value={
                          this.state.currencies.eur
                        }
                        onChange={e => this.handleCurrencyChange("eur", e.target.value)}
                        onKeyDown={this.preventSpecialChars}
                        disabled
                      /> */}
                                  <span className="text-center px-4" style={{ fontSize: '16px', color: '#292b2c' }}>
                                    € {this.state.costing.euroTotal}
                                  </span>
                                </label>
                              </p>

                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </td>
                  </tr>
                  <tr>
                    <td colspan="2">
                      <tr className="d-flex justify-content-end ml-3 mr-3">
                        <label className="mr-2">Shipment Term</label>
                        <Field
                          className={"py-0 my-0"}
                          isFormGroup={true}
                          inputType="select"
                          inputName="shipmentTerm"
                          // label="Shipment Term"
                          value={costing.shipmentTerm}
                          options={this.state.shipmentTermList.map(x => ({
                            label: x.label,
                            value: x.label
                          }))}
                          onChange={this.landedCalc}
                          disabled={this.state.disabled}
                        />
                      </tr>
                      <tr className="d-flex justify-content-end ml-3 mr-3 ">
                        <label className="mr-2">Shipment Mode</label>
                        <Field
                          className={"py-0 my-0"}
                          isFormGroup={true}
                          inputType="select"
                          inputName="shipMode"
                          // label="Shipment Mode"
                          value={costing.shipMode}
                          options={this.state.shipModeList}
                          onChange={this._handleInputChange}
                          disabled={this.state.disabled}
                        />
                      </tr>
                      <tr className="d-flex justify-content-end ml-3 mr-3">
                        <label className="mr-2 fw-bold font-size-14">Agreed Price @ &nbsp;
                          <select value={
                            this.state.costing.agreedCurrency
                          }
                            onChange={e => {
                              let costing = { ...this.state.costing }
                              costing.agreedCurrency = e.target.value
                              this.setState({
                                costing
                              })
                            }}>
                            <option>₹</option>
                            <option>$</option>
                            <option>£</option>
                            <option>€</option>
                          </select>
                        </label>
                        <span className="mt-2">
                          <input
                            type='number'
                            className="number-field  custom-number-field"
                            
                            name="agreedPrice"
                            value={this.state.costing.agreedPrice}
                            onChange={e => {
                              let costing = { ...this.state.costing }
                              costing.agreedPrice = e.target.value || ''
                              this.setState({
                                costing
                              })
                            }}
                            onBlur={(e) => {
                              let costing = { ...this.state.costing }
                              costing.agreedPrice = Number(e.target.value).toFixed(2)
                              this.setState({
                                costing
                              })
                            }
                            }
                          />
                        </span>
                      </tr>
                    </td>

                  </tr>
                </tbody>
              </table>
              <table>
                <tbody>
                  <tr>
                    <td className="border-top-0" colSpan="2">
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={e =>
                          this.setState({
                            showLandedCalc: !this.state.showLandedCalc
                          })
                        }
                      >
                        Show landed Calculation
                        {this.state.showLandedCalc ? (
                          <span className="pl-2 font-weight-bold">
                            <i className="fa fa-angle-up" />
                          </span>
                        ) : (
                          <span className="pl-2 font-weight-bold">
                            <i className="fa fa-angle-down" />
                          </span>
                        )}
                      </span>
                    </td>
                    <td className="border-top-0" />
                  </tr>

                </tbody>
              </table>

              <table className="costingtable">
                <tbody>
                  {this.state.showLandedCalc && (
                    <Fragment>
                      <tr
                        className="d-flex justify-content-end my-1"
                        style={{ width: "99%" }}
                      >
                        <td>Landed Price</td>
                        <td>
                          <span className="font-weight-bold">
                            {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          </span>
                          <NumberField
                            name="landedPrice"
                            style={{ textAlign: "left" }}
                            // disabled={false}
                            value={
                              (this.state.costing.landedData.totalLandedValue &&
                                Number(
                                  this.state.costing.landedData.totalLandedValue
                                ).toFixed(2)) ||
                              "0.00"
                            }
                            // onChange={this.AgreedAndLandedPriceHandler}
                            disabled={true}
                          />
                        </td>
                        <td />
                      </tr>
                      <tr
                        className="d-flex justify-content-end mx-auto"
                        style={{ width: "27%" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right"
                        >
                          <label>if landed, then working is</label>
                        </td>
                        {/* <td className="border-top-0" /> */}
                      </tr>
                      <tr
                        className="d-flex justify-content-between"
                        style={{ width: "24.5%", margin: "0 auto" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right w-align"
                        >
                          <span className="mr-2">Conversion from</span>
                          <select
                            name="fromCurrencyConversion"
                            value={this.state.costing.fromCurrencyConvertion}
                            defaultValue="usd"
                          // onChange={e => this.currencyConverter(e)}
                          >
                            {/* <option value="">---</option> */}
                            <option value="usd">USD</option>
                            {/* <option value="gbp">GBP</option>
                            <option value="eur">EUR</option> */}
                          </select>
                          <span className="mx-1">to</span>
                          <select
                            className="mr-1"
                            name="toCurrencyConversion"
                            value={this.state.costing.toCurrencyConversion}
                            onChange={e => this.currencyConverter(e)}
                          >
                            <option value="">---</option>
                            <option value="gbp">GBP</option>
                            <option value="usd">USD</option>
                            <option value="eur">EUR</option>
                          </select>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 text-right font-13 font-weight-bold"
                        >
                          ${this.state.costing.landedPrice}
                          {/* ${this.state.costing.usdTotal} */}
                        </td>
                      </tr>
                      <tr
                        className="d-flex justify-content-between my-1"
                        style={{ width: "26.5%", margin: "0 auto" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right w-align"
                        >
                          <span className="pr-2">Conversion Rate</span>
                          <span>
                            <input
                              type="number"
                              style={{ width: "30%" }}
                              name="conversionRate"
                              value={
                                this.state.costing.landedData.conversionRate
                                  ? Number(
                                    this.state.costing.landedData
                                      .conversionRate
                                  )
                                  : ""
                              }
                              onChange={e => this.landedWorkingCalculation(e)}
                            />
                            {/* {Number(this.state.others.conversionRate).toFixed(
                              2
                            )} */}
                          </span>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 text-right font-13 font-weight-bold"
                        >
                          {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          {costing.landedData.rateValue}
                        </td>
                      </tr>
                      <tr
                        className="d-flex justify-content-between my-1"
                        style={{ width: "26.2%", margin: "0 auto" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right w-align"
                        >
                          <span className="pr-2">Freight Charges</span>
                          <span>
                            <input
                              type="number"
                              style={{ width: "30%" }}
                              name="freightCharges"
                              value={Number(
                                this.state.costing.landedData.freightCharges
                              )}
                              onChange={e => this.landedWorkingCalculation(e)}
                            />
                            {/* {Number(this.state.others.freightCharges).toFixed(
                              2
                            )} */}
                          </span>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 text-right font-13 font-weight-bold"
                        >
                          {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          {costing.landedData.freightChargesTotal}
                        </td>
                      </tr>
                      <tr
                        className="d-flex justify-content-between my-1"
                        style={{ width: "26.2%", margin: "0 auto" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right w-align"
                        >
                          <span
                            className="pr-2"
                            style={{ marginRight: "3.2rem" }}
                          >
                            Duty
                          </span>
                          <span>
                            <input
                              type="number"
                              style={{ width: "30%" }}
                              name="duty"
                              value={Number(this.state.costing.landedData.duty)}
                              onChange={e => this.landedWorkingCalculation(e)}
                            />
                            {/* {Number(this.state.others.duty)} */}
                          </span>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 text-right font-13 font-weight-bold"
                        >
                          {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          {costing.landedData.dutyValue}
                        </td>
                      </tr>
                      <tr
                        className="d-flex justify-content-between my-1"
                        style={{ width: "26.2%", margin: "0 auto" }}
                      >
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right w-align"
                        >
                          <span className="pr-2">Processing cost</span>
                          <span>
                            <input
                              type="number"
                              style={{ width: "30%" }}
                              name="processingCost"
                              value={Number(
                                this.state.costing.landedData.processingCost
                              )}
                              onChange={e => this.landedWorkingCalculation(e)}
                            />
                            {/* {Number(this.state.others.processingCost).toFixed(
                              2
                            )} */}
                          </span>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 text-right font-13 font-weight-bold"
                        >
                          {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          {costing.landedData.processValue}
                        </td>
                      </tr>
                      <tr
                        className="d-flex justify-content-between my-1"
                        style={{ width: "26.3%", margin: "0 auto" }}
                      >
                        {/* <td className="border-top-0 naming text-right pt-1" /> */}
                        <td
                          colspan="2"
                          className="border-top-0 naming text-right pt-1 border-bottom-style"
                        >
                          <label>Total Landing Cost</label>
                        </td>
                        <td
                          colspan="1"
                          className="border-top-0 pt-0 border-bottom-style font-weight-bold font-for-medium text-right"
                        >
                          {this.curSymbol(this.state.costing.toCurrencyConversion)}
                          {costing.landedData.totalLandedValue}
                        </td>
                      </tr>
                      {/* <tr>
                        <td className="border-top-0 naming text-right"
                        />
                        <td className="border-top-0" />
                      </tr> */}
                    </Fragment>
                  )}
                </tbody>
              </table>

              <div className="col-md-12 border-bottom-style row w-100">
                <div className="col-md-12 mx-auto row">
                  <div className="col-md-8 mx-auto">
                    <label>Special Comments</label>
                    <textarea
                      col="5"
                      className="w-100"
                      value={this.state.costing.comments}
                      onChange={e => {
                        let costing = this.state.costing
                        costing.comments = e.target.value
                        this.setState({ costing })
                      }}
                    ></textarea>
                  </div>
                </div>
              </div>
              {/* Landing calculatio last section */}
              <div className="col-md-12 border-bottom-style">
                {/* <ModuleHeader header={"Girls Wear Details"} /> */}
                {toggle.girlsWearing && (
                  <div className="col-md-12 no-padding my-1 product-form pl-2">
                    <div className="col-md-9 col-md-offset-1 no-padding product-form">
                      <form className="landingCalculation">
                        <table className="table table-bordered mb-0 landing-calc">
                          <tr>
                            <th rowspan="2">Grouping</th>
                            {girlsWearing &&
                              girlsWearing.grouping &&
                              girlsWearing.grouping.length &&
                              girlsWearing.grouping.map((x, i) => {
                                return (
                                  <td colspan={x.values && x.values.length} key={i}>
                                    {x.name}
                                  </td>
                                )
                              })}
                          </tr>
                          <tr>
                            {girlsWearing &&
                              girlsWearing.grouping &&
                              girlsWearing.grouping.length &&
                              girlsWearing.grouping.map((x, i) => {
                                return (
                                  x.values &&
                                  x.values.length &&
                                  x.values.map((y, j) => {
                                    return <td key={j}>{y.to}</td>
                                  })
                                )
                              })}
                          </tr>
                          <tr>
                            <th rowspan="2">Ratio</th>
                            {girlsWearing &&
                              girlsWearing.grouping &&
                              girlsWearing.grouping.length &&
                              girlsWearing.grouping.map((x, i) => {
                                return (
                                  x.values &&
                                  x.values.length &&
                                  x.values.map((y, j) => {
                                    return (
                                      <td>
                                        <input
                                          className="smallInput"
                                          style={{ padding: "0 !important" }}
                                          type="number"
                                          name={y.to}
                                          value={y.value ? y.value : null}
                                          // size="2"
                                          onChange={e =>
                                            this.addGirlsWearArray(e, x.name, j)
                                          }
                                        />
                                      </td>
                                    )
                                  })
                                )
                              })}
                          </tr>
                          <tr className="w-align">
                            {girlsWearing &&
                              girlsWearing.grouping &&
                              girlsWearing.grouping.length &&
                              girlsWearing.grouping.map((x, i) => {
                                return (
                                  <td colspan={x.values.length}>{x.total}</td>
                                )
                              })}
                            <td colspan="2">
                              <span>{girlsWearing.groupTotal}</span>
                            </td>
                          </tr>
                        </table>
                      </form>
                    </div>
                    <div className="col-md-9 col-md-offset-1 no-padding product-form pt-1">
                      <form className="landingCalculation">
                        <table className="table table-bordered mb-0 landing-calc">
                          <tr>
                            <th />
                            {girlsWearing &&
                              girlsWearing.grouping &&
                              girlsWearing.grouping.length &&
                              girlsWearing.grouping.map((x, i) => {
                                return <td key={i}>{x.name}</td>
                              })}
                            <td>Average</td>
                          </tr>
                          <tr>
                            <th>To Quote</th>
                            {girlsWearing &&
                              girlsWearing.toQuote &&
                              girlsWearing.toQuote.length > 0 &&
                              girlsWearing.toQuote.map((x, i) => {
                                return <td key={i}>{x}</td>
                              })}
                            <td>{girlsWearing && girlsWearing.toQuateAvg}</td>
                          </tr>
                          <tr>
                            <th>Can Quote</th>
                            {girlsWearing &&
                              girlsWearing.canQuote &&
                              girlsWearing.canQuote.length > 0 &&
                              girlsWearing.canQuote.map((x, i) => {
                                return (
                                  <td key={i}>
                                    <input
                                      className="smallInput"
                                      style={{ padding: "0 !important" }}
                                      type="number"
                                      value={x ? x : null}
                                      onChange={e => this.canQuote(e, i)}
                                    />
                                  </td>
                                )
                              })}
                            <td>{girlsWearing.canQuateAvg}</td>
                          </tr>
                          <tr>
                            <th>Agreed Price</th>
                            {girlsWearing &&
                              girlsWearing.agreedQuote &&
                              girlsWearing.agreedQuote.length > 0 &&
                              girlsWearing.agreedQuote.map((x, i) => {
                                return (
                                  <td key={i}>
                                    <input
                                      className="smallInput"
                                      style={{ padding: "0 !important" }}
                                      type="number"
                                      value={x ? x : null}
                                      onChange={e => this.agreedQuote(e, i)}
                                    />
                                  </td>
                                )
                              })}
                            <td>{costing.girlsWearing.agreedQuoteAvg}</td>
                          </tr>
                        </table>
                      </form>
                    </div>
                  </div>
                )}
              </div>
              {!this.state.disabled && <div className="col-md-12 no-padding text-center profile-btn bg-white">
                <Button
                  buttonName={"save"}
                  onClick={() => this.checkValidation()}
                />
                <Button
                  buttonName={"cancel"}
                  buttonType="cancel"
                  history={this.props.history}
                />
                {this.state.action === "edit" && (
                  <Button
                    buttonName={"Duplicate"}
                    // history={this.props.history}
                    onClick={() => this.confirmDuplicate()}
                  />
                )}
              </div>}
              {/*<!-- end of col-md-12 -->*/}
              {/*<!-- end of right-section-container -->*/}
              <div className="scroll-up pull-right scroll-hide">
                <div className="fab">
                  <span className="fab-action-button">
                    <a className="btn-floating btn-large green">
                      <i className="fa fa-bars font-for-icon-big" />
                    </a>
                  </span>
                  <ul className="fab-buttons">
                    <FloatMenuList
                      moduleList={this.state.moduleList}
                      goToDiv={this.goToDiv}
                    />
                  </ul>
                </div>
              </div>
              {/*<!-- end of col-md-12 -->*/}
              <div id="printCosting" className="d-none">
              
                {this.state.printLoading && (
                  <PrintCosting costingPrint={this.state.costingPrint} />
                )}
              </div>

              {/* Modal for Costing Start */}
              <Modal
                open={this.state.modalToggle}
                onClose={() => this.setState({ modalToggle: false })}
                center
              >
                <table className="table table-bordered">
                  <thead>
                    <tr>
                      <th>Supplier Name</th>
                      <th>Process</th>
                      <th>Width</th>
                      <th>Price</th>
                      <th>Select</th>
                    </tr>
                  </thead>
                  <tbody>
                    {this.state.supplierSectionList.map((data, index) => {
                      return (
                        <tr>
                          <td>{data.supplier}</td>
                          <td>{data.process}</td>
                          <td>{data.cuttableWidth}</td>
                          <td>{data.totalCost}</td>
                          <td>
                            <input
                              name="supplierSection"
                              type="radio"
                              className="filled-in hide-all"
                              id={"supplierSection" + index}
                              value={"supplierSection" + index}
                              checked={false}
                              onChange={() => this.selectSupplierSec(index)}
                            />
                            <label id="supplier-section-radio" for={"supplierSection" + index}></label>
                          </td>
                        </tr>
                      )
                    })}
                  </tbody>
                </table>
              </Modal>
              {/* Modal for Costing End */}
            </div>
          </div>
        </div>
        {/*<!-- end of row -->*/}
      </Fragment>
    )
  }
}
const mapStateToProps = (state) => {
  return ({
    // toggle: state.Header.toggle,
    userDetails: state.main
  });
}

const mapDispatchToProps = (dispatch) => {

  // options.filter((data) => data.moduleName == this.props.location.moduleName)

  return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(Costing)



// WEBPACK FOOTER //
// ./src/pages/Costing/page.js